import { DatePipe } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';
import { forkJoin, lastValueFrom, Subscription } from 'rxjs';
import { MarketInfoService } from 'src/app/services/MarketInfoService.service';
import { PaymentService } from 'src/app/services/paymentService.service';
import { RentalService } from 'src/app/services/Rental.service';
import { VendorService } from 'src/app/services/Vendor.service';
import { customCurrencyPipe } from 'src/app/Shared/customCurrency.pipe';
import Swal from 'sweetalert2';
import { DiscountType, EPaymentGateway } from 'src/app/Shared/enum';
import { ToastrService } from 'ngx-toastr';
import { GeneralService } from 'src/app/services/General.service';
interface DateString {
  startDate: string;
}
@Component({
  selector: 'app-booking-details',
  templateUrl: './booking-details.component.html',
  styleUrls: ['./booking-details.component.scss']
})
export class BookingDetailsComponent implements OnInit, OnDestroy {
  @Input() rentalType;
  @Input() paymentOnly;
  RentalTypeText;
  voidPayment = false;
  selectedBooths = [];
  selectedMonthlyBooths =[]
  public loaderIcon: Promise<boolean>;
  private subscriptions: Subscription[] = [];
  @Input() vendorId;
  @Input() marketId;
  processPayment = false;
  secondTaxName="";
  paymentAmount = 0;
  vendorProducts=[];
  vendorDiscountPlans=[];
  priorBalance;
  paymentGatewayCredentials;
  PromptRenewOther = false;
  processCreditCardOnline;
  verifoneId;
  masterRentChargeforResOtherItems = false;
  openConfirmationPage = false;
  creditCardAmount = 0;
  accountReceipId;
  private clickTimeout: any;
  selectedMarketDays = [];
  rentEndPeriodIndex;
  private monthEndDateCache = new Map<string, Date>();
  totalRentalCharge = 0.00;
  totalOtherRentalCharge = 0.00;
  totalSalesTax = 0.00;
  totalSecondLeveltax = 0.00
  totalCharge = 0.00;
  otherItemList = [];
  applyRenewalFee = false;
  paymentAdjustedWithPriorBal = false;
  bookingRenewalFeeId;
  renewalFeeAmount = 0;
  allowRenewalsFee = false;
  allowRenewalsFeeId;
  onlineBookingFeeAmount = 0;
  onlineBookingFeeApplied = false;
  displaySalesTax = false;
  displayCityTax = false;
  displayOtherChargeSalesTax = false;
  displayOtherChargeCityTax = false;
  savePayment = false;
  toasterConfig = {
    closeButton: true,
    timeOut: 4500,
    easing: 'ease-out',
    progressBar: true,
    positionClass: 'toast-top-right',
    tapToDismiss: true,
    showEasing: 'swing',
    hideEasing: 'linear',
    showMethod: 'fadeIn',
    hideMethod: 'slideUp'
  };
  bookingDetailsForm: FormGroup;
  isSaveDisabled: boolean = true;
  selectedOtherItems = [];
  applyCCCharge = false;
  CCFeeType = 0;
  CcfeeinPercentage;
  AllowPartialPay;
  vendorRentalDays;
  marketDayCountForResale = 0;
  actualTotalDue = 0;
  renewAllBoothsFromGrid;
  keyedInTransaction = true;
  combinedMonthlyBookingEndDate = false;
  transactionType="CREDITSALE"
  monthlyMarketDays = [];
  weeklyMarketDays =[];
  allrentedOtherItems = [];
  showDetails: boolean = false;
  ResaleNumberRequired  = false;
  DaysSellWithoutResaleNumber;
  BusinessLicenseNumberRequired  = false;
  DaysSellWithoutBusiLicNumber;
  resaleOptionSelected;
  resaleNoOption = "1";
  exemptResale = false;
  resaleNo = "";
  exemptResaleReason = "";
  applyLateFee = false;
  businessLicenseNumber;
  businessLicenseExpiryDate;
  ResaleOrBusinessHeader = "";
  resaleNoDisplay = false;
  @Output() hideTopHeaders = new EventEmitter<any>();
  @ViewChild('modalResaleNo', { static: false }) modalResaleNo: ElementRef;
  totalDiscountCharge;
  selectedWeeklyBooths=[];
  rules: any[] = [];
  allowCWRentalRenewal = false;
  allowCMRentalRenewal = false;
  allowOtherItemRenewal = false;
  FirstMondayCustomChanges: boolean = false;
  isStripeEnabled = false;
  isOpenEdgenEnabled = false;
  OtherChargesPeriod = false;
  preventVendorUncheckOtherItemRenewal = false;
  constructor(
    private formbuilder: FormBuilder,
    private route: ActivatedRoute,
    public router: Router,
    public rentalService: RentalService,
    public vendorService: VendorService,
    private customCurrency: customCurrencyPipe,
    private paymentService: PaymentService,
    private toastr: ToastrService,
    private generalService: GeneralService,
    private marketInfoService: MarketInfoService,
    private datePipe: DatePipe) {
    this.bookingDetailsForm = this.formbuilder.group({
      priorBalance: [this.customCurrency.transform('0')],
      totalCharge: [this.customCurrency.transform('0')],
      paymentAmount: [this.customCurrency.transform('0')],
      convenienceFee: [this.customCurrency.transform('0')],
      totalPayment: [this.customCurrency.transform('0')],
      balanceDue: [this.customCurrency.transform('0')],
      rentalCharge: [this.customCurrency.transform('0')],
      otherCharge: [this.customCurrency.transform('0')],
      discount: [this.customCurrency.transform('0')],
      additionalCharge: [this.customCurrency.transform('0')],
      totalSalesTax: [this.customCurrency.transform('0')],
      totalSecondLeveltax: [this.customCurrency.transform('0')],
      rules: this.formbuilder.array(this.initializeRulesArray()),
      paymentLateFee: [this.customCurrency.transform('0')]
    });

    this.subscriptions.push(
      this.bookingDetailsForm.get('totalCharge')?.valueChanges.subscribe((val) => {
        if (!this.AllowPartialPay) {
          var totalCharge = this.getActualAmountFromInp(val.toString());
          var convenienceFee = this.getActualAmountFromInp(this.bookingDetailsForm.get('convenienceFee').value);
          if (convenienceFee > 0) {
            val = totalCharge - convenienceFee;
            val = this.customCurrency.transform(val);
          }
          this.bookingDetailsForm.get('paymentAmount')?.setValue(val, { emitEvent: false });
        }
        this.calculateBalance();
      })
    );
  }

  ngOnInit(): void {
    this.getOtherRentalItems();
    const rentalTypeMapping: { [key: string]: string } = {
      '1': 'Daily',
      '4': 'Combined Monthly',
      '5': 'Combined Weekly',
      '7': 'Events'
    };

    this.rentalType = parseInt(this.rentalType);
    this.RentalTypeText = rentalTypeMapping[this.rentalType] || '';
    this.marketInfoService.setMarketId(this.marketId);
    this.getMonthlyMarketDays();
    //   this.getVendorProducts();
    this.getVendorBalances();
    this.getCCCredentials();
    this.getWebRentalSetting();
    this.getLateFeeForVendorLatePayment();
    this.getRentalPaymentSettings()
    this.getMarketRulesAndRegulations();
  }

  getLateFeeForVendorLatePayment() {
    this.loaderIcon = Promise.resolve(true);
    this.subscriptions.push(this.rentalService.getLateFeeForVendorLatePayment(this.marketId, this.vendorId).subscribe((res: any) => {
      if (res) {
        const latefee = this.customCurrency.transform(res?.LateFeeAmount);
        this.bookingDetailsForm.get('paymentLateFee').setValue(latefee)
        if (res?.LateFeeAmount > 0) {
          this.calculateBalance();
        }
      }
      this.loaderIcon = Promise.resolve(false);
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    }));
  }

  initializeRulesArray(): FormGroup[] {
    return this.rules.map(rule => this.formbuilder.group({
      isChecked: [false],  // Initialize checkbox with false
      rulesAndRegualtions: [rule.rulesAndRegualtions],
      AgreementLinkRequired: [rule.AgreementLinkRequired],
      AgreementBlobURL: [rule.AgreementBlobURL],
      AgreementLinkTextContent: [rule.AgreementLinkTextContent]
    }));
  }

  updateArrayDirectly(index: number, updatedValue: any) {
    const isChecked = (event.target as HTMLInputElement).checked;
    const control = this.rulesFormArray.at(index);
    if (control) {
      this.bookingDetailsForm.value['rules'][index].isChecked = isChecked;
    }
  }

  getMarketRulesAndRegulations() {
    this.subscriptions.push(this.generalService.getWebrentalMarketRules(this.marketId).subscribe((rules: any) => {
      if (rules) {
        const rulesArray = this.bookingDetailsForm.get('rules') as FormArray;
        rules.forEach(rule => {
          var agreementURL = this.rentalType == 1 ? rule.DailyAgreementBlobURL :
            this.rentalType == 4 ? rule.CMAgreementBlobURL :
              this.rentalType == 5 ? rule.CWAgreementBlobURL : "";

          if (!agreementURL) {
            agreementURL = rule.AgreementBlobURL ?? "";
          }

          if (!rule.AgreementLinkRequired || (rule.AgreementLinkRequired && agreementURL)) {
            rulesArray.push(this.formbuilder.group({
              id: rule.ID,
              isChecked: false,
              rulesAndRegualtions: rule.Rules,
              AgreementLinkRequired : rule.AgreementLinkRequired ?? false,
              AgreementLinkTextContent: rule.AgreementLinkTextContent ?? "",
              AgreementBlobURL: agreementURL
            }));
          }
        });
      }
    }));
  }

  allCheckboxesCheckedValidator(control: AbstractControl) {
    var allChecked = this.bookingDetailsForm.value['rules'].filter(e => !e.isChecked).length > 0 ? false : true;
    return allChecked;
  }

  get rulesFormArray() {
    return this.bookingDetailsForm.value['rules'] as FormArray;
  }

  getOtherRentalItems() {
    this.rentalService.getOtherRentalItems(this.marketId).subscribe((response) => {
      if (response) {
        response.map((el, i) => {
          const ob = {
            Id: el.OtherItemId,
            OtherItem: el.OtherItem,
            OtherItemCharge: this.rentalType == 1 ? this.customCurrency.transform(el.OtherItemCharge)
              : this.rentalType == 4 ? this.customCurrency.transform(el.OtherItemCombinedMonthlyCharge)
                : this.rentalType == 5 ? this.customCurrency.transform(el.OtherItemCombinedWeeklyCharge)
                  : "$0.00",
            Quantity: 0,
            OtherItemtotal: this.customCurrency.transform('0'),
            Recurring: el.Recurring,
            othChgBooths: "none"
          }
          this.otherItemList.push(ob);
        });
      }
    }, (err) => {
    });
  }

  getVendorProducts() {
    this.loaderIcon = Promise.resolve(true);
    const sub = this.rentalService.GetVendorProductsById(this.marketId, this.vendorId).subscribe((res: any) => {
      if (res) {
        this.vendorProducts = res.body;
        this.loaderIcon = Promise.resolve(false);
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  ClosePaymentPage(){
    this.processPayment = false;
    this.hideTopHeaders.emit(false);
  }

  getMonthlyMarketDays() {
    forkJoin({
      response: this.marketInfoService.getMonthlyMarketDays(this.marketId),
      weeklyMarket: this.marketInfoService.getWeeklyMarketDays(this.marketId),
      resRentalSettings: this.rentalService.getRentalSettings(this.marketId),
      vendorProducts: this.rentalService.GetVendorProductsById(this.marketId, this.vendorId),
      resCustomSettings: this.rentalService.getCustomSettings(this.marketId)
    }).subscribe(
      async ({ response, resRentalSettings, vendorProducts, weeklyMarket, resCustomSettings }: any) => {
        if (resCustomSettings) {
          this.FirstMondayCustomChanges = resCustomSettings.FirstMondayCustomChanges;
          this.calculateConvenienceFee();
        }
        if (response) {
          this.monthlyMarketDays = response;
        }
        if(weeklyMarket){
          this.weeklyMarketDays = weeklyMarket;
        }
        if (vendorProducts) {
          this.vendorProducts = vendorProducts.body;
        }

        if (resRentalSettings) {
          this.applyLateFee = resRentalSettings.ApplyLateFee ?? false;
          this.combinedMonthlyBookingEndDate = resRentalSettings.CombinedMonthlyBookingEndDate;
          this.OtherChargesPeriod = resRentalSettings.OtherChargesPeriod ?? false;
          if (this.combinedMonthlyBookingEndDate && this.rentalType == 4) {
            const currentDate = new Date();
            const currentYear = currentDate.getFullYear();
            const currentMonth = currentDate.getMonth();
            const currentYearMonth = `${currentYear}${(currentMonth + 1) < 10 ? '0' : ''}${(currentMonth + 1)}`;
            const currentMonthEndDate =await this.getMonthEndingDateFromSetting(currentYearMonth);
            if (currentMonthEndDate <= new Date(currentDate)) {
              var currentDateYearAndMonth = this.datePipe.transform(currentDate, 'MMMM yyyy');
              this.monthlyMarketDays = response.filter(e => e.RentalMonths != currentDateYearAndMonth)
            }
          }
        }

        // this.selectedMonthlyMarketDays();
        if (this.rentalType == 1) {
          this.getDailyRental();
          this.getDailyOtherRentals();
        }
        else if (this.rentalType == 4) {
          await this.getCombinedMonthlyRental();
          this.getCombinedMonthlyOtherRentals();
        }
        else if(this.rentalType == 5){
          this.getCombinedWeeklyRental();
          this.getCombinedWeeklyOtherRentals();
        }
        else if (this.rentalType == 7) {
          this.getEventRental();
          this.getEventOtherRental();
        }
      }, (err) => {
      });
  }

  getEventRental() {
    this.loaderIcon = Promise.resolve(true);
    this.selectedBooths = [];
    const sub = this.rentalService.getEventBookings(this.marketId, this.vendorId).subscribe((res: any[]) => {
      if (res) {
        this.selectedBooths = res.map(el => ({
          EventRentalId: el.EventRentalId,
          BoothNumber: el.BoothNumber,
          BoothType: el.BoothType,
          BoothTypeId: el.BoothTypeId,
          Product: this.vendorProducts.filter(e=>e.ProductId == el.ProductId)[0]?.ProductName,
          EventDate: this.datePipe.transform(el.DailyEventDay, "MM/dd/yyyy"),
          EventRent: this.customCurrency.transform('0'),
          SalesTax: this.customCurrency.transform('0'),
          CityTax: this.customCurrency.transform('0'),
          NewBooth: false,
          EventName: el.EventName,
          TotalEvent: el.TotalEvent,
          TotalEventDays: el.TotalEventDays.map(e => this.datePipe.transform(e, "MM/dd/yyyy")),
        }));
        this.loaderIcon = Promise.resolve(false);
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  getEventOtherRental() {
    this.loaderIcon = Promise.resolve(true);
    this.selectedOtherItems = [];
    const sub = this.rentalService.getEventOtherItemBookings(this.marketId, this.vendorId).subscribe((res: any[]) => {
      if (res) {
        res.forEach((el) => {
          const index = this.selectedOtherItems.findIndex(item => item.Id === el.OtherItemId && item.TotalEvent == el.TotalEvent && item.EventName == el.EventName && item.Reference == el.Reference && item.BoothNo == el.BoothNumber);
          if (index !== -1) {
            this.selectedOtherItems[index].Quantity += el.Quantity;
          }
          else {
            const ob = {
              Id: el.OtherItemId,
              OtherItem: el.OtherItemName,
              OtherItemCharge: this.customCurrency.transform('0'),
              Quantity: el.Quantity,
              OtherItemtotal: this.customCurrency.transform('0'),
              EventDate: this.datePipe.transform(el.DailyEventDay, "MM/dd/yyyy"),
              SalesTax: this.customCurrency.transform('0'),
              CityTax: this.customCurrency.transform('0'),
              BoothNo: el.BoothNumber,
              Reference: el.Reference,
              NewItem: false,
              EventName: el.EventName,
              TotalEvent: el.TotalEvent,
              TotalEventDays: el.TotalEventDays.map(e => this.datePipe.transform(e, "MM/dd/yyyy")),
            }
            this.selectedOtherItems.push(ob);
          }
        });
        this.loaderIcon = Promise.resolve(false);
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  getMonthIndex(monthString: string): number {
    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];
    const monthIndex = months.findIndex(month => month.toLowerCase() === monthString.toLowerCase());
    return monthIndex !== -1 ? monthIndex : 0;
  }

  getDailyOtherRentals() {
    this.loaderIcon = Promise.resolve(true);
    this.selectedOtherItems = [];
    const sub = this.rentalService.getDailyOtherRentals(this.marketId,this.vendorId).subscribe((res: any[]) => {
      if (res) {
        res.forEach((el) => {
          const index = this.selectedOtherItems.findIndex(item => item.Id === el.OtherItemId && this.datePipe.transform(item.RentalDay, 'MM/dd/yyyy') == this.datePipe.transform(el.RentalDay, 'MM/dd/yyyy') && item.Reference == el.Reference && item.BoothNo == el.BoothNumber);
          if (index !== -1) {
            this.selectedOtherItems[index].Quantity += el.Quantity;
            var otherItemTotal = (el.OtherCharge * this.selectedOtherItems[index].Quantity).toString();
            this.selectedOtherItems[index].OtherItemtotal = otherItemTotal;
          }
          else {
            var otherItemTotal = (el.OtherCharge *  el.Quantity).toString();
            const ob = {
              Id: el.OtherItemId,
              OtherItem: el.OtherItemName,
              OtherItemCharge: this.customCurrency.transform(el.OtherCharge),
              Quantity: el.Quantity,
              OtherItemtotal: this.customCurrency.transform(otherItemTotal),
              RentalDay: this.datePipe.transform(el.RentalDay, "MM/dd/YYYY"),
              SalesTax: this.customCurrency.transform(el.SalesTax),
              CityTax: this.customCurrency.transform(el.SecLevelTax),
              BoothNo: el.BoothNumber,
              Reference: el.Reference,
              NewItem: false
            }
            this.selectedOtherItems.push(ob);
          }
        });
        this.loaderIcon = Promise.resolve(false);
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  getDailyRental() {
    this.loaderIcon = Promise.resolve(true);
    this.selectedBooths = [];
    const sub = this.rentalService.getDailyRentals(this.marketId,this.vendorId).subscribe((res: any[]) => {
      if (res) {
        this.selectedBooths = res.map(el => ({
          DailyRentalId: el.DailyRentalId,
          BoothNumber: el.BoothNumber,
          BoothType: el.BoothType,
          BoothTypeId: el.BoothTypeId,
          Product: this.vendorProducts.filter(e=>e.ProductId == el.ProductId)[0]?.ProductName,
          RentalDay: this.datePipe.transform(el.RentalDay, "MM/dd/YYYY"),
          Rent: this.customCurrency.transform(el.RentalCharge),
          SalesTax: this.customCurrency.transform(el.SalesTax),
          CityTax: this.customCurrency.transform(el.SecLevelTax),
          NewBooth: false
        }));
        this.loaderIcon = Promise.resolve(false);
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  getVendorBalances() {
    this.rentalService.getVendorBalances(this.vendorId, this.marketId).subscribe((res: any) => {
      if (res) {
        this.priorBalance = res.PriorBalance;
        this.actualTotalDue = res.PriorBalance;
        this.bookingDetailsForm.patchValue({
          priorBalance: this.customCurrency.transform(this.priorBalance),
          totalCharge: this.customCurrency.transform(this.priorBalance)
        });
      }
    });
  }

  getMonthEndDate(inputDate: Date): Date {
    const nextMonthFirstDay = new Date(inputDate);
    nextMonthFirstDay.setMonth(nextMonthFirstDay.getMonth() + 1, 1);
    const monthEndDate = new Date(nextMonthFirstDay);
    monthEndDate.setDate(monthEndDate.getDate() - 1);
    return monthEndDate;
  }

  toggleDetails(index: number) {
    this.selectedMonthlyBooths[index].showDetails = !this.selectedMonthlyBooths[index].showDetails;
  }

  toggleCMOtherItemsDetails(index: number) {
    this.selectedOtherItems[index].showOtherItemsDetails = !this.selectedOtherItems[index].showOtherItemsDetails;
  }

  toggleCWBookingDetails(index: number) {
    this.selectedWeeklyBooths[index].showDetails = !this.selectedWeeklyBooths[index].showDetails;
  }

  async getCombinedMonthlyRental(): Promise<any> {
    this.loaderIcon = Promise.resolve(true);
    this.selectedMonthlyBooths = [];
    var existingBooths = [];
    const sub = this.rentalService.getCombinedMonthlyBookings(this.marketId,this.vendorId).subscribe(async (res: any[]) => {
      if (res) {
        existingBooths = res;
        for(const el of existingBooths)
        {
          const StartDateList = [];
          var initialStartDate;
          var marketDays = 0;
          var marketDay;
          const today: Date = new Date(new Date().toDateString());
          var startDate = new Date(el.RentalStartDate);
          var endDate = new Date(el.RentalEndDate);
          var endDateYearMonth;
          if (el.Status == "R" && startDate < today) {
            startDate = today;
            initialStartDate = startDate;
            endDate = this.getMonthEndDate(startDate);

            if (this.combinedMonthlyBookingEndDate  && this.rentalType == 4) {
              const rentalEndDateYear = endDate.getFullYear();
              const rentalEndDateMonth = endDate.getMonth() + 1;
              const rentalEndDateYearMonth = `${rentalEndDateYear}${rentalEndDateMonth < 10 ? '0' : ''}${rentalEndDateMonth}`;
              endDate = await this.getMonthEndingDateFromSetting(rentalEndDateYearMonth);
              endDateYearMonth = rentalEndDateYearMonth;

              const rentalStartDate = new Date(startDate);
              var previousMonth = new Date(rentalStartDate.setMonth(rentalStartDate.getMonth() - 1)).getMonth() + 1;
              var PreviousMonthYear = new Date(rentalStartDate.setMonth(rentalStartDate.getMonth() - 1)).getFullYear();
              const PreviousMonthYearAndMonth = `${PreviousMonthYear}${previousMonth < 10 ? '0' : ''}${previousMonth}`;
              // if (PreviousMonthYearAndMonth >= currentYearMonth) {
              const monthEndDate = await this.getMonthEndingDateFromSetting(PreviousMonthYearAndMonth);
              const dateDiff = this.getDaysDifference(monthEndDate, new Date(startDate)); //calculates the diff between current month start date and previous monthend date
              if (dateDiff <= 7 && new Date(monthEndDate) < startDate) {
                if (new Date() > new Date(monthEndDate)) {
                  startDate = new Date();
                }
                else {
                  startDate = new Date(monthEndDate.setDate(monthEndDate.getDate() + 1));
                }
              }

              if (new Date(endDate) < new Date(startDate)) {
                const rentalStartDate = new Date(startDate);
                var nextMonth = new Date(rentalStartDate.setMonth(rentalStartDate.getMonth() + 1)).getMonth() + 1;
                var nextMonthYear = new Date(rentalStartDate.setMonth(rentalStartDate.getMonth() + 1)).getFullYear();
                const nextMonthYearAndMonth = `${nextMonthYear}${nextMonth < 10 ? '0' : ''}${nextMonth}`;
                endDate = await this.getMonthEndingDateFromSetting(nextMonthYearAndMonth);
              }
              // }
            }
          }

          if (!this.selectedMarketDays || this.selectedMarketDays.length == 0) {
            var response = await this.marketInfoService.getMarketDays(this.marketId).toPromise();
            if (response) {
              response.Sunday ? this.selectedMarketDays.push(1) : 0;
              response.Monday ? this.selectedMarketDays.push(2) : 0;
              response.Tuesday ? this.selectedMarketDays.push(3) : 0;
              response.Wednesday ? this.selectedMarketDays.push(4) : 0;
              response.Thursday ? this.selectedMarketDays.push(5) : 0;
              response.Friday ? this.selectedMarketDays.push(6) : 0;
              response.Saturday ? this.selectedMarketDays.push(6) : 0;
            }
          }
          for (const date of this.selectedMarketDays) {
            const selectedDayOfWeek = date - 1;
            marketDay = this.datePipe.transform(el.RentalStartDate, 'EEE');
            let currentDay = new Date(startDate);
            while (currentDay <= endDate) {
              if (currentDay.getDay() === selectedDayOfWeek) {
                marketDays += 1;
                StartDateList.push({ startDate: this.datePipe.transform(new Date(currentDay), 'MMM d, y') });
              }

              if (this.datePipe.transform(currentDay, 'MM/dd/yyyy') == this.datePipe.transform(endDate, 'MM/dd/yyyy')) {
                if (StartDateList && StartDateList.length == 0) {
                  endDate.setDate(endDate.getDate() + 1);
                  endDate = this.getMonthEndDate(endDate);
                }
              }
              currentDay.setDate(currentDay.getDate() + 1);
            }
          }
          const compareDates = (a: DateString, b: DateString): number => {
            const dateA = new Date(a.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
            const dateB = new Date(b.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
            return dateA - dateB;
          };

          const sortedDates = StartDateList.sort(compareDates);

          if (el.Status == "R") {
            if (initialStartDate <= today) {
              el.RentalStartDate = StartDateList[0].startDate
              el.RentalEndDate = StartDateList[StartDateList.length - 1].startDate;
            }
          }

          const rentEndPeriodIndex = this.monthlyMarketDays.findIndex(e => e.RentalMonths == this.datePipe.transform(el.RentalEndDate, 'MMMM yyyy'));
          var renewalStartMonth = "";
          if (this.monthlyMarketDays.length > 1) {
            renewalStartMonth = this.monthlyMarketDays.length > rentEndPeriodIndex + 1 ? this.monthlyMarketDays[rentEndPeriodIndex + 1].RentalMonths :
              this.monthlyMarketDays[this.monthlyMarketDays.length - 1].RentalMonths
          }
          if (el.Status == "R") {
            renewalStartMonth = this.monthlyMarketDays[rentEndPeriodIndex].RentalMonths
            var obj = {
              BoothTypeId: el.BoothTypeId,
              VendorId: this.vendorId,
              RentalStartPeriod: new Date(el.RentalStartDate),
              RentalEndPeriod: new Date(el.RentalEndDate)
            }
            const res = await this.rentalService.getBoothRentalCombinedMonthlyCharges(this.marketId,obj).toPromise();
            if(res){
              const ob = {
                MonthlyRentalId: el.MonthlyRentalId,
                BoothNumber: el.BoothNumber,
                BoothType: el.BoothType,
                BoothTypeId: el.BoothTypeId,
                RentalStartDate: this.datePipe.transform(el.RentalStartDate, 'MMM d, y'),
                RentalEndDate: this.datePipe.transform(el.RentalEndDate, 'MMM d, y'),
                RentalSavedEndDate: this.datePipe.transform(el.RentalStartDate, 'MMM d, y'),
                RentStartPeriod: this.datePipe.transform(el.RentalStartDate, 'MMMM yyyy'),
                RentEndPeriod: this.datePipe.transform(el.RentalEndDate, 'MMMM yyyy'),
                Product: el.ProductId,
                ProductName: this.vendorProducts.filter(e=>e.ProductId == el.ProductId)[0]?.ProductName,
                StartDateList: StartDateList,
                MktDays: marketDays,
                PerDiemRent: this.customCurrency.transform('0.00'),
                Rent: this.customCurrency.transform(res.Rent),
                SalesTax: this.customCurrency.transform(res.SalesTax),
                CityTax: this.customCurrency.transform(res.CityTax),
                CurrentRentStartPeriod: this.datePipe.transform(el.RentalStartDate, 'MMMM yyyy'),
                CurrentRentEndPeriod: this.datePipe.transform(el.RentalEndDate, 'MMMM yyyy'),
                CurrentRent: this.customCurrency.transform(el.RentalCharge),
                CurrentSalesTax: this.customCurrency.transform(el.SalesTax),
                CurrentSecondTax: this.customCurrency.transform(el.SecLevelTax),
                Sunday: el.Sunday,
                Monday: el.Monday,
                Tuesday: el.Tuesday,
                Wednesday: el.Wednesday,
                Thursday: el.Thursday,
                Friday: el.Friday,
                Saturday: el.Saturday,
                Reservation: el.BoothReserved,
                Drop: el.DoNotRenew,
                January: this.customCurrency.transform(res.JanRent),
                February: this.customCurrency.transform(res.FebRent),
                March: this.customCurrency.transform(res.MarRent),
                April: this.customCurrency.transform(res.AprRent),
                May: this.customCurrency.transform(res.MayRent),
                June: this.customCurrency.transform(res.JunRent),
                July: this.customCurrency.transform(res.JulRent),
                August: this.customCurrency.transform(res.AugRent),
                September: this.customCurrency.transform(res.SepRent),
                October: this.customCurrency.transform(res.OctRent),
                November: this.customCurrency.transform(res.NovRent),
                December: this.customCurrency.transform(res.DecRent),
                JanuaryMonthPresent: res.JanuaryMonthPresent,
                FebruaryMonthPresent: res.FebruaryMonthPresent,
                MarchMonthPresent: res.MarchMonthPresent,
                AprilMonthPresent: res.AprilMonthPresent,
                MayMonthPresent: res.MayMonthPresent,
                JuneMonthPresent: res.JuneMonthPresent,
                JulyMonthPresent: res.JulyMonthPresent,
                AugustMonthPresent: res.AugustMonthPresent,
                SeptemberMonthPresent: res.SeptemberMonthPresent,
                OctoberMonthPresent: res.OctoberMonthPresent,
                NovemberMonthPresent: res.NovemberMonthPresent,
                DecemberMonthPresent: res.DecemberMonthPresent,
                DisableJanMonth: res.JanRent ? false : true,
                DisableFebMonth: res.FebRent ? false : true,
                DisableMarMonth: res.MarRent ? false : true,
                DisableAprMonth: res.AprRent ? false : true,
                DisableMayMonth: res.MayRent ? false : true,
                DisableJunMonth: res.JunRent ? false : true,
                DisableJulMonth: res.JulRent ? false : true,
                DisableAugMonth: res.AugRent ? false : true,
                DisableSepMonth: res.SepRent ? false : true,
                DisableOctMonth: res.OctRent ? false : true,
                DisableNovMonth: res.NovRent ? false : true,
                DisableDecMonth: res.DecRent ? false : true,
                DiasbleStartDate: false,
                Status: el.Status,
                NewBooth: false,
                ExtendRental: true,
                BookingCanExtend: true,
                AllRentalDates:StartDateList.map(el => new Date(el.startDate)),
                RenewalStartMonth: renewalStartMonth,
                CMRenewalMonth: this.monthlyMarketDays[rentEndPeriodIndex].RentalMonths,
                RentEndPeriodIndex:rentEndPeriodIndex
              }
              if (this.allowCMRentalRenewal) {
                this.totalRentalCharge += this.getActualAmountFromInp(res.Rent);
                this.totalSalesTax += this.getActualAmountFromInp(res.SalesTax);
                this.totalSecondLeveltax += this.getActualAmountFromInp(res.CityTax);
                this.totalCharge = this.priorBalance + this.totalRentalCharge + this.totalOtherRentalCharge + this.totalSalesTax + this.totalSecondLeveltax;
                this.setRentalCharges();
              }
              this.selectedMonthlyBooths.push(ob);
            };
          }
          else {
            var rentalStartPeriod;
            if (this.combinedMonthlyBookingEndDate && this.rentalType == 4) {
              let rentalStartDate = new Date(el.RentalStartDate);
              var startMonth = rentalStartDate.getMonth() + 1;
              var startYear = rentalStartDate.getFullYear();
              const startYearAndMonth = `${startYear}${startMonth < 10 ? '0' : ''}${startMonth}`;
              const rentalMonthEndDate = await this.getMonthEndingDateFromSetting(startYearAndMonth);

              if (new Date(el.RentalStartDate) > rentalMonthEndDate) {
                rentalStartDate = new Date(el.RentalStartDate);
                const dayOfMonth = rentalStartDate.getDate();
                rentalStartDate.setMonth(rentalStartDate.getMonth() + 1);

                if (rentalStartDate.getDate() < dayOfMonth) {
                  rentalStartDate.setDate(0); // Set to the last day of the previous month
                }
                rentalStartPeriod = this.datePipe.transform(rentalStartDate, 'MMMM yyyy');
              }
              else{
                rentalStartPeriod = this.datePipe.transform(el.RentalStartDate, 'MMMM yyyy');
              }
            }
            else{
              rentalStartPeriod = this.datePipe.transform(el.RentalStartDate, 'MMMM yyyy');
            }

            const ob = {
              MonthlyRentalId: el.MonthlyRentalId,
              BoothNumber: el.BoothNumber,
              BoothType: el.BoothType,
              BoothTypeId: el.BoothTypeId,
              RentalStartDate: this.datePipe.transform(el.RentalStartDate, 'MMM d, y'),
              RentalEndDate: this.datePipe.transform(el.RentalEndDate, 'MMM d, y'),
              RentalSavedEndDate: this.datePipe.transform(el.RentalEndDate, 'MMM d, y'),
              RentStartPeriod:rentalStartPeriod,
              RentEndPeriod: this.datePipe.transform(el.RentalEndDate, 'MMMM yyyy'),
              Product: el.ProductId,
              ProductName: this.vendorProducts.filter(e=>e.ProductId == el.ProductId)[0]?.ProductName,
              StartDateList: StartDateList,
              MktDays: marketDays,
              PerDiemRent: this.customCurrency.transform('0.00'),
              Rent: this.customCurrency.transform('0.00'),
              SalesTax: this.customCurrency.transform('0.00'),
              CityTax: this.customCurrency.transform('0.00'),
              CurrentRentStartPeriod: this.datePipe.transform(el.RentalStartDate, 'MMMM yyyy'),
              CurrentRentEndPeriod: this.datePipe.transform(el.RentalEndDate, 'MMMM yyyy'),
              CurrentRent: this.customCurrency.transform(el.RentalCharge),
              CurrentSalesTax: this.customCurrency.transform(el.SalesTax),
              CurrentSecondTax: this.customCurrency.transform(el.SecLevelTax),
              Sunday: el.Sunday,
              Monday: el.Monday,
              Tuesday: el.Tuesday,
              Wednesday: el.Wednesday,
              Thursday: el.Thursday,
              Friday: el.Friday,
              Saturday: el.Saturday,
              Reservation: el.BoothReserved,
              Drop: el.DoNotRenew,
              Status: el.Status,
              BookingCanExtend: true,
              January: this.customCurrency.transform('0.00'),
              February: this.customCurrency.transform('0.00'),
              March: this.customCurrency.transform('0.00'),
              April: this.customCurrency.transform('0.00'),
              May: this.customCurrency.transform('0.00'),
              June: this.customCurrency.transform('0.00'),
              July: this.customCurrency.transform('0.00'),
              August: this.customCurrency.transform('0.00'),
              September: this.customCurrency.transform('0.00'),
              October: this.customCurrency.transform('0.00'),
              November: this.customCurrency.transform('0.00'),
              December: this.customCurrency.transform('0.00'),
              JanuaryMonthPresent: el.JanuaryMonthPresent,
              FebruaryMonthPresent: el.FebruaryMonthPresent,
              MarchMonthPresent: el.MarchMonthPresent,
              AprilMonthPresent: el.AprilMonthPresent,
              MayMonthPresent: el.MayMonthPresent,
              JuneMonthPresent: el.JuneMonthPresent,
              JulyMonthPresent: el.JulyMonthPresent,
              AugustMonthPresent: el.AugustMonthPresent,
              SeptemberMonthPresent: el.SeptemberMonthPresent,
              OctoberMonthPresent: el.OctoberMonthPresent,
              NovemberMonthPresent: el.NovemberMonthPresent,
              DecemberMonthPresent: el.DecemberMonthPresent,
              DisableJanMonth: true,
              DisableFebMonth: true,
              DisableMarMonth: true,
              DisableAprMonth: true,
              DisableMayMonth: true,
              DisableJunMonth: true,
              DisableJulMonth: true,
              DisableAugMonth: true,
              DisableSepMonth: true,
              DisableOctMonth: true,
              DisableNovMonth: true,
              DisableDecMonth: true,
              DiasbleStartDate: true,
              NewBooth: false,
              AllRentalDates:StartDateList.map(el => new Date(el.startDate)),
              RenewalStartMonth: renewalStartMonth,
              CMRenewalMonth: this.monthlyMarketDays.length > rentEndPeriodIndex + 1 ? this.monthlyMarketDays[rentEndPeriodIndex +1].RentalMonths :"",
              RentEndPeriodIndex:rentEndPeriodIndex
            }
            this.selectedMonthlyBooths.push(ob);
          }
        };

        this.applyRentalRenewalAvailability();
        await this.handleCMEndDateChange();
        this.loaderIcon = Promise.resolve(false);
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  isAnyRenewalSelected(): boolean {
    const monthlyRenewal = this.selectedMonthlyBooths?.some(b => b.Reservation) ?? false;
    const weeklyRenewal = this.selectedWeeklyBooths?.some(b => b.Reservation) ?? false;
    return monthlyRenewal || weeklyRenewal;
  }

  updateRentalRecord(record) {
    if (record.Reservation && this.allowCMRentalRenewal) {
      const rentEndPeriodIndex = this.monthlyMarketDays.findIndex(e => e.RentalMonths == record.RentEndPeriod);
      const renewalStartMonth = this.monthlyMarketDays[rentEndPeriodIndex +1].RentalMonths
      record.BookingCanExtend = true;
      record.RenewalStartMonth =renewalStartMonth
      record.CMRenewalMonth = renewalStartMonth;
      record.RentEndPeriodIndex =rentEndPeriodIndex
      this.extendCMRental(record);
    }
    else{
      record.BookingCanExtend = false;
      record.RenewalStartMonth = "This booking cannot be extended further!";
      record.CMRenewalMonth = record.RentalMonth;
      record.RentEndPeriod = record.CurrentRentEndPeriod;
      this.totalRentalCharge -= this.getActualAmountFromInp(record.Rent);
      this.totalSalesTax -= this.getActualAmountFromInp(record.SalesTax);
      this.totalSecondLeveltax -= this.getActualAmountFromInp(record.CityTax);
      this.setRentalCharges();
      record.Rent = this.customCurrency.transform("0");
      record.CityTax = this.customCurrency.transform("0");
    }
  }

  getDaysDifference(date1: Date, date2: Date): number {
    // Normalize both dates to start of the day (midnight)
    const start = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
    const end = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
    // Calculate the difference in time (milliseconds)
    const timeDiff = Math.abs(end.getTime() - start.getTime());
    // Convert time difference from milliseconds to days
    const dayDiff = Math.ceil(timeDiff / (1000 * 3600 * 24));
    return dayDiff;
  }

  async handleCMEndDateChange() {
    this.loaderIcon = Promise.resolve(true);
    this.renewAllBoothsFromGrid = false;
    if (this.selectedMonthlyBooths.length === 0) {
      await this.renewAllBooths();
      this.loaderIcon = Promise.resolve(false);
      return;
    }

    this.renewAllBoothsFromGrid = true;
    let rentalDates: any[] = [];
    let noResale = true;
    this.vendorRentalDays = [];
    this.marketDayCountForResale = 0;

    if ((this.ResaleNumberRequired && !this.exemptResale) || this.BusinessLicenseNumberRequired) {
      await this.processSelectedBooths(rentalDates);

      for (const item of this.selectedMonthlyBooths) {
        if (this.shouldProcessBooth(item)) {
          await this.processBoothRentalDates(item, rentalDates);
        }
      }

      this.updateVendorRentalDays(rentalDates);

      const vendorRentalDaysObj = { VendorID: this.vendorId, VendorRentalDate: new Date() };
      const vendorRentalDaysRes = await this.rentalService.getVendorRentalDays(vendorRentalDaysObj).toPromise();

      if (this.marketDayCountForResale <= this.DaysSellWithoutResaleNumber ||
        this.marketDayCountForResale <= this.DaysSellWithoutBusiLicNumber) {
        this.addVendorRentalDays(vendorRentalDaysRes);
      }

      await this.checkResaleOrBusinessLicense(noResale);
      this.loaderIcon = Promise.resolve(false);
    } else {
      await this.renewAllBooths();
    }
  }

  async extendCMOtherRental(item: any) {
    this.loaderIcon = Promise.resolve(true);
    const currentMonth = new Date(item.RenewalStartMonth);

    if (currentMonth > new Date(item.CMRenewalMonth) || !item.Recurring || !this.allowOtherItemRenewal) {
      item.BookingCanExtend = false;
      item.RenewalStartMonth = "This booking cannot be extended further!";
      item.CMRenewalMonth = item.RentalMonth;
      this.loaderIcon = Promise.resolve(false);
      return;
    }

    this.totalOtherRentalCharge -= this.getActualAmountFromInp(item.OtherItemtotal);
    this.totalSalesTax -= this.getActualAmountFromInp(item.SalesTax);
    this.totalSecondLeveltax -= this.getActualAmountFromInp(item.CityTax);
    this.setRentalCharges();
    item.OtherItemtotal = this.customCurrency.transform("0");


    const monthsToProcess: { rentalStartMonth: string; otherItemCharge: string }[] = [];
    // Defensive: ensure dates are valid
    const renewalEnd = item.CMRenewalMonth ? new Date(item.CMRenewalMonth) : null;
    if (!renewalEnd || isNaN(renewalEnd.getTime())) {
      console.error('Invalid CMRenewalMonth:', item.CMRenewalMonth);
      this.loaderIcon = Promise.resolve(false);
      return;
    }

    const tempMonth = new Date(currentMonth);

    // Helper for robust composite key
    const makeCompositeKey = (obj: any) => [
      obj.RentalMonth,
      obj.Id,
      obj.Reference,
      encodeURIComponent(obj.BoothNo || obj.BoothNumber || "")
    ].join('|');

    // Defensive: YearMonth validation helper
    const isValidYearMonth = (val: string) => {
      // Accepts YYYY-MM or MM/YYYY or similar
      return val && /^(\d{4}-\d{2}|\d{2}\/\d{4})$/.test(val.trim());
    };

    while (tempMonth <= renewalEnd) {

      const formatted = this.datePipe.transform(new Date(tempMonth), 'MM/dd/yyyy');
      tempMonth.setMonth(tempMonth.getMonth() + 1);
      const rentalMonthDate = this.monthlyMarketDays.find(date =>
        this.datePipe.transform(new Date(date.RentalMonths), 'MM/dd/yyyy') === formatted
      );
      if (!rentalMonthDate) continue;

      const rentalStartMonth = rentalMonthDate.RentalMonths;
      // Defensive: skip if rentalStartMonth is falsy
      if (!rentalStartMonth) continue;

      // Use robust composite key for deduplication
      const recordExist = this.selectedOtherItems.findIndex(e =>
        makeCompositeKey(e) === makeCompositeKey({
          RentalMonth: rentalStartMonth,
          Id: item.Id,
          Reference: item.Reference,
          BoothNo: item.BoothNo
        })
      );

      let otherItemCharge = this.otherItemList.find(e => e.Id == item.Id)?.OtherItemCharge;
      if (!this.masterRentChargeforResOtherItems && this.allrentedOtherItems.length > 0) {
        otherItemCharge = this.customCurrency.transform(
          this.allrentedOtherItems.find(e => e.OtherItemId == item.Id)?.OtherCharge
        );
      }

      let chargeResolved = true;
      if (this.OtherChargesPeriod) {
        const date = new Date(`${rentalStartMonth} 1`);
        const formattedDate = this.datePipe.transform(`${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`, 'MM/dd/yyyy');
        const companyOtherRentalId = this.otherItemList.find(e => e.OtherItem == item.OtherItem)?.CompanyOtherRentalId;
        if (companyOtherRentalId != null) {
          try {
            const response = await this.rentalService.getOtherRentalItems(this.marketId, formattedDate).toPromise();
            if (response) {
              const matchedItem = response.find(e => e.OtherItemCompanyId == companyOtherRentalId);
              if (matchedItem) {
                otherItemCharge = this.customCurrency.transform(matchedItem.OtherItemCombinedMonthlyCharge);
              } else {
                console.warn('No matching other rental item found for companyOtherRentalId:', companyOtherRentalId);
                chargeResolved = false;
              }
            }
          } catch (err) {
            console.error('Error fetching other rental items for period:', err);
            chargeResolved = false;
          }
        }
      }

      // Fallback logic: if chargeResolved is false, use original charge and log
      if (!chargeResolved) {
        console.warn(`Falling back to original charge for month ${rentalStartMonth}, item ${item.Id}`);
        // Already set above from otherItemList/allrentedOtherItems
      }
      monthsToProcess.push({ rentalStartMonth, otherItemCharge });
    }

    if (monthsToProcess.length === 0) {
      this.loaderIcon = Promise.resolve(false);
      return;
    }

    const requests = monthsToProcess.map(({ otherItemCharge }) => {
      const isNegative = otherItemCharge.includes('(') && otherItemCharge.includes(')');
      const rawCharge = parseFloat(otherItemCharge.replace(/[^0-9.-]/g, ''));
      const finalCharge = isNegative ? -rawCharge : rawCharge;

      return {
        obj: {
          MarketId: this.marketId,
          OtherItemId: item.Id,
          VendorId: this.vendorId,
          Quantity: item.Quantity,
          OtherItemCharge: finalCharge
        },
        finalCharge,
        otherItemCharge
      };
    });

    const results = await Promise.all(
      requests.map(({ obj }) =>
        lastValueFrom(this.rentalService.getOtherItemsRentalCharges(obj))
      )
    );

    let totalCharge = 0;
    let totalSalesTax = 0;
    let totalCityTax = 0;

    results.forEach((res: any, index) => {
      const { finalCharge, otherItemCharge } = requests[index];

      item.OtherItemCharge = this.customCurrency.transform(finalCharge.toString());
      item.OtherItemtotal = this.customCurrency.transform(
        (parseFloat(item.OtherItemtotal.replace(/[^0-9.-]/g, '')) + (finalCharge * item.Quantity)).toString()
      );
      item.MonthlyRentalIds += ',' + item.Id;
      item.CMRenewalMonth = item.CMRenewalMonth;

      totalCharge += this.getActualAmountFromInp(item.OtherItemCharge);
      totalSalesTax += this.getActualAmountFromInp(res.SalesTax);
      totalCityTax += this.getActualAmountFromInp(res.CityTax);
      this.loaderIcon = Promise.resolve(false);
    });

    this.totalOtherRentalCharge += totalCharge;
    this.totalSalesTax += totalSalesTax;
    this.totalSecondLeveltax += totalCityTax;
    this.setRentalCharges();
  }

  renewCMOtherCharges() {
    if (this.selectedOtherItems.length > 0) {
      this.proceedRenewingOtherCharges();
    }
  }

  extendCWOtherRental(item) {
    var cuurentWeek = new Date(item.RentalWeek.split('-')[1]);
    this.totalOtherRentalCharge -= this.getActualAmountFromInp(item.OtherItemtotal);
    this.totalSalesTax += this.getActualAmountFromInp(item.SalesTax);
    this.totalSecondLeveltax += this.getActualAmountFromInp(item.CityTax);
    this.totalCharge = this.priorBalance + this.totalRentalCharge + this.totalOtherRentalCharge + this.totalSalesTax + this.totalSecondLeveltax;
    item.OtherItemtotal = this.customCurrency.transform("0");
    if (cuurentWeek < new Date(item.CWRenewalWeek.split('-')[1]) && item.Recurring && this.allowOtherItemRenewal) {
      while (cuurentWeek < new Date(item.CWRenewalWeek.split('-')[1]) && item.Recurring && this.allowOtherItemRenewal) {
        var nextDate = this.addDays(new Date(cuurentWeek), 7);
        var rentalWeekDate = this.weeklyMarketDays.filter(date => this.datePipe.transform(new Date(date.RentalEndDays.split('-')[0]), 'MM/dd/yyyy') <= this.datePipe.transform(new Date(nextDate), 'MM/dd/yyyy')
          && this.datePipe.transform(new Date(date.RentalEndDays.split('-')[1]), 'MM/dd/yyyy') >= this.datePipe.transform(new Date(nextDate), 'MM/dd/yyyy'))
        if (rentalWeekDate.length > 0)
          var rentalStartWeek = rentalWeekDate[0].RentalStartDays;
        cuurentWeek = new Date(rentalStartWeek.split('-')[1]);
        var otherItemCharge = this.otherItemList.filter(e => e.Id == item.Id)[0].OtherItemCharge;
        if (!this.masterRentChargeforResOtherItems && this.allrentedOtherItems.length > 0) {
          otherItemCharge = this.customCurrency.transform(this.allrentedOtherItems.filter(e => e.OtherItemId == item.Id)[0].OtherCharge);
        }
        var obj = {
          MarketId: this.marketId,
          OtherItemId: item.Id,
          VendorId: this.vendorId,
          Quantity: item.Quantity,
          OtherItemCharge: this.getActualAmountFromInp(otherItemCharge)
        }

        this.rentalService.getOtherItemsRentalCharges(obj).subscribe((res: any) => {
          const isNegative = otherItemCharge.includes('(') && otherItemCharge.includes(')');
          const totalValue = parseFloat(otherItemCharge.replace(/[^0-9.-]/g, ''));
          const finalCharge = isNegative ? -totalValue : totalValue;
          item.OtherItemtotal = this.customCurrency.transform((parseFloat(item.OtherItemtotal.replace(/[^0-9.-]/g, '')) + (finalCharge * item.Quantity)).toString());
          item.Quantity = item.Quantity;
          item.OtherItemCharge = otherItemCharge;
          item.MonthlyRentalIds += ',' + item.Id
          item.CWRenewalWeek = rentalStartWeek;

          this.totalOtherRentalCharge += this.getActualAmountFromInp(item.OtherItemCharge);
          this.totalSalesTax += this.getActualAmountFromInp(res.SalesTax);
          this.totalSecondLeveltax += this.getActualAmountFromInp(res.CityTax);
          this.totalCharge = this.priorBalance + this.totalRentalCharge + this.totalOtherRentalCharge + this.totalSalesTax + this.totalSecondLeveltax;
          this.bookingDetailsForm.patchValue({
            otherCharge: this.customCurrency.transform(this.totalOtherRentalCharge.toString()),
            totalSalesTax: this.customCurrency.transform(this.totalSalesTax.toString()),
            totalSecondLeveltax: this.customCurrency.transform(this.totalSecondLeveltax.toString()),
            totalCharge: this.customCurrency.transform(this.totalCharge.toString())
          });
        });
      }
    }
    else {
      item.BookingCanExtend = false;
      item.RenewalStartMonth = "This booking cannot be extended further!";
      item.CWRenewalWeek = item.CurrentRentalWeek;
    }
  }

  getDateFromDateTime(date){
    return new Date(date.getFullYear(), date.getMonth(), date.getDate());
  }

  async proceedRenewingOtherCharges() {
    for (const item of this.selectedOtherItems) {
      const endMonth = new Date(item.CMRenewalMonth);
      const currentMonth = new Date(item.RentalMonth);
      if (item.Status != "R") {
        if (this.getDateFromDateTime(currentMonth) <= this.getDateFromDateTime(new Date(item.CMRenewalMonth)) && item.Recurring && this.allowOtherItemRenewal) {
          var nextDate = currentMonth.setMonth(currentMonth.getMonth() + 1);
          var rentalMonthDate = this.monthlyMarketDays.filter(date => this.datePipe.transform(new Date(date.RentalMonths), 'MM/dd/yyyy') <= this.datePipe.transform(new Date(nextDate), 'MM/dd/yyyy')
            && this.datePipe.transform(new Date(date.RentalMonths), 'MM/dd/yyyy') >= this.datePipe.transform(new Date(nextDate), 'MM/dd/yyyy'))
          if (rentalMonthDate.length > 0)
            var rentalEndMonth = rentalMonthDate[0].RentalMonths;
          var recordExist = this.selectedOtherItems.findIndex(e => e.RentalMonth == rentalEndMonth && e.Id == item.Id && e.Reference == item.Reference && e.BoothNo == item.BoothNo)
          if (recordExist == -1) {
            var otherItemCharge = this.otherItemList.filter(e => e.Id == item.Id)[0].OtherItemCharge;
            if (!this.masterRentChargeforResOtherItems && this.allrentedOtherItems.length > 0) {
              otherItemCharge = this.customCurrency.transform(this.allrentedOtherItems.filter(e => e.OtherItemId == item.Id)[0].OtherCharge);
            }

            let periodChargeResolved = true;
            if (this.OtherChargesPeriod) {
              const date = new Date(`${rentalEndMonth} 1`);
              const formattedDate = this.datePipe.transform(`${date.getMonth() + 1}/${date.getDate()}/${date.getFullYear()}`, 'MM/dd/yyyy');
              const companyOtherRentalId = this.otherItemList.find(e => e.OtherItem == item.OtherItem)?.CompanyOtherRentalId;
              if (companyOtherRentalId != null) {
                try {
                  const response = await this.rentalService.getOtherRentalItems(this.marketId, formattedDate).toPromise();
                  if (response) {
                    const matchedItem = response.find(e => e.OtherItemCompanyId == companyOtherRentalId);
                    if (matchedItem) {
                      otherItemCharge = this.customCurrency.transform(matchedItem.OtherItemCombinedMonthlyCharge);
                    } else {
                      console.warn('No matching other rental item found for companyOtherRentalId:', companyOtherRentalId);
                      periodChargeResolved = false;
                    }
                  }
                } catch (err) {
                  console.error('Error fetching other rental items for period:', err);
                  periodChargeResolved = false;
                }
              }
            }
            if (!periodChargeResolved) continue;

            var obj = {
              MarketId: this.marketId,
              OtherItemId: item.Id,
              VendorId: this.vendorId,
              Quantity: item.Quantity,
              OtherItemCharge: this.getActualAmountFromInp(otherItemCharge)
            }

            var res = await this.rentalService.getOtherItemsRentalCharges(obj).toPromise();
            const isNegative = otherItemCharge.includes('(') && otherItemCharge.includes(')');
            const totalValue = parseFloat(otherItemCharge.replace(/[^0-9.-]/g, ''));
            const finalCharge = isNegative ? -totalValue : totalValue;
            const OtherItemtotal = this.customCurrency.transform((finalCharge * item.Quantity).toString());
            item.Quantity = item.Quantity;
            item.MonthlyRentalIds += ',' + item.Id
            item.OtherItemCharge = otherItemCharge
            item.OtherItemtotal = OtherItemtotal;
            item.CMRenewalMonth = rentalEndMonth;

            this.totalOtherRentalCharge += this.getActualAmountFromInp(item.OtherItemtotal);
            this.totalSalesTax += this.getActualAmountFromInp(res.SalesTax);
            this.totalSecondLeveltax += this.getActualAmountFromInp(res.CityTax);
            this.setRentalCharges();
          }
        }
        else {
          item.BookingCanExtend = false;
          item.RenewalStartMonth = "This booking cannot be extended further!";
          item.CMRenewalMonth = item.RentalMonth;
        }
      }
    }
  }

  // Helper functions
  // Process selected booths for rental dates
  async processSelectedBooths(rentalDates: any[]) {
    const selectedBoothRecord = this.selectedMonthlyBooths.filter(e => e.NewBooth || e.ExtendRental);
    for (const record of selectedBoothRecord) {
      for (const el of this.selectedMarketDays) {
        this.addRentalDates(record, rentalDates, el - 1);
      }
    }
  }

  // Check if the booth should be processed
  shouldProcessBooth(item: any): boolean {
    return new Date(item.RentEndPeriod.split('-')[0]) < new Date(item.CMRenewalMonth) &&
      !item.Drop && item.Reservation;
  }

  // Process rental dates for a booth
  async processBoothRentalDates(item: any, rentalDates: any[]) {
    const recordExist = this.selectedMonthlyBooths.findIndex(e =>
      e.RentStartPeriod === item.RentStartPeriod && e.RentEndPeriod === item.RentEndPeriod &&
      e.BoothNumber === item.BoothNumber && (item.MonthlyRentalId === 0 || e.MonthlyRentalId === item.MonthlyRentalId)
    );

    if (recordExist !== -1) {
      const startDate = new Date(this.selectedMonthlyBooths[recordExist].RentalStartDate);
      let endDate = await this.calculateEndDate(item);

      // Loop through selected market days and add dates
      this.selectedMarketDays.forEach((el) => {
        this.addRentalDates({ RentalStartDate: startDate, RentalEndDate: endDate }, rentalDates, el - 1);
      });
    }
  }

  // Add rental dates based on the day of the week
  addRentalDates(record: any, rentalDates: any[], dayOfWeek: number) {
    let currentDay = new Date(record.RentalStartDate);
    const endDate = new Date(record.RentalEndDate);

    while (currentDay <= endDate) {
      if (currentDay.getDay() === dayOfWeek) {
        rentalDates.push({ startDate: this.datePipe.transform(currentDay, 'MMM d, y') });
      }
      currentDay.setDate(currentDay.getDate() + 1);
    }
  }

  // Calculate end date based on CMRenewalMonth
  async calculateEndDate(item: any): Promise<Date> {
    const [endMonthDate, endMonthYear] = item.CMRenewalMonth.split(' ');
    const endMonthIndex = this.getMonthIndex(endMonthDate);
    let endDate = new Date(endMonthYear, endMonthIndex + 1, 0);

    if (this.combinedMonthlyBookingEndDate) {
      const rentalEndDateYearMonth = `${endDate.getFullYear()}${(endDate.getMonth() + 1).toString().padStart(2, '0')}`;
      endDate = await this.getMonthEndingDateFromSetting(rentalEndDateYearMonth);
    }

    return endDate;
  }

  // Update vendor rental days by comparing with existing rental dates
  updateVendorRentalDays(rentalDates: any[]) {
    rentalDates.forEach(date => {
      const targetDateString = this.datePipe.transform(date.startDate, "MM/dd/yyyy");
      const dateExist = this.vendorRentalDays.some(el => {
        const rentalDateString = this.datePipe.transform(el.VendorRentalDate, "MM/dd/yyyy");
        return rentalDateString === targetDateString;
      });

      if (!dateExist) {
        const formattedDate = this.datePipe.transform(date.startDate, "MM/dd/yyyy");
        this.vendorRentalDays.push({ VendorRentalDate: formattedDate });
        this.marketDayCountForResale += 1;
      }
    });
  }

  // Add vendor rental days from API response
  addVendorRentalDays(res: any[]) {
    res.forEach(el => {
      const targetDateString = this.datePipe.transform(el.VendorRentalDate, "MM/dd/yyyy");
      const dateExist = this.vendorRentalDays.some(data => {
        const rentalDateString = this.datePipe.transform(data.VendorRentalDate, "MM/dd/yyyy");
        return rentalDateString === targetDateString;
      });

      if (!dateExist) {
        const formattedDate = this.datePipe.transform(el.VendorRentalDate, "MM/dd/yyyy");
        this.vendorRentalDays.push({ VendorRentalDate: formattedDate });
        this.marketDayCountForResale += 1;
      }
    });
  }

  // Check conditions for resale or business license
  async checkResaleOrBusinessLicense(noResale: boolean) {
    if (this.ResaleNumberRequired && !this.exemptResale && !this.resaleNo &&
      this.marketDayCountForResale > this.DaysSellWithoutResaleNumber && !this.resaleOptionSelected) {
      const modal = this.modalResaleNo.nativeElement;
      modal.classList.add('show');
      modal.style.display = 'block';
      noResale = false;
    } else if (this.BusinessLicenseNumberRequired &&
      this.marketDayCountForResale > this.DaysSellWithoutBusiLicNumber) {
      await this.handleBusinessLicenseNumber();
    } else {
      await this.renewAllBooths();
    }
  }

  async validateResaleAndBusinessLicense() {
    var addToGrid = false;
    var closeModalPopup = false;
    const modal = this.modalResaleNo.nativeElement;
    if (!this.resaleNo || this.resaleNo.trim() === '') {
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Enter the resale number`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
    }
    else {
      addToGrid = true;
      closeModalPopup = true;
      this.resaleOptionSelected = true;
      if (modal.classList.contains('show')) {
        modal.style.display = 'none';
        modal.classList.remove('show');
      }
    }
    if (addToGrid) {
      const obj = {
        VendorID: this.vendorId,
        ExemptResaleNo: false,
        ExemptResaleReason: "",
        ResaleNo: this.resaleNo,
        MarketId: this.marketId
      }

      this.subscriptions.push(this.rentalService.UpdateVendorResaleInfo(obj).subscribe((res: any) => {
      }));
    }

    if (addToGrid) {
      this.ResaleOrBusinessHeader = "Business License Number";
      if (this.BusinessLicenseNumberRequired &&
        this.marketDayCountForResale > this.DaysSellWithoutBusiLicNumber) {
        await this.handleBusinessLicenseNumber();
      }
      else{
        await this.renewAllBooths();
      }
    }
  }

  // Handle business license number validation
  async handleBusinessLicenseNumber() {
    if (!this.businessLicenseNumber) {
      this.loaderIcon = Promise.resolve(false);
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Business License is required! Please contact the market`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
      this.revertPendingMonthlyExtensions();
      return;
    } else {
      await this.checkBusinessLicenseExpiry();
    }
  }

  // Check business license expiry date
  async checkBusinessLicenseExpiry() {
    if (!this.businessLicenseExpiryDate) {
      this.loaderIcon = Promise.resolve(false);
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Business License is expired! Please contact the market`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
      this.revertPendingMonthlyExtensions();
      return;
    }

    if (new Date(this.businessLicenseExpiryDate) < new Date()) {
      this.loaderIcon = Promise.resolve(false);
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Business License is expired! Please contact the market`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
      this.revertPendingMonthlyExtensions();
      return;
    } else {
      await this.renewAllBooths();
    }
  }

  // Undo pending renewals for every CM (Monthly) booth marked for renewal,
  // used when the "renew all" bulk flow is blocked before a specific record
  // is selected (no single extendRentalRecord to target).
  private revertPendingMonthlyExtensions() {
    this.selectedMonthlyBooths
      .filter(record => record.Reservation)
      .forEach(record => {
        record.Reservation = false;
        this.updateRentalRecord(record);
      });
  }
  

  async getMonthEndingDateFromSetting(rentalYearMonth: string): Promise<Date> {
    if (this.monthEndDateCache.has(rentalYearMonth)) {
      return this.monthEndDateCache.get(rentalYearMonth);
    }
    const response = await this.rentalService.GetSelectedMonthEndDate(rentalYearMonth,this.marketId).toPromise();
    if (response) {
      const monthEndDate = new Date(response.MonthEndDateSelected);
      this.monthEndDateCache.set(rentalYearMonth, monthEndDate);
      return monthEndDate;
    }
    else {
      return null
    }
  }

  async renewAllBooths() {
    const nonAvailableBooths = [];

    for (const item of this.selectedMonthlyBooths) {
      this.loaderIcon = Promise.resolve(true);
      if (item.Status != "R") {
        const { RentEndPeriod, CMRenewalMonth, Drop, Reservation, MonthlyRentalId, BoothNumber, RentStartPeriod, Status } = item;
        const rentEndDate = new Date(RentEndPeriod.split('-')[0]);
        const renewalMonth = new Date(CMRenewalMonth);

        if (rentEndDate < renewalMonth && !Drop && Reservation && this.allowCMRentalRenewal) {
          const recordExist = this.selectedMonthlyBooths.findIndex(e =>
            e.RentStartPeriod === RentStartPeriod &&
            e.RentEndPeriod === RentEndPeriod &&
            e.BoothNumber === BoothNumber &&
            e.MonthlyRentalId === MonthlyRentalId &&
            e.Reservation && !e.Drop
          );

          if (recordExist != -1) {
            const rentalDates = [];
            var currentMonthRentalDates = [];
            var rentalstartDate = "";
            var marketDays = 0;
            this.selectedMarketDays = [];
            this.selectedMonthlyBooths[recordExist].Sunday == true ? this.selectedMarketDays.push(1) : 0;
            this.selectedMonthlyBooths[recordExist].Monday ? this.selectedMarketDays.push(2) : 0;
            this.selectedMonthlyBooths[recordExist].Tuesday == true ? this.selectedMarketDays.push(3) : 0;
            this.selectedMonthlyBooths[recordExist].Wednesday == true ? this.selectedMarketDays.push(4) : 0;
            this.selectedMonthlyBooths[recordExist].Thursday == true ? this.selectedMarketDays.push(5) : 0;
            this.selectedMonthlyBooths[recordExist].Friday == true ? this.selectedMarketDays.push(6) : 0;
            this.selectedMonthlyBooths[recordExist].Saturday == true ? this.selectedMarketDays.push(7) : 0;
            for (const el of this.selectedMarketDays) {
              var endDateYearMonth;
              var startDate = new Date(this.selectedMonthlyBooths[recordExist].RenewalStartMonth);
              const endMonth = item.CMRenewalMonth;
              const [endMonthDate, endMonthYear] = endMonth.split(' ');
              const endMonthIndex = this.getMonthIndex(endMonthDate);
              var endDate = new Date(endMonthYear, endMonthIndex + 1, 0);
              if (this.combinedMonthlyBookingEndDate) {
                const rentalEndDateYear = endDate.getFullYear();
                const rentalEndDateMonth = endDate.getMonth() + 1;
                const rentalEndDateYearMonth = `${rentalEndDateYear}${rentalEndDateMonth < 10 ? '0' : ''}${rentalEndDateMonth}`;
                endDate = await this.getMonthEndingDateFromSetting(rentalEndDateYearMonth);
                endDateYearMonth = rentalEndDateYearMonth;

                const rentalStartDate = new Date(startDate);
                var previousMonth = new Date(rentalStartDate.setMonth(rentalStartDate.getMonth() - 1)).getMonth() + 1;
                var PreviousMonthYear = new Date(rentalStartDate.setMonth(rentalStartDate.getMonth() - 1)).getFullYear();
                const PreviousMonthYearAndMonth = `${PreviousMonthYear}${previousMonth < 10 ? '0' : ''}${previousMonth}`;
                // if (PreviousMonthYearAndMonth >= currentYearMonth) {
                const monthEndDate = await this.getMonthEndingDateFromSetting(PreviousMonthYearAndMonth);
                const dateDiff = this.getDaysDifference(monthEndDate, new Date(startDate)); //calculates the diff between current month start date and previous monthend date
                if (dateDiff <= 7 && new Date(monthEndDate) < startDate) {
                  if (new Date() > new Date(monthEndDate)) {
                    startDate = new Date();
                  }
                  else {
                    startDate = new Date(monthEndDate.setDate(monthEndDate.getDate() + 1));
                  }
                }
                // }
              }
              var previousRentalYearMonth;
              var currentMonthEnd = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
              if (this.combinedMonthlyBookingEndDate) {
                const currentStartMonth = this.selectedMonthlyBooths[recordExist].RentStartPeriod;
                const [startMonthDate, startMonthYear] = currentStartMonth.split(' ');
                const startMonthIndex = this.getMonthIndex(startMonthDate);
                var currentMonthEnd = new Date(startMonthYear, startMonthIndex + 1, 0);
                const rentalEndDateYear = currentMonthEnd.getFullYear();
                const rentalEndDateMonth = currentMonthEnd.getMonth() + 1;
                const rentalEndDateYearMonth = `${rentalEndDateYear}${rentalEndDateMonth < 10 ? '0' : ''}${rentalEndDateMonth}`;
                previousRentalYearMonth = rentalEndDateYearMonth;
                if (endDateYearMonth == rentalEndDateYearMonth)
                  currentMonthEnd = await this.getMonthEndingDateFromSetting(rentalEndDateYearMonth);
              }
              const selectedDayOfWeek = el - 1
              let currentDay = new Date(startDate);
              while (currentDay <= endDate) {
                if (currentDay.getDay() === selectedDayOfWeek) {
                  if (!rentalstartDate) {
                    rentalstartDate = this.datePipe.transform(new Date(currentDay), 'MMM d, y');
                  }
                  marketDays += 1;
                  rentalDates.push({ startDate: this.datePipe.transform(new Date(currentDay), 'MMM d, y') });
                }
                currentDay.setDate(currentDay.getDate() + 1);
              }

              if (this.combinedMonthlyBookingEndDate) {
                currentDay = new Date(startDate);
                while (currentDay <= currentMonthEnd) {
                  if (currentDay.getDay() === selectedDayOfWeek) {
                    if (!rentalstartDate) {
                      rentalstartDate = this.datePipe.transform(new Date(currentDay), 'MMM d, y');
                    }
                    currentMonthRentalDates.push({ startDate: this.datePipe.transform(new Date(currentDay), 'MMM d, y') });
                  }
                  currentDay.setDate(currentDay.getDate() + 1);
                }
              }
            };

            const compareDates = (a: DateString, b: DateString): number => {
              const dateA = new Date(a.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
              const dateB = new Date(b.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
              return dateA - dateB;
            };
            const sortedDates = rentalDates.sort(compareDates);

            if (this.combinedMonthlyBookingEndDate) {
              const compareCurrentMonthDates = (a: DateString, b: DateString): number => {
                const dateA = new Date(a.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
                const dateB = new Date(b.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
                return dateA - dateB;
              };
              const currentMonthSortedDates = currentMonthRentalDates.sort(compareCurrentMonthDates);
            }
            else {
              currentMonthRentalDates = rentalDates;
            }

            var allRentalDates = rentalDates.map(el => new Date(el.startDate));
            var currentRentedEndDate = new Date(this.selectedMonthlyBooths[recordExist].RentalEndDate);
            const filteredRentalDates = allRentalDates.filter(rentalDate => rentalDate > currentRentedEndDate);
            var obj1 = {
              RentalDates: filteredRentalDates,
              BoothNumber: this.selectedMonthlyBooths[recordExist].BoothNumber
            }

            const rentalExist = await this.rentalService.checkRentalExits(this.marketId, obj1).toPromise();
            if (!rentalExist.Success) {
              await this.updateBoothRentDetails(recordExist, rentalDates, marketDays);
              this.loaderIcon = Promise.resolve(false);
            } else {
              nonAvailableBooths.push(BoothNumber);
              this.loaderIcon = Promise.resolve(false);
            }
          }
        }
        else {
          item.CMRenewalMonth = item.RentEndPeriod;
          item.RenewalStartMonth = "This booking cannot be extended further!"
          item.BookingCanExtend = false;
          nonAvailableBooths.push(item.BoothNumber);
          this.loaderIcon = Promise.resolve(false);
        }
      }
      else{
        this.loaderIcon = Promise.resolve(false);
      }
    }
  }

  private async getEndDate(CMRenewalMonth, startDate: Date) {
    const [endMonthDate, endMonthYear] = CMRenewalMonth.split(' ');
    const endMonthIndex = this.getMonthIndex(endMonthDate);
    return new Date(endMonthYear, endMonthIndex + 1, 0);
  }

  private async getPreviousMonthEndDate(startDate: Date) {
    const rentalStartDate = new Date(startDate);
    rentalStartDate.setMonth(rentalStartDate.getMonth() - 1);
    const previousMonth = rentalStartDate.getMonth() + 1;
    const previousYear = rentalStartDate.getFullYear();
    return await this.getMonthEndingDateFromSetting(`${previousYear}${previousMonth.toString().padStart(2, '0')}`);
  }

  private filterCurrentMonthDates(startDate: Date, selectedDayOfWeek: number, currentMonthRentalDates: any[]) {
    let currentDay = new Date(startDate);
    const currentMonthEnd = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
    while (currentDay <= currentMonthEnd) {
      if (currentDay.getDay() === selectedDayOfWeek) {
        currentMonthRentalDates.push({ startDate: this.datePipe.transform(new Date(currentDay), 'MMM d, y') });
      }
      currentDay.setDate(currentDay.getDate() + 1);
    }
    return currentMonthRentalDates;
  }

  private sortDates(dates: any[]): any[] {
    return dates.sort((a, b) => new Date(a.startDate).getTime() - new Date(b.startDate).getTime());
  }

  private filterDatesAfterEndDate(allRentalDates: Date[], currentRentedEndDate: string): Date[] {
    const currentEndDate = new Date(currentRentedEndDate);
    return allRentalDates.filter(date => date > currentEndDate);
  }

  private async updateBoothRentDetails(recordExist: number, rentalDates: any[], marketDays: number) {
    const { BoothTypeId, RenewalStartMonth, Status, PerDiem, Rent, SalesTax, CityTax } = this.selectedMonthlyBooths[recordExist];
    const res = await this.rentalService.getBoothRentalCombinedMonthlyCharges(this.marketId, {
      BoothTypeId,
      VendorId: this.vendorId,
      RentalStartPeriod: new Date(RenewalStartMonth),
      RentalEndPeriod: new Date(rentalDates[rentalDates.length - 1].startDate),
      PerDiemApplicable: PerDiem,
      Rent: this.parseCurrency(Rent),
      SalesTax: this.parseCurrency(SalesTax),
      CityTax: this.parseCurrency(CityTax)
    }).toPromise();

    if (res) {
      RentalEndDate: this.datePipe.transform(new Date(rentalDates[rentalDates.length - 1].startDate), 'MMM d, y'),
        this.selectedMonthlyBooths[recordExist].RentalEndDate = this.datePipe.transform(new Date(rentalDates[rentalDates.length - 1].startDate), 'MMM d, y');
      this.selectedMonthlyBooths[recordExist].MktDays = marketDays;
      this.selectedMonthlyBooths[recordExist].Rent = this.customCurrency.transform(res.Rent);
      this.selectedMonthlyBooths[recordExist].SalesTax = this.customCurrency.transform(res.SalesTax);
      this.selectedMonthlyBooths[recordExist].CityTax = this.customCurrency.transform(res.CityTax);
      this.selectedMonthlyBooths[recordExist].January = this.customCurrency.transform(res.JanRent);
      this.selectedMonthlyBooths[recordExist].February = this.customCurrency.transform(res.FebRent);
      this.selectedMonthlyBooths[recordExist].March = this.customCurrency.transform(res.MarRent);
      this.selectedMonthlyBooths[recordExist].April = this.customCurrency.transform(res.AprRent);
      this.selectedMonthlyBooths[recordExist].May = this.customCurrency.transform(res.MayRent);
      this.selectedMonthlyBooths[recordExist].June = this.customCurrency.transform(res.JunRent);
      this.selectedMonthlyBooths[recordExist].July = this.customCurrency.transform(res.JulRent);
      this.selectedMonthlyBooths[recordExist].August = this.customCurrency.transform(res.AugRent);
      this.selectedMonthlyBooths[recordExist].September = this.customCurrency.transform(res.SepRent);
      this.selectedMonthlyBooths[recordExist].October = this.customCurrency.transform(res.OctRent);
      this.selectedMonthlyBooths[recordExist].November = this.customCurrency.transform(res.NovRent);
      this.selectedMonthlyBooths[recordExist].December = this.customCurrency.transform(res.DecRent);
      this.selectedMonthlyBooths[recordExist].JanuaryMonthPresent = res.JanuaryMonthPresent;
      this.selectedMonthlyBooths[recordExist].FebruaryMonthPresent = res.FebruaryMonthPresent;
      this.selectedMonthlyBooths[recordExist].MarchMonthPresent = res.MarchMonthPresent;
      this.selectedMonthlyBooths[recordExist].AprilMonthPresent = res.AprilMonthPresent;
      this.selectedMonthlyBooths[recordExist].MayMonthPresent = res.MayMonthPresent;
      this.selectedMonthlyBooths[recordExist].JuneMonthPresent = res.JuneMonthPresent;
      this.selectedMonthlyBooths[recordExist].JulyMonthPresent = res.JulyMonthPresent;
      this.selectedMonthlyBooths[recordExist].AugustMonthPresent = res.AugustMonthPresent;
      this.selectedMonthlyBooths[recordExist].SeptemberMonthPresent = res.SeptemberMonthPresent;
      this.selectedMonthlyBooths[recordExist].OctoberMonthPresent = res.OctoberMonthPresent;
      this.selectedMonthlyBooths[recordExist].NovemberMonthPresent = res.NovemberMonthPresent;
      this.selectedMonthlyBooths[recordExist].DecemberMonthPresent = res.DecemberMonthPresent;
      this.selectedMonthlyBooths[recordExist].DisableJanMonth = res.JanRent || res.JanRent == 0 ? false : true;
      this.selectedMonthlyBooths[recordExist].DisableFebMonth = res.FebRent || res.FebRent == 0 ? false : true;
      this.selectedMonthlyBooths[recordExist].DisableMarMonth = res.MarRent || res.MarRent == 0 ? false : true;
      this.selectedMonthlyBooths[recordExist].DisableAprMonth = res.AprRent || res.AprRent == 0 ? false : true;
      this.selectedMonthlyBooths[recordExist].DisableMayMonth = res.MayRent || res.MayRent == 0 ? false : true;
      this.selectedMonthlyBooths[recordExist].DisableJunMonth = res.JunRent || res.JunRent == 0 ? false : true;
      this.selectedMonthlyBooths[recordExist].DisableJulMonth = res.JulRent || res.JulRent == 0 ? false : true;
      this.selectedMonthlyBooths[recordExist].DisableAugMonth = res.AugRent || res.AugRent == 0 ? false : true;
      this.selectedMonthlyBooths[recordExist].DisableSepMonth = res.SepRent || res.SepRent == 0 ? false : true;
      this.selectedMonthlyBooths[recordExist].DisableOctMonth = res.OctRent || res.OctRent == 0 ? false : true;
      this.selectedMonthlyBooths[recordExist].DisableNovMonth = res.NovRent || res.NovRent == 0 ? false : true;
      this.selectedMonthlyBooths[recordExist].DisableDecMonth = res.DecRent || res.DecRent == 0 ? false : true;
      this.selectedMonthlyBooths[recordExist].ExtendRental = true;
      this.selectedMonthlyBooths[recordExist].AllRentalDates =  rentalDates.map(el => new Date(el.startDate));
      this.updateTotalCharges(res.Rent, res.SalesTax, res.CityTax);
    }
  }

  private parseCurrency(value: string) {
    return value.includes('(') && value.includes(')') ? -parseFloat(value.replace(/[^0-9.-]/g, '')) : parseFloat(value.replace(/[^0-9.-]/g, ''));
  }

  private updateTotalCharges(Rent, SalesTax, CityTax) {
    this.totalRentalCharge += Rent;
    this.totalSalesTax += SalesTax;
    this.totalSecondLeveltax += CityTax;
    this.totalCharge = this.priorBalance + this.totalRentalCharge + this.totalOtherRentalCharge + this.totalSalesTax + this.totalSecondLeveltax;
    this.setRentalCharges();
  }

  getCombinedMonthlyOtherRentals() {
    this.loaderIcon = Promise.resolve(true);
    this.selectedOtherItems = [];
    const now = new Date();
    const currentYear = now.getFullYear();
    const currentMonth = now.getMonth() + 1;
    const currentYearMonth = `${currentYear}${currentMonth < 10 ? '0' : ''}${currentMonth}`;
    const pastMonthFormattedDate = this.datePipe.transform(new Date(currentYear, currentMonth - 2, 1), 'MMMM yyyy');

    const sub = this.rentalService.getCombinedMonthlyOtherRentals(this.marketId, this.vendorId).subscribe(async (res: any[]) => {
      if (res) {
        this.allrentedOtherItems = res;

        // Keep only the record with the highest YearMonth per unique key (OtherItemId + Reference + BoothNumber)
        const isValidYearMonth = (ym: string) => typeof ym === 'string' && /^\d{6}$/.test(ym);
        const allRecordsMap = new Map<string, any>();
        for (const el of res) {
          if (!isValidYearMonth(el.YearMonth)) continue;
          const key = `${el.OtherItemId}_${el.Reference}_${el.BoothNumber ?? 'none'}`;
          const existing = allRecordsMap.get(key);
          if (!existing || el.YearMonth > existing.YearMonth) {
            allRecordsMap.set(key, el);
          }
        }
        const filteredRes = Array.from(allRecordsMap.values());

        for (const el of filteredRes) {
          const boothNo = el.BoothNumber ? el.BoothNumber : "none";

          if (el.YearMonth >= currentYearMonth) {
            console.log('selectedOtherItems', this.selectedOtherItems);
            const formattedDate = this.datePipe.transform(
              new Date(parseInt(el.YearMonth.substring(0, 4)), parseInt(el.YearMonth.substring(4, 6)) - 1, 1),
              'MMMM yyyy'
            );
            const rentEndPeriodIndex = this.monthlyMarketDays.findIndex(e => e.RentalMonths == formattedDate);
            const nextIndex = rentEndPeriodIndex + 1;
            const renewalStartMonth = (rentEndPeriodIndex >= 0 && nextIndex < this.monthlyMarketDays.length)
              ? this.monthlyMarketDays[nextIndex].RentalMonths : "";

            const index = this.selectedOtherItems.findIndex(item =>
              item.Id === el.OtherItemId &&
              item.RentalMonth == formattedDate &&
              item.Reference == el.Reference &&
              item.BoothNo == boothNo &&
              item.Recurring == el.Recurring
            );
            if (index !== -1) {
              this.selectedOtherItems[index].Quantity += el.Quantity;
              this.selectedOtherItems[index].MonthlyRentalIds += ',' + el.OtherRentalId;
              this.selectedOtherItems[index].OtherItemtotal = this.customCurrency.transform((el.OtherCharge * this.selectedOtherItems[index].Quantity).toString());
            } else {
              const recordExist = this.selectedOtherItems.findIndex(e =>
                e.RentalMonth == formattedDate &&
                e.Id == el.OtherItemId &&
                e.Reference == el.Reference &&
                e.BoothNo == boothNo
              );
              const newItem = {
                Id: el.OtherItemId,
                MonthOtherRentalId: el.OtherRentalId,
                OtherItem: el.OtherItemName,
                OtherItemCharge: this.customCurrency.transform("0"),
                Quantity: el.Quantity,
                OtherItemtotal: this.customCurrency.transform("0"),
                RentalMonth: formattedDate,
                SalesTax: this.customCurrency.transform('0'),
                CityTax: this.customCurrency.transform('0'),
                CurrentRentalMonth: formattedDate,
                CurrentOtherItemtotal: this.customCurrency.transform(el.OtherCharge.toString()),
                CurrentSalesTax: this.customCurrency.transform(el.SalesTax.toString()),
                CurrentSecLevelTax: this.customCurrency.transform(el.SecLevelTax.toString()),
                BoothNo: boothNo,
                Recurring: el.Recurring,
                Reference: el.Reference,
                NewItem: false,
                MonthlyRentalIds: el.OtherRentalId.toString(),
                RenewalStartMonth: renewalStartMonth,
                CMRenewalMonth: renewalStartMonth,
                BookingCanExtend: true,
                RentEndPeriodIndex: rentEndPeriodIndex
              };
              if (recordExist == -1) {
                this.selectedOtherItems.push(newItem);
              } else {
                const existingRenewalMonth = this.selectedOtherItems[recordExist].RenewalStartMonth;
                const incomingYearMonth = renewalStartMonth ? new Date(renewalStartMonth).getTime() : 0;
                const existingYearMonth = existingRenewalMonth ? new Date(existingRenewalMonth).getTime() : 0;
                if (incomingYearMonth > existingYearMonth) {
                  this.selectedOtherItems[recordExist] = newItem;
                }
              }
            }
          } else {
            console.log('monthlyMarketDays', this.monthlyMarketDays);
            const res = await this.rentalService.getOtherItemsRentalCharges({
              MarketId: this.marketId,
              OtherItemId: el.OtherItemId,
              VendorId: this.vendorId,
              Quantity: el.Quantity,
              OtherItemCharge: el.OtherCharge
            }).toPromise();
            if (res) {
              const recordExist = this.selectedOtherItems.findIndex(e =>
                e.RentalMonth == pastMonthFormattedDate &&
                e.Id == el.OtherItemId &&
                e.Reference == el.Reference &&
                e.BoothNo == boothNo
              );
              if (recordExist == -1) {
                this.selectedOtherItems.push({
                  Id: el.OtherItemId,
                  MonthOtherRentalId: el.OtherRentalId,
                  OtherItem: el.OtherItemName,
                  OtherItemCharge: this.customCurrency.transform(el.OtherCharge),
                  Quantity: el.Quantity,
                  OtherItemtotal: this.customCurrency.transform((el.OtherCharge * el.Quantity).toString()),
                  RentalMonth: pastMonthFormattedDate,
                  SalesTax: this.customCurrency.transform(res.SalesTax.toString()),
                  CityTax: this.customCurrency.transform(res.CityTax.toString()),
                  CurrentRentalMonth: pastMonthFormattedDate,
                  CurrentOtherItemtotal: this.customCurrency.transform(el.OtherCharge.toString()),
                  CurrentSalesTax: this.customCurrency.transform(el.SalesTax.toString()),
                  CurrentSecLevelTax: this.customCurrency.transform(el.SecLevelTax.toString()),
                  BoothNo: boothNo,
                  Recurring: el.Recurring,
                  Reference: el.Reference,
                  NewItem: false,
                  MonthlyRentalIds: '',
                  Status: "R",
                  RentEndPeriodIndex: 0,
                  BookingCanExtend: true,
                  RenewalStartMonth: this.monthlyMarketDays[0].RentalMonths,
                  CMRenewalMonth: this.monthlyMarketDays[0].RentalMonths,
                });
                if (this.allowOtherItemRenewal) {
                  this.totalOtherRentalCharge += el.OtherCharge * el.Quantity;
                  this.totalSalesTax += this.getActualAmountFromInp(res.SalesTax);
                  this.totalSecondLeveltax += this.getActualAmountFromInp(res.CityTax);
                  this.setRentalCharges();
                }
              }
            }
          }
        }

        this.renewCMOtherCharges();
        this.loaderIcon = Promise.resolve(false);
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  saveRentalWithPayment() {
    this.savePayment = false;
    var creditCardAmount = this.getActualAmountFromInp(this.bookingDetailsForm.get('paymentAmount').value);
    var convenienceFee = this.getActualAmountFromInp(this.bookingDetailsForm.get('convenienceFee').value);
    const totalAmountPaid = creditCardAmount  + convenienceFee;
    if (totalAmountPaid != 0 || (totalAmountPaid == 0 && this.paymentAdjustedWithPriorBal)) {
      Swal.fire({
        title: $localize`Confirm`,
        text: $localize`Are you sure you want to proceed with the payment?`,
        icon: "question",
        showCancelButton: true,
        confirmButtonText: $localize`Yes`,
        cancelButtonText: $localize`No`,
      }).then((result) => {
        if (result.value) {
          if (this.paymentAdjustedWithPriorBal) {
            var obj = {
              PaymentSuccess: true,
              OrderId: "",
              VerifoneId: 0
            }
            this.savePayment = true;
            this.PaymentResponse(obj)
          } else {
            if (this.paymentGatewayCredentials && this.processCreditCardOnline) {
              this.processPayment = true;
              this.hideTopHeaders.emit(true);
            }
            else {
              Swal.fire({
                title: $localize`Warning`,
                text: $localize`Credit card cannot be processed.`,
                icon: "warning",
                confirmButtonText: $localize`Ok`,
              });
            }
          }
        }
      });
    }
    else {
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Please enter the payment amount!`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
    }
  }

  getCombinedWeeklyOtherRentals() {
    this.loaderIcon = Promise.resolve(true);
    this.selectedOtherItems = [];
    const weekStartDate = this.weeklyMarketDays[0].RentalStartDays.split('-')[0];
    const sub = this.rentalService.getCombinedWeeklyOtherRentals(this.marketId,this.vendorId).subscribe(async (res: any[]) => {
      if (res) {
        this.allrentedOtherItems = res;
        for (const el of res) {
          var RentalWeekRecord = this.weeklyMarketDays.filter(date => new Date(date.RentalStartDays.split('-')[0]) <= new Date(el.RentalWeekDay)
            && new Date(date.RentalStartDays.split('-')[1]) >= new Date(el.RentalWeekDay))
          if (RentalWeekRecord.length > 0)
            var RentalWeek = RentalWeekRecord[0].RentalStartDays
          const rentEndPeriodIndex = this.weeklyMarketDays.findIndex(e => e.RentalEndDays == RentalWeek);
          const renewalStartWeek = this.weeklyMarketDays.length > 1 ? this.weeklyMarketDays[rentEndPeriodIndex + 1].RentalEndDays : "";

          if (new Date(el.RentalWeekDay) >= new Date(weekStartDate)) {
            const index = this.selectedOtherItems.findIndex(item => item.Id === el.OtherItemId && item.RentalWeek == el.RentalWeek && item.Reference == el.Reference && item.BoothNo == el.BoothNumber && item.Recurring == el.Recurring);
            if (index !== -1) {
              this.selectedOtherItems[index].Quantity += el.Quantity;
              this.selectedOtherItems[index].WeeklyOtherRentalIds += ',' + el.OtherRentalId
            }
            const ob = {
              Id: el.OtherItemId,
              WeekOtherRentalId: el.OtherRentalId,
              OtherItem: el.OtherItemName,
              OtherItemCharge: this.customCurrency.transform('0'),
              Quantity: el.Quantity,
              OtherItemtotal: this.customCurrency.transform('0'),
              RentalWeek: RentalWeek,
              SalesTax: this.customCurrency.transform('0'),
              CityTax: this.customCurrency.transform('0'),
              CurrentRentalWeek: RentalWeek,
              CurrentOtherItemtotal: this.customCurrency.transform(el.OtherCharge.toString()),
              CurrentSalesTax: this.customCurrency.transform(el.SalesTax.toString()),
              CurrentSecLevelTax: this.customCurrency.transform(el.SecLevelTax.toString()),
              BoothNo: el.BoothNumber,
              Recurring: el.Recurring,
              NewItem: false,
              Reference: el.Reference,
              WeeklyOtherRentalIds: el.OtherRentalId.toString(),
              Status: "B",
              RentEndPeriodIndex: rentEndPeriodIndex,
              RenewalStartWeek: renewalStartWeek,
              CWRenewalWeek: renewalStartWeek,
              BookingCanExtend: true,
            }
            this.selectedOtherItems.push(ob);
          }
          else {
            var obj = {
              MarketId: this.marketId,
              OtherItemId: el.OtherItemId,
              VendorId: this.vendorId,
              Quantity: el.Quantity,
              OtherItemCharge: el.OtherCharge
            }

            const res = await this.rentalService.getOtherItemsRentalCharges(obj).toPromise();
            if (res) {
              const ob = {
                Id: el.OtherItemId,
                MonthOtherRentalId: el.OtherRentalId,
                OtherItem: el.OtherItemName,
                OtherItemCharge: this.customCurrency.transform(el.OtherCharge),
                Quantity: el.Quantity,
                OtherItemtotal: this.customCurrency.transform((el.OtherCharge * el.Quantity).toString()),
                RentalWeek: this.weeklyMarketDays[0].RentalStartDays,
                CurrentRentalWeek: this.weeklyMarketDays[0].RentalStartDays,
                SalesTax: this.customCurrency.transform(res.SalesTax.toString()),
                CityTax: this.customCurrency.transform(res.CityTax.toString()),
                BoothNo: el.BoothNumber ? el.BoothNumber : "none",
                Recurring: el.Recurring,
                Reference: el.Reference,
                NewItem: false,
                WeeklyOtherRentalIds: '',
                Status: "R",
                RentEndPeriodIndex: rentEndPeriodIndex,
                RenewalStartWeek: this.weeklyMarketDays[0].RentalStartDays,
                CWRenewalWeek: this.weeklyMarketDays[0].RentalStartDays,
                BookingCanExtend: true,
              }
              this.selectedOtherItems.push(ob);
              const OtherItemtotal = el.OtherCharge * el.Quantity;
              if (this.allowOtherItemRenewal) {
                this.totalOtherRentalCharge += OtherItemtotal;
                this.totalSalesTax += this.getActualAmountFromInp(res.SalesTax);
                this.totalSecondLeveltax += this.getActualAmountFromInp(res.CityTax);
                this.totalCharge = this.priorBalance + this.totalRentalCharge + this.totalOtherRentalCharge + this.totalSalesTax + this.totalSecondLeveltax;
                this.setRentalCharges();
              }
            }
          }
        }
        this.renewCWOtherCharges();
        this.loaderIcon = Promise.resolve(false);
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  getDateRange(endDate: Date): string {
    const startDate = new Date(endDate);
    startDate.setDate(endDate.getDate() - 6); // Subtract 6 days

    // Format dates as "MMM d, yyyy"
    const options: Intl.DateTimeFormatOptions = { month: 'short', day: 'numeric', year: 'numeric' };
    const startDateStr = startDate.toLocaleDateString('en-US', options);
    const endDateStr = endDate.toLocaleDateString('en-US', options);

    return `${startDateStr} - ${endDateStr}`;
  }

  private async fetchMarketDays() {
    if (!this.selectedMarketDays || this.selectedMarketDays.length === 0) {
      const response = await this.marketInfoService.getMarketDays(this.marketId).toPromise();
      if (response) {
        response.Sunday && this.selectedMarketDays.push(1);
        response.Monday && this.selectedMarketDays.push(2);
        response.Tuesday && this.selectedMarketDays.push(3);
        response.Wednesday && this.selectedMarketDays.push(4);
        response.Thursday && this.selectedMarketDays.push(5);
        response.Friday && this.selectedMarketDays.push(6);
        response.Saturday && this.selectedMarketDays.push(7);
      }
    }
  }

  private async CWRentalDateList(startDate,endDate){
    var StartDateList = [];
    for (const date of this.selectedMarketDays) {
      const selectedDayOfWeek = date - 1;
      let currentDay = new Date(startDate);
      while (currentDay <= endDate) {
        if (currentDay.getDay() === selectedDayOfWeek) {
          // marketDays += 1;
          StartDateList.push({ startDate: this.datePipe.transform(new Date(currentDay), 'MMM d, y') });
        }

        if (this.datePipe.transform(currentDay, 'MM/dd/yyyy') == this.datePipe.transform(endDate, 'MM/dd/yyyy')) {
          if (StartDateList && StartDateList.length == 0) {
            endDate.setDate(endDate.getDate() + 1);
            endDate = new Date(this.weeklyMarketDays[0].RentalEndDays.split('-')[1]);
          }
        }
        currentDay.setDate(currentDay.getDate() + 1);
      }
    }
    const compareDates = (a: DateString, b: DateString): number => {
      const dateA = new Date(a.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
      const dateB = new Date(b.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
      return dateA - dateB;
    };
    const sortedDates = StartDateList.sort(compareDates);
    return StartDateList;
  }

  getCombinedWeeklyRental() {
    this.loaderIcon = Promise.resolve(true);
    this.selectedWeeklyBooths = [];
    var existingBooths = [];
    const sub = this.rentalService.getCombinedWeeklyBookings(this.marketId,this.vendorId).subscribe(async (res: any[]) => {
      if (res) {
        existingBooths = res;
        for (const el of existingBooths) {
          var StartDateList;
          var initialStartDate;
          var marketDays = 0;
          //var marketDay;
          const today: Date = new Date(new Date().toDateString());

          var startDate = new Date(el.RentalStartDate);
          var endDate = new Date(el.RentalEndDate);
          if (el.Status == "R" && startDate < today) {
            startDate = today;
            initialStartDate = startDate;
            endDate = new Date(this.weeklyMarketDays[0].RentalEndDays.split('-')[1]);
          }
          await this.fetchMarketDays();
          StartDateList = await this.CWRentalDateList(startDate,endDate);

          if (el.Status == "R") {
            if (initialStartDate <= today) {
              el.RentalStartDate = StartDateList[0].startDate
              el.RentalEndDate = StartDateList[StartDateList.length - 1].startDate;
            }
          }

          if (el.Status == "R") {
            await this.bindCWReservations(el,StartDateList,marketDays);
          }
          else {
            var rentalStartDateRecord = this.weeklyMarketDays.filter(date => new Date(date.RentalStartDays.split('-')[0]) <= new Date(el.RentalStartDate)
              && new Date(date.RentalStartDays.split('-')[1]) >= new Date(el.RentalStartDate))
            if (rentalStartDateRecord.length > 0)
              var rentalStartDate = rentalStartDateRecord[0].RentalStartDays

            var rentalEndDateRecord = this.weeklyMarketDays.filter(date => new Date(date.RentalEndDays.split('-')[0]) <= new Date(el.RentalEndDate)
              && new Date(date.RentalEndDays.split('-')[1]) >= new Date(el.RentalEndDate))
            if (rentalEndDateRecord.length > 0)
              var rentalEndDate = rentalEndDateRecord[0].RentalEndDays

            if (!rentalEndDate) {
              rentalEndDate = this.getDateRange(new Date(rentalEndDate));
            }

            const rentEndPeriodIndex = this.weeklyMarketDays.findIndex(e=>e.RentalEndDays == rentalEndDate);
            const renewalStartWeek = this.weeklyMarketDays.length > 1 ? this.weeklyMarketDays[rentEndPeriodIndex +1].RentalEndDays : "";

            if (rentalStartDate && rentalEndDate) {
              var month = this.datePipe.transform(el.RentalEndDate, 'MMM');
              const monthMap: Record<string, string> = {
                jan: "JanuaryMonthPresent",
                feb: "FebruaryMonthPresent",
                mar: "MarchMonthPresent",
                apr: "AprilMonthPresent",
                may: "MayMonthPresent",
                jun: "JuneMonthPresent",
                jul: "JulyMonthPresent",
                aug: "AugustMonthPresent",
                sep: "SeptemberMonthPresent",
                oct: "OctoberMonthPresent",
                nov: "NovemberMonthPresent",
                dec: "DecemberMonthPresent"
              };

              // Initialize month presence variables dynamically
              const monthPresence: Record<string, boolean> = {};
              Object.keys(monthMap).forEach(key => monthPresence[monthMap[key]] = false);

              // Set the correct month to true
              if (monthMap[month.toLowerCase()]) {
                monthPresence[monthMap[month.toLowerCase()]] = true;
              }

              // Create an object with dynamic month fields
              const months = [
                "January", "February", "March", "April", "May", "June",
                "July", "August", "September", "October", "November", "December"
              ];

              const monthValues = months.reduce((acc, month) => {
                acc[month] = this.customCurrency.transform('0.00');
                acc[`Disable${month.slice(0, 3)}Month`] = true;
                return acc;
              }, {} as Record<string, any>);

              const ob = {
                WeeklyRentalId: el.WeeklyRentalId,
                BoothNumber: el.BoothNumber,
                BoothType: el.BoothType,
                BoothTypeId: el.BoothTypeId,
                RentStartPeriod: rentalStartDate,
                RentEndPeriod: rentalEndDate,
                RentalStartDate: this.datePipe.transform(new Date(el.RentalStartDate), 'MMM d, y'),
                RentalEndDate: this.datePipe.transform(new Date(el.RentalEndDate), 'MMM d, y'),
                RentalSavedEndDate: this.datePipe.transform(el.RentalEndDate, 'MMM d, y'),
                Product: el.ProductId,
                ProductName: this.vendorProducts.find(e => e.ProductId == el.ProductId)?.ProductName,
                MktDays: marketDays,
                PerDiemRent: this.customCurrency.transform('0.00'),
                StartDateList: StartDateList,
                Rent: this.customCurrency.transform(el.RentalCharge),
                SalesTax: this.customCurrency.transform(el.SalesTax),
                CityTax: this.customCurrency.transform(el.SecLevelTax),
                CurrentRentStartPeriod: this.weeklyMarketDays[0].RentalEndDays,
                CurrentRentEndPeriod: this.weeklyMarketDays[0].RentalEndDays,
                CurrentRent: this.customCurrency.transform(el.RentalCharge),
                CurrentSalesTax: this.customCurrency.transform(el.SalesTax),
                CurrentSecondTax: this.customCurrency.transform(el.SecLevelTax),
                Sunday: el.Sunday,
                Monday: el.Monday,
                Tuesday: el.Tuesday,
                Wednesday: el.Wednesday,
                Thursday: el.Thursday,
                Friday: el.Friday,
                Saturday: el.Saturday,
                Reservation: el.BoothReserved,
                Drop: el.DoNotRenew,
                NewBooth: false,
                ...monthPresence,
                ...monthValues, // Replaces `Object.fromEntries()`
                DisableStartDate: true,
                BookingCanExtend: true,
                RenewalStartWeek: renewalStartWeek,
                CWRenewalWeek: this.weeklyMarketDays.length > 1 ? this.weeklyMarketDays[rentEndPeriodIndex + 1].RentalEndDays : "",
                RentEndPeriodIndex: rentEndPeriodIndex,
                BlockRenewal: false
              };
              this.selectedWeeklyBooths.push(ob);

            }
          }
        }   
        
        this.applyRentalRenewalAvailability();
        this.loaderIcon = Promise.resolve(false);
        this.handleCWEndDateChange();
      }
    }, err => {
      this.loaderIcon = Promise.resolve(false);
    });
    this.subscriptions.push(sub);
  }

  async bindCWReservations(el,StartDateList,marketDays){
    var obj = {
      BoothTypeId: el.BoothTypeId,
      VendorId: this.vendorId,
      RentalStartPeriod: new Date(this.weeklyMarketDays[0].RentalEndDays.split('-')[0]),
      RentalEndPeriod: new Date(this.weeklyMarketDays[0].RentalEndDays.split('-')[1]),
    }
    var res = await this.rentalService.getBoothRentalCombinedWeeklyCharges(this.marketId,obj).toPromise();
    if(res){
      var rentalStartDateRecord = this.weeklyMarketDays.filter(date => this.datePipe.transform(new Date(date.RentalStartDays.split('-')[0]), 'MM/dd/yyyy') <= this.datePipe.transform(new Date(el.RentalStartDate), 'MM/dd/yyyy')
        && this.datePipe.transform(new Date(date.RentalStartDays.split('-')[1]), 'MM/dd/yyyy') >= this.datePipe.transform(new Date(el.RentalStartDate), 'MM/dd/yyyy'))
      if (rentalStartDateRecord.length > 0)
        var rentalStartDate = rentalStartDateRecord[0].RentalStartDays

      var rentalEndDateRecord = this.weeklyMarketDays.filter(date => this.datePipe.transform(new Date(date.RentalEndDays.split('-')[0]), 'MM/dd/yyyy') <= this.datePipe.transform(new Date(el.RentalEndDate), 'MM/dd/yyyy')
        && this.datePipe.transform(new Date(date.RentalEndDays.split('-')[1]), 'MM/dd/yyyy') >= this.datePipe.transform(new Date(el.RentalEndDate), 'MM/dd/yyyy'))
      if (rentalEndDateRecord.length > 0)
        var rentalEndDate = rentalEndDateRecord[0].RentalEndDays

      const rentEndPeriodIndex = this.weeklyMarketDays.findIndex(e=>e.RentalEndDays == rentalEndDate);
      const renewalStartWeek = this.weeklyMarketDays[rentEndPeriodIndex].RentalEndDays;

      const ob = {
        WeeklyRentalId: el.WeeklyRentalId,
        BoothNumber: el.BoothNumber,
        BoothType: el.BoothType,
        BoothTypeId: el.BoothTypeId,
        RentStartPeriod: rentalStartDate,
        RentEndPeriod: rentalEndDate,
        RentalStartDate: this.datePipe.transform(new Date(el.RentalStartDate), 'MMM d, y'),
        RentalEndDate: this.datePipe.transform(new Date(el.RentalEndDate), 'MMM d, y'),
        RentalSavedEndDate: this.datePipe.transform(el.RentalEndDate, 'MMM d, y'),
        Product: el.ProductId,
        ProductName: this.vendorProducts.filter(e=>e.ProductId == el.ProductId)[0]?.ProductName,
        StartDateList: StartDateList,
        MktDays: marketDays,
        PerDiemRent: this.customCurrency.transform('0.00'),
        Rent: this.customCurrency.transform(res.Rent),
        SalesTax: this.customCurrency.transform(res.SalesTax),
        CityTax: this.customCurrency.transform(res.CityTax),
        CurrentRentStartPeriod: this.weeklyMarketDays[0].RentalEndDays,
        CurrentRentEndPeriod: this.weeklyMarketDays[0].RentalEndDays,
        CurrentRent: this.customCurrency.transform(el.RentalCharge),
        CurrentSalesTax: this.customCurrency.transform(el.SalesTax),
        CurrentSecondTax: this.customCurrency.transform(el.SecLevelTax),
        Sunday: el.Sunday,
        Monday: el.Monday,
        Tuesday: el.Tuesday,
        Wednesday: el.Wednesday,
        Thursday: el.Thursday,
        Friday: el.Friday,
        Saturday: el.Saturday,
        Reservation: el.BoothReserved,
        Drop: el.DoNotRenew,
        January: this.customCurrency.transform(res.JanRent),
        February: this.customCurrency.transform(res.FebRent),
        March: this.customCurrency.transform(res.MarRent),
        April: this.customCurrency.transform(res.AprRent),
        May: this.customCurrency.transform(res.MayRent),
        June: this.customCurrency.transform(res.JunRent),
        July: this.customCurrency.transform(res.JulRent),
        August: this.customCurrency.transform(res.AugRent),
        September: this.customCurrency.transform(res.SepRent),
        October: this.customCurrency.transform(res.OctRent),
        November: this.customCurrency.transform(res.NovRent),
        December: this.customCurrency.transform(res.DecRent),
        JanuaryMonthPresent: res.JanuaryMonthPresent,
        FebruaryMonthPresent: res.FebruaryMonthPresent,
        MarchMonthPresent: res.MarchMonthPresent,
        AprilMonthPresent: res.AprilMonthPresent,
        MayMonthPresent: res.MayMonthPresent,
        JuneMonthPresent: res.JuneMonthPresent,
        JulyMonthPresent: res.JulyMonthPresent,
        AugustMonthPresent: res.AugustMonthPresent,
        SeptemberMonthPresent: res.SeptemberMonthPresent,
        OctoberMonthPresent: res.OctoberMonthPresent,
        NovemberMonthPresent: res.NovemberMonthPresent,
        DecemberMonthPresent: res.DecemberMonthPresent,
        DisableJanMonth: res.JanRent ? false : true,
        DisableFebMonth: res.FebRent ? false : true,
        DisableMarMonth: res.MarRent ? false : true,
        DisableAprMonth: res.AprRent ? false : true,
        DisableMayMonth: res.MayRent ? false : true,
        DisableJunMonth: res.JunRent ? false : true,
        DisableJulMonth: res.JulRent ? false : true,
        DisableAugMonth: res.AugRent ? false : true,
        DisableSepMonth: res.SepRent ? false : true,
        DisableOctMonth: res.OctRent ? false : true,
        DisableNovMonth: res.NovRent ? false : true,
        DisableDecMonth: res.DecRent ? false : true,
        DisableStartDate: false,
        Status: el.Status,
        NewBooth: false,
        BookingCanExtend: true,
        RenewalStartWeek:renewalStartWeek,
        CWRenewalWeek: this.weeklyMarketDays[rentEndPeriodIndex].RentalEndDays,
        RentEndPeriodIndex:rentEndPeriodIndex,
        BlockRenewal: false
      }
      if (this.allowCWRentalRenewal) {
        this.totalRentalCharge += this.getActualAmountFromInp(res.Rent);
        this.totalSalesTax += this.getActualAmountFromInp(res.SalesTax);
        this.totalSecondLeveltax += this.getActualAmountFromInp(res.CityTax);
        this.totalCharge = this.priorBalance + this.totalRentalCharge + this.totalOtherRentalCharge + this.totalSalesTax + this.totalSecondLeveltax;
        this.bookingDetailsForm.patchValue({
          rentalCharge: this.customCurrency.transform(this.totalRentalCharge.toString()),
          totalSalesTax: this.customCurrency.transform(this.totalSalesTax.toString()),
          totalSecondLeveltax: this.customCurrency.transform(this.totalSecondLeveltax.toString()),
          totalCharge: this.customCurrency.transform(this.totalCharge.toString())
        });
      }
      this.selectedWeeklyBooths.push(ob);
    };
  }

  PaymentResponse(response) {
    this.loaderIcon = Promise.resolve(true);
    if (response.PaymentSuccess) {
      this.verifoneId = response.VerifoneId;
      var convenienceFee = this.getActualAmountFromInp(this.bookingDetailsForm.get('convenienceFee').value);
      var rentalCharge = this.getActualAmountFromInp(this.bookingDetailsForm.get('rentalCharge').value);
      var OtherCharge = this.getActualAmountFromInp(this.bookingDetailsForm.get('otherCharge').value);

      if (rentalCharge == 0 && OtherCharge == 0) { this.paymentOnly = true }
      //if (convenienceFee > 0 && this.paymentOnly) {
      //  this.paymentOnly = false;
      //}
      switch (this.rentalType) {
        case 1:
          var obj = {
            VendorId: this.vendorId,
            PaymentOrderId: response.OrderId,
            RentalCharge: this.getActualAmountFromInp(this.bookingDetailsForm.get('rentalCharge').value),
            SalesTax: this.getActualAmountFromInp(this.bookingDetailsForm.get('totalSalesTax').value),
            SecLevelTax: this.getActualAmountFromInp(this.bookingDetailsForm.get('totalSecondLeveltax').value),
            OtherCharge: this.getActualAmountFromInp(this.bookingDetailsForm.get('otherCharge').value),
            PriorBalance: this.getActualAmountFromInp(this.bookingDetailsForm.get('priorBalance').value),
            TotalBalanceDue: this.getActualAmountFromInp(this.bookingDetailsForm.get('balanceDue').value),
            RentalNotes: "",
            CashAmount: 0,
            CheckAmount: 0,
            CheckNo: "",
            ChangeAmount: 0,
            CardAmount: this.getActualAmountFromInp(this.bookingDetailsForm.get('paymentAmount').value),
            DirectDebitAmount: 0,
            CardType: "",
            PaymentDone: true,
            WebRentalRequest: true,
            PaymentDueDate: null,
            VerifoneId: response.VerifoneId,
            DiscountAmount: this.getActualAmountFromInp(this.bookingDetailsForm.get('discount').value),
            ConvenienceFee: this.getActualAmountFromInp(this.bookingDetailsForm.get('convenienceFee').value),
            BookingFee: this.getActualAmountFromInp(this.bookingDetailsForm.get('additionalCharge').value),
            DailyRentalBooth: [],
            DailyRentalOtherCharges: [],
            AppliedDiscountModel: [],
            LateFeeAmount : this.getActualAmountFromInp(this.bookingDetailsForm.get('paymentLateFee').value ?? 0)
          }

          var objSelectedBooth = [];
          if (this.selectedBooths.length > 0) {
            this.selectedBooths.forEach((item) => {
              if (item.NewBooth) {
                objSelectedBooth.push({
                  DailyRentalId: item.DailyRentalId,
                  BoothNumber: item.BoothNumber,
                  BoothTypeId: item.BoothTypeId,
                  ProductId: item.Product,
                  BoothType: item.BoothType,
                  RentalDay: new Date(item.RentalDay),
                  RentalCharge: this.getActualAmountFromInp(item.Rent),
                  SalesTax: this.getActualAmountFromInp(item.SalesTax),
                  SecLevelTax: this.getActualAmountFromInp(item.CityTax),
                })
              }
            });
          }

          var objSelectedOtherCharge = [];
          if (this.selectedOtherItems.length > 0) {
            this.selectedOtherItems.forEach((item) => {
              if (item.NewItem) {
                objSelectedOtherCharge.push({
                  OtherItemId: item.Id,
                  OtherItemName: item.OtherItem,
                  OtherItemCharge: this.getActualAmountFromInp(item.OtherItemtotal),
                  Quantity: item.Quantity,
                  RentalDay: new Date(item.RentalDay),
                  BoothNumber: item.BoothNo,
                  OtherCharge: this.getActualAmountFromInp(item.OtherItemCharge),
                  SalesTax: this.getActualAmountFromInp(item.SalesTax),
                  SecLevelTax: this.getActualAmountFromInp(item.CityTax),
                  Reference: item.Reference
                })
              }
            });
          }

          if (objSelectedBooth.length > 0)
            obj.DailyRentalBooth = objSelectedBooth;

          if (objSelectedOtherCharge.length > 0)
            obj.DailyRentalOtherCharges = objSelectedOtherCharge;

          const sub = this.rentalService.SaveDailyRental(obj).subscribe(async (res: any) => {
            if (res.Success) {
              this.accountReceipId = res.Id;
              this.toastr.success($localize`Transaction saved successfully`, $localize`Success`, this.toasterConfig);
              this.processPayment = false;
              this.openConfirmationPage = true;
            } else {
              this.toastr.error($localize`Error occurred while saving the rental transaction`, $localize`Error`, this.toasterConfig);
              if (this.verifoneId) {
                this.voidPayment = true;
              }
            }
            this.loaderIcon = Promise.resolve(false);
          }, (err) => {
            this.toastr.error($localize`Error occurred while saving the rental transaction`, $localize`Error`, this.toasterConfig);
            // const url = 'ops/vendors/details/' + this.vendorId + '/3';
            // this.router.navigate([url]);

            this.loaderIcon = Promise.resolve(false);
          });

          this.subscriptions.push(sub);
          break;

        case 4:
          var objCM = {
            VendorId: this.vendorId,
            PaymentOrderId: response.OrderId,
            RentalCharge: this.getActualAmountFromInp(this.bookingDetailsForm.get('rentalCharge').value),
            SalesTax: this.getActualAmountFromInp(this.bookingDetailsForm.get('totalSalesTax').value),
            SecLevelTax: this.getActualAmountFromInp(this.bookingDetailsForm.get('totalSecondLeveltax').value),
            OtherCharge: this.getActualAmountFromInp(this.bookingDetailsForm.get('otherCharge').value),
            PriorBalance: this.getActualAmountFromInp(this.bookingDetailsForm.get('priorBalance').value),
            TotalBalanceDue: this.getActualAmountFromInp(this.bookingDetailsForm.get('balanceDue').value),
            RentalNotes: "",
            CashAmount: 0,
            CheckAmount: 0,
            CheckNo: "",
            ChangeAmount: 0,
            CardAmount: this.getActualAmountFromInp(this.bookingDetailsForm.get('paymentAmount').value),
            DirectDebitAmount: 0,
            CardType: "",
            PaymentDone: true,
            WebRentalRequest: true,
            PaymentDueDate: null,
            VerifoneId: response.VerifoneId,
            DiscountAmount: this.getActualAmountFromInp(this.bookingDetailsForm.get('discount').value),
            ConvenienceFee: this.getActualAmountFromInp(this.bookingDetailsForm.get('convenienceFee').value),
            BookingFee: this.getActualAmountFromInp(this.bookingDetailsForm.get('additionalCharge').value),
            MonthlyRentalBooth: [],
            MonthlyOtherRentalCharges: [],
            AppliedDiscountModel: [],
            LateFeeAmount : this.getActualAmountFromInp(this.bookingDetailsForm.get('paymentLateFee').value ?? 0)
          }

          var objSelectedBooth = [];
          if (this.selectedMonthlyBooths.length > 0) {
            this.selectedMonthlyBooths.forEach((item, i) => {
              const rentalStartDateYear = new Date(item.RentalEndDate).getFullYear();
              const rentalStartDateMonth = new Date(item.RentalEndDate).getMonth() + 1;
              const rentalStartDateYearMonth = `${rentalStartDateYear}${rentalStartDateMonth < 10 ? '0' : ''}${rentalStartDateMonth}`;
              if (item.Reservation) {
                objSelectedBooth.push({
                  MonthlyRentalId: item.MonthlyRentalId,
                  BoothNumber: item.BoothNumber,
                  BoothTypeId: item.BoothTypeId,
                  ProductId: item.Product,
                  BoothType: item.BoothType,
                  RentalStartDate: new Date(item.RentalStartDate),
                  RentalEndDate: new Date(item.RentalEndDate),
                  RentalYearMonth: rentalStartDateYearMonth,
                  BoothReserved: item.Reservation,
                  DoNotRenew: item.Drop,
                  PerDiem: item.PerDiem,
                  PerdiemRent: this.getActualAmountFromInp(item.PerDiemRent),
                  Monday: item.Monday,
                  Tuesday: item.Tuesday,
                  Wednesday: item.Wednesday,
                  Thursday: item.Thursday,
                  Friday: item.Friday,
                  Saturday: item.Saturday,
                  Sunday: item.Sunday,
                  RentalCharge: this.getActualAmountFromInp(item.Rent),
                  SalesTax: this.getActualAmountFromInp(item.SalesTax),
                  SecLevelTax: this.getActualAmountFromInp(item.CityTax),
                  JanRent: item.January ? this.getActualAmountFromInp(item.January) : 0,
                  FebRent: item.February ? this.getActualAmountFromInp(item.February) : 0,
                  MarRent: item.March ? this.getActualAmountFromInp(item.March) : 0,
                  AprRent: item.April ? this.getActualAmountFromInp(item.April) : 0,
                  MayRent: item.May ? this.getActualAmountFromInp(item.May) : 0,
                  JunRent: item.June ? this.getActualAmountFromInp(item.June) : 0,
                  JulRent: item.July ? this.getActualAmountFromInp(item.July) : 0,
                  AugRent: item.August ? this.getActualAmountFromInp(item.August) : 0,
                  SepRent: item.September ? this.getActualAmountFromInp(item.September) : 0,
                  OctRent: item.October ? this.getActualAmountFromInp(item.October) : 0,
                  NovRent: item.November ? this.getActualAmountFromInp(item.November) : 0,
                  DecRent: item.December ? this.getActualAmountFromInp(item.December) : 0,
                  BookingLog: i + 1,
                  AllRentalDates: item.AllRentalDates
                });
              }
            });
          }

          if (objSelectedBooth.length > 0)
            objCM.MonthlyRentalBooth = objSelectedBooth;

          var objSelectedOtherCharge = [];
          if (this.selectedOtherItems.length > 0) {
            this.selectedOtherItems.forEach((item) => {
              const otherRentalYear = new Date(item.CMRenewalMonth.split('-')[0]).getFullYear();
              const otherRentalMonth = new Date(item.CMRenewalMonth.split('-')[0]).getMonth() + 1;
              const otherRentalYearMonth = `${otherRentalYear}${otherRentalMonth <
                10 ? '0' : ''}${otherRentalMonth}`;

              if (item.Recurring && this.allowOtherItemRenewal && item.BookingCanExtend) {
                objSelectedOtherCharge.push({
                  OtherItemId: item.Id,
                  MonthOtherRentalId: item.MonthOtherRentalId,
                  OtherItemName: item.OtherItem,
                  OtherItemCharge: this.getActualAmountFromInp(item.OtherItemtotal),
                  Quantity: item.Quantity,
                  YearMonth: otherRentalYearMonth,
                  BoothNumber: item.BoothNo,
                  Recurring: item.Recurring,
                  OtherCharge: this.getActualAmountFromInp(item.OtherItemCharge),
                  SalesTax: this.getActualAmountFromInp(item.SalesTax),
                  SecLevelTax: this.getActualAmountFromInp(item.CityTax),
                  Reference: item.Reference
                })
              }
            });
          }
          if (objSelectedOtherCharge.length > 0)
            objCM.MonthlyOtherRentalCharges = objSelectedOtherCharge;

          if (this.allowRenewalsFee && this.allowRenewalsFeeId && this.onlineBookingFeeApplied) {
            const now = new Date();
            const nowYearMonth = `${now.getFullYear()}${(now.getMonth() + 1) < 10 ? '0' : ''}${now.getMonth() + 1}`;
            const feeAmount = this.getActualAmountFromInp(this.onlineBookingFeeAmount);
            objCM.MonthlyOtherRentalCharges = [...(objCM.MonthlyOtherRentalCharges || []), {
              OtherItemId: this.allowRenewalsFeeId,
              MonthOtherRentalId: 0,
              OtherItemName: "Online Booking Fee",
              OtherItemCharge: feeAmount,
              Quantity: 1,
              YearMonth: nowYearMonth,
              BoothNumber: "none",
              Recurring: false,
              OtherCharge: feeAmount,
              SalesTax: 0,
              SecLevelTax: 0,
              Reference: null
            }];
          }

          var objDiscountData = [];
          if (this.vendorDiscountPlans.length > 0 && this.totalDiscountCharge > 0) {
            this.vendorDiscountPlans.forEach((item) => {
              if (item.CheckAll) {
                objDiscountData.push({
                  PlanId: item.PlanSeqId,
                  DiscountAmount: this.getActualAmountFromInp(item.AppliedDiscount),
                  OtherCharges: item.OtherItems,
                  SalesTax: item.SalesTaxApplied,
                  SecondLevelTax: item.SecondLevelTaxApplied,
                  DiscountType: item.DiscountType == DiscountType.Percentage ? "0" : "1",
                  DiscountValue: item.DiscountValue,
                  SalesTaxAmount: this.getActualAmountFromInp(item.SalesTaxAmount),
                  SecondLevelTaxAmount: this.getActualAmountFromInp(item.SecondLevelTaxAmount)
                })
              }
            });
          }
          if (objDiscountData.length > 0)
            objCM.AppliedDiscountModel = objDiscountData;

          const subCM = this.rentalService.SaveCombinedMonthlyRentalTransactions(objCM).subscribe(async (res: any) => {
            if (res.Success) {
              this.accountReceipId = res.Id;
              this.toastr.success($localize`Transaction saved successfully`, $localize`Success`, this.toasterConfig);
              this.processPayment = false;
              this.openConfirmationPage = true;
            } else {
              this.toastr.error($localize`Error occurred while saving the rental transaction`, $localize`Error`, this.toasterConfig);
              if (this.verifoneId) {
                this.voidPayment = true;
              }
            }
            this.loaderIcon = Promise.resolve(false);
          }, (err) => {
            this.toastr.error($localize`Error occurred while saving the rental transaction`, $localize`Error`, this.toasterConfig);
            if (this.verifoneId) {
              this.voidPayment = true;
            }
            this.loaderIcon = Promise.resolve(false);
          });

          this.subscriptions.push(subCM);
          break;

        case 5:
          var objCombinedWeekly = {
            VendorId: this.vendorId,
            PaymentOrderId: response.OrderId,
            RentalCharge: this.getActualAmountFromInp(this.bookingDetailsForm.get('rentalCharge').value),
            SalesTax: this.getActualAmountFromInp(this.bookingDetailsForm.get('totalSalesTax').value),
            SecLevelTax: this.getActualAmountFromInp(this.bookingDetailsForm.get('totalSecondLeveltax').value),
            OtherCharge: this.getActualAmountFromInp(this.bookingDetailsForm.get('otherCharge').value),
            PriorBalance: this.getActualAmountFromInp(this.bookingDetailsForm.get('priorBalance').value),
            TotalBalanceDue: this.getActualAmountFromInp(this.bookingDetailsForm.get('balanceDue').value),
            RentalNotes: "",
            CashAmount: 0,
            CheckAmount: 0,
            CheckNo: "",
            ChangeAmount: 0,
            CardAmount: this.getActualAmountFromInp(this.bookingDetailsForm.get('paymentAmount').value),
            DirectDebitAmount: 0,
            CardType: "",
            PaymentDone: true,
            WebRentalRequest: true,
            PaymentDueDate: null,
            VerifoneId: response.VerifoneId,
            DiscountAmount: this.getActualAmountFromInp(this.bookingDetailsForm.get('discount').value),
            ConvenienceFee: this.getActualAmountFromInp(this.bookingDetailsForm.get('convenienceFee').value),
            BookingFee: this.getActualAmountFromInp(this.bookingDetailsForm.get('additionalCharge').value),
            CombinedWeeklyRentalBooth: [],
            WeeklyRentalOtherCharges: [],
            AppliedDiscountModel: [],
            LateFeeAmount : this.getActualAmountFromInp(this.bookingDetailsForm.get('paymentLateFee').value ?? 0)
          }

          var objSelectedBooth = [];
          if (this.selectedWeeklyBooths.length > 0) {
            this.selectedWeeklyBooths.forEach((item, i) => {
              if (item.Reservation && !item.BlockRenewal) {
                objSelectedBooth.push({
                  WeeklyRentalId: item.WeeklyRentalId,
                  BoothNumber: item.BoothNumber,
                  BoothTypeId: item.BoothTypeId,
                  ProductId: item.Product,
                  BoothType: item.BoothType,
                  RentalWeeekStartDate: new Date(item.RentStartPeriod.split('-')[0]),
                  RentalWeeekEndDate: new Date(item.CWRenewalWeek.split('-')[1]),
                  RentalStartDate: new Date(item.RentalStartDate),
                  RentalEndDate: new Date(item.RentalEndDate),
                  SelectedRentalDates: "",
                  BoothReserved: item.Reservation,
                  DoNotRenew: item.Drop,
                  PerDiem: item.PerDiem,
                  PerdiemRent: this.getActualAmountFromInp(item.PerDiemRent),
                  Monday: item.Monday,
                  Tuesday: item.Tuesday,
                  Wednesday: item.Wednesday,
                  Thursday: item.Thursday,
                  Friday: item.Friday,
                  Saturday: item.Saturday,
                  Sunday: item.Sunday,
                  RentalCharge: this.getActualAmountFromInp(item.Rent),
                  SalesTax: this.getActualAmountFromInp(item.SalesTax),
                  SecLevelTax: this.getActualAmountFromInp(item.CityTax),
                  JanRent: item.January ? this.getActualAmountFromInp(item.January) : 0,
                  FebRent: item.February ? this.getActualAmountFromInp(item.February) : 0,
                  MarRent: item.March ? this.getActualAmountFromInp(item.March) : 0,
                  AprRent: item.April ? this.getActualAmountFromInp(item.April) : 0,
                  MayRent: item.May ? this.getActualAmountFromInp(item.May) : 0,
                  JunRent: item.June ? this.getActualAmountFromInp(item.June) : 0,
                  JulRent: item.July ? this.getActualAmountFromInp(item.July) : 0,
                  AugRent: item.August ? this.getActualAmountFromInp(item.August) : 0,
                  SepRent: item.September ? this.getActualAmountFromInp(item.September) : 0,
                  OctRent: item.October ? this.getActualAmountFromInp(item.October) : 0,
                  NovRent: item.November ? this.getActualAmountFromInp(item.November) : 0,
                  DecRent: item.December ? this.getActualAmountFromInp(item.December) : 0,
                  BookingLog: i + 1
                })
              }
            });
          }

          if (objSelectedBooth.length > 0)
            objCombinedWeekly.CombinedWeeklyRentalBooth = objSelectedBooth;

          var objSelectedOtherCharge = [];
          if (this.selectedOtherItems.length > 0) {
            this.selectedOtherItems.forEach((item) => {
              if (item.Recurring && this.allowOtherItemRenewal) {
                objSelectedOtherCharge.push({
                  OtherItemId: item.Id,
                  WeekOtherRentalId: item.WeekOtherRentalId,
                  Quantity: item.Quantity,
                  OtherItemName: item.OtherItem,
                  OtherItemCharge: this.getActualAmountFromInp(item.OtherItemtotal),
                  RentalWeek: item.RentalWeek.split('-')[0],
                  BoothNumber: item.BoothNo,
                  Recurring: item.Recurring,
                  OtherCharge: this.getActualAmountFromInp(item.OtherItemCharge),
                  SalesTax: this.getActualAmountFromInp(item.SalesTax),
                  SecLevelTax: this.getActualAmountFromInp(item.CityTax),
                  Reference: item.Reference,
                  WeeklyOtherRentalIds: item.WeeklyOtherRentalIds
                })
              }
            });
          }
          if (objSelectedOtherCharge.length > 0)
            objCombinedWeekly.WeeklyRentalOtherCharges = objSelectedOtherCharge;

          if (this.allowRenewalsFee && this.allowRenewalsFeeId && this.onlineBookingFeeApplied) {
            const feeAmount = this.getActualAmountFromInp(this.onlineBookingFeeAmount);
            objCombinedWeekly.WeeklyRentalOtherCharges = [...(objCombinedWeekly.WeeklyRentalOtherCharges || []), {
              OtherItemId: this.allowRenewalsFeeId,
              WeekOtherRentalId: 0,
              Quantity: 1,
              OtherItemName: "Online Booking Fee",
              OtherItemCharge: feeAmount,
              RentalWeek: this.weeklyMarketDays?.[0]?.RentalStartDays?.split('-')?.[0],
              BoothNumber: "none",
              Recurring: false,
              OtherCharge: feeAmount,
              SalesTax: 0,
              SecLevelTax: 0,
              Reference: null,
              WeeklyOtherRentalIds: ''
            }];
          }

          var objDiscountData = [];
          if (this.vendorDiscountPlans.length > 0 && this.totalDiscountCharge > 0) {
            this.vendorDiscountPlans.forEach((item) => {
              if (item.CheckAll) {
                objDiscountData.push({
                  PlanId: item.PlanSeqId,
                  DiscountAmount: this.getActualAmountFromInp(item.AppliedDiscount),
                  OtherCharges: item.OtherItems,
                  SalesTax: item.SalesTaxApplied,
                  SecondLevelTax: item.SecondLevelTaxApplied,
                  DiscountType: item.DiscountType == DiscountType.Percentage ? "0" : "1",
                  DiscountValue: item.DiscountValue,
                  SalesTaxAmount: this.getActualAmountFromInp(item.SalesTaxAmount),
                  SecondLevelTaxAmount: this.getActualAmountFromInp(item.SecondLevelTaxAmount)
                })
              }
            });
          }
          if (objDiscountData.length > 0)
            obj.AppliedDiscountModel = objDiscountData;

          const subCW = this.rentalService.SaveCombinedWeeklyRentalTransactions(objCombinedWeekly).subscribe((res: any) => {
            if (res.Success) {
                this.accountReceipId = res.Id;
                this.toastr.success($localize`Transaction saved successfully`, $localize`Success`, this.toasterConfig);
                this.processPayment = false;
                this.openConfirmationPage = true;
              } else {
                this.toastr.error($localize`Error occurred while saving the rental transaction`, $localize`Error`, this.toasterConfig);
                if (this.verifoneId) {
                  this.voidPayment = true;
                }
              }
              this.loaderIcon = Promise.resolve(false);
          }, (err) => {
            this.toastr.error($localize`Error occurred while saving the rental transaction`, $localize`Error`, this.toasterConfig);
            if (this.verifoneId) {
              this.voidPayment = true;
            }

            this.loaderIcon = Promise.resolve(false);
          });

          this.subscriptions.push(subCW);
          break;

        case 7:
          var objEvent = {
            RentalType: 7,
            VendorId: this.vendorId,
            PaymentOrderId: response.OrderId,
            RentalCharge: this.getActualAmountFromInp(this.bookingDetailsForm.get('rentalCharge').value),
            SalesTax: 0,
            SecLevelTax: 0,
            OtherCharge: this.getActualAmountFromInp(this.bookingDetailsForm.get('otherCharge').value),
            PriorBalance: this.getActualAmountFromInp(this.bookingDetailsForm.get('priorBalance').value),
            TotalBalanceDue: this.getActualAmountFromInp(this.bookingDetailsForm.get('balanceDue').value),
            RentalNotes: "",
            CashAmount: 0,
            CheckAmount: 0,
            CheckNo: "",
            ChangeAmount: 0,
            CardAmount: this.getActualAmountFromInp(this.bookingDetailsForm.get('paymentAmount').value),
            DirectDebitAmount: 0,
            CardType: "",
            PaymentDone: true,
            WebRentalRequest: true,
            PaymentDueDate: null,
            VerifoneId: response.VerifoneId,
            DiscountAmount: this.getActualAmountFromInp(this.bookingDetailsForm.get('discount').value),
            ConvenienceFee: this.getActualAmountFromInp(this.bookingDetailsForm.get('convenienceFee').value),
            BookingFee: this.getActualAmountFromInp(this.bookingDetailsForm.get('additionalCharge').value),
            EventRentalBooth: [],
            EventRentalOtherCharges: [],
            AppliedDiscountModel: [],
          }

          this.subscriptions.push(this.rentalService.SaveEventRental(this.marketId, objEvent).subscribe(async (res: any) => {
            if (res.Success) {
              this.accountReceipId = res.Id;
              this.toastr.success($localize`Transaction saved successfully`, $localize`Success`, this.toasterConfig);
              this.processPayment = false;
              this.openConfirmationPage = true;
            } else {
              this.toastr.error($localize`Error occurred while saving the rental transaction`, $localize`Error`, this.toasterConfig);
              if (this.verifoneId) {
                this.voidPayment = true;
              }
            }
            this.loaderIcon = Promise.resolve(false);
          }, (err) => {
            this.toastr.error($localize`Error occurred while saving the rental transaction`, $localize`Error`, this.toasterConfig);
            this.loaderIcon = Promise.resolve(false);
          }));

          this.subscriptions.push(sub);
          break;
      }
    }
    else {
      this.processPayment = false;
      this.hideTopHeaders.emit(false);
      this.voidPayment = false;
      this.loaderIcon = Promise.resolve(false);
    }
  }

  voidPaymentResponse() {
    this.voidPayment = false;
    const url =  'home/' + this.marketId
    this.router.navigate([url]);
  }

  getTotalCharge() {
    var totalrentalCharge = this.getActualAmountFromInp(this.bookingDetailsForm.get('rentalCharge').value);
    var otherRentalCharge = this.getActualAmountFromInp(this.bookingDetailsForm.get('otherCharge').value);
    var totalSalesTax = this.getActualAmountFromInp(this.bookingDetailsForm.get('totalSalesTax').value);
    var totalSecondLeveltax = this.getActualAmountFromInp(this.bookingDetailsForm.get('totalSecondLeveltax').value);
    var totalCharge = this.actualTotalDue + totalrentalCharge + otherRentalCharge + this.renewalFeeAmount + totalSalesTax + totalSecondLeveltax;
    return totalCharge;
  }

  setMinimum(controls) {
    const value = controls.value;
    var enteredAmount = this.getActualAmountFromInp(value.toString());
    if (!enteredAmount) {
      controls.setValue(this.customCurrency.transform("0.00"));
    }

    var totalDue = this.getTotalCharge();
    if (enteredAmount > totalDue) {
      this.bookingDetailsForm.get("paymentAmount").setValue(this.customCurrency.transform(totalDue.toString()));
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Payment amount cannot be greater than total due.`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
    }
    this.calculateBalance();
  }

  calculateBalance() {
    if (this.allowRenewalsFee && this.allowRenewalsFeeId) {
      this.onlineBookingFeeApplied = this.isAnyRenewalSelected();
    }

    var creditCardAmount = this.getActualAmountFromInp(this.bookingDetailsForm.get('paymentAmount').value);
    var totalrentalCharge = this.getActualAmountFromInp(this.bookingDetailsForm.get('rentalCharge').value);
    var otherRentalCharge = this.getActualAmountFromInp(this.bookingDetailsForm.get('otherCharge').value);
    var totalSalesTax = this.getActualAmountFromInp(this.bookingDetailsForm.get('totalSalesTax').value);
    var totalSecondLeveltax = this.getActualAmountFromInp(this.bookingDetailsForm.get('totalSecondLeveltax').value);
    var vendorLateFee = this.getActualAmountFromInp(this.bookingDetailsForm.get('paymentLateFee').value ?? 0);
    var renewalFee = this.getActualAmountFromInp(this.renewalFeeAmount);
    if (this.onlineBookingFeeApplied) {
      renewalFee += this.getActualAmountFromInp(this.onlineBookingFeeAmount);
    }
    var currentRentalCharge = totalrentalCharge + otherRentalCharge + totalSalesTax + totalSecondLeveltax + renewalFee + vendorLateFee;
    var totalDue = this.actualTotalDue + totalrentalCharge + otherRentalCharge + totalSalesTax + totalSecondLeveltax + vendorLateFee;
    totalDue = parseFloat(totalDue.toFixed(2))
    if (totalDue > 0) {
      totalDue = totalDue + renewalFee;
    }
    else{
      renewalFee = 0;
      currentRentalCharge -= this.getActualAmountFromInp(this.renewalFeeAmount);
      if (this.onlineBookingFeeApplied) {
        currentRentalCharge -= this.getActualAmountFromInp(this.onlineBookingFeeAmount);
      }
    }

    if (this.actualTotalDue < 0 && (totalDue <= 0)) {
      totalDue = 0;
      creditCardAmount = 0;
    }
    if (!this.AllowPartialPay) {
      creditCardAmount = totalDue > 0 ? totalDue : 0;
    }
    this.creditCardAmount = creditCardAmount;
    const convenienceFee = 0;

    var totalAmount;
    totalAmount = creditCardAmount + convenienceFee;
    var balanceAmount = totalDue != 0 ? totalDue - totalAmount : 0;

    if(this.actualTotalDue < 0 && currentRentalCharge == 0){
      balanceAmount = this.actualTotalDue;
      totalAmount = 0;
    }
    else if (this.actualTotalDue < 0 && (totalDue <= 0)) {
      balanceAmount = this.actualTotalDue + currentRentalCharge;
      totalDue = currentRentalCharge;
    }
    this.bookingDetailsForm.patchValue({
      totalCharge: this.customCurrency.transform(totalDue.toString()),
      balanceDue: this.customCurrency.transform(balanceAmount.toString()),
      convenienceFee: this.customCurrency.transform(convenienceFee.toString()),
      additionalCharge: this.customCurrency.transform(renewalFee.toString()),
      totalPayment: this.customCurrency.transform(totalAmount.toString()),
      paymentAmount: this.customCurrency.transform(creditCardAmount.toString()),
    }, { emitEvent: false })

    this.paymentAmount = parseFloat(this.getActualAmountFromInp(this.bookingDetailsForm.get('totalPayment')?.value ?? 0).toFixed(2));

    if (this.applyCCCharge && creditCardAmount > 0) {
      this.calculateConvenienceFee();
    }
  }

  handledblClick(event: any) {
    clearTimeout(this.clickTimeout);

    const inputElement = event.target as HTMLInputElement;
    inputElement.select(); // Select the entire text on double-click
  }

  handleClick(event: any) {
    // Get the current value of the input field
    let currentValue: string = event.target.value;
    const currentCursorPosition = event.target.selectionStart;
    const currentSelectionLength = event.target.selectionEnd - event.target.selectionStart;
    const inputElement = event.target as HTMLInputElement;
    const inputValue = inputElement.value;
    clearTimeout(this.clickTimeout);

    this.clickTimeout = setTimeout(() => {
      if (inputValue === '$0.00') {
        const selectionLength = inputElement.selectionEnd - inputElement.selectionStart;

        // If the entire text is not selected, set the cursor position after the "$" sign
        if (selectionLength !== inputValue.length) {
          inputElement.setSelectionRange(1, 1);
        }
      }
    }, 200); // Delay to check for double click

    if (currentSelectionLength === currentValue.length) {
      return true;
    }
    // Check if the input value is "$0.00"
    if (currentValue === '$0.00') {
      // Set the cursor position after the "$" sign
      event.target.setSelectionRange(1, 1);
      return;
    }

    // Check if the "$" sign is present in the current value
    const hasDollarSign = currentValue.includes('$');
    // Get the cursor position
    const caretPosition = event.target.selectionStart;
    // Check if the cursor position is after the "$" sign
    const hasDollarSignBeforeCaret = currentValue.slice(0, caretPosition).includes('$');
    // If the cursor is not after the "$" sign, adjust the cursor position
    if (!hasDollarSignBeforeCaret && hasDollarSign) {
      // Find the index of "$" sign
      const dollarSignIndex = currentValue.indexOf('$');
      // Set the cursor position after the "$" sign
      event.target.setSelectionRange(dollarSignIndex + 1, dollarSignIndex + 1);
    }
  }

  setCurrencyFormat(controls) {
    const value = controls.value;
    let inputValue = value;
    if(inputValue.toString().substring(1,2) == "$")
      inputValue = `${inputValue.slice(1)}`;
    controls.setValue(inputValue);
  }


  numberOnly(event): boolean {
    const inputValue = event.target.value;
    const charCode = (event.which) ? event.which : event.keyCode;
    const currentCursorPosition = event.target.selectionStart;
    const currentSelectionLength = event.target.selectionEnd - event.target.selectionStart;
    // Check if the input value is "$0.00"
    if (charCode == 45) {
      return false;
    }
    if (currentSelectionLength === inputValue.length) {
      return true;
    }
    if (inputValue === '$0.00') {
      // Set the cursor position after the "$" sign
      event.target.setSelectionRange(1, 1);
      return true; // Allow further input
    }
    // Check if the "$" sign is present in the current value
    const hasDollarSign = inputValue.includes('$');
    // Check if the cursor position is after the "$" sign
    const hasDollarSignBeforeCaret = inputValue.slice(0, currentCursorPosition).includes('$');
    // If the cursor is not after the "$" sign and "$" sign is present, prevent input
    if (!hasDollarSignBeforeCaret && hasDollarSign && charCode !== 46 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    // If the entered character is a dot and there's already a dot in the input, prevent input
    if (charCode == 46 && inputValue.includes('.') && inputValue.indexOf('.') !== currentCursorPosition) {
      return false;
    }
    if (charCode > 31 && (charCode < 46 || charCode > 57 || charCode === 47)) {
      return false;
    }
    return true; // Allow input
  }

  getCCCredentials() {
    this.paymentService.getCCCredentials(this.marketId).subscribe((res) => {
      if (res !== null) {
        this.paymentGatewayCredentials = res.GatewayDetails ? JSON.parse(res.GatewayDetails) : null;
        this.processCreditCardOnline = res.ProcessCreditCardOnline;
        const gatewayId = Number(res.PaymentGateWay);
        this.isStripeEnabled = gatewayId == EPaymentGateway.Stripe;
        this.isOpenEdgenEnabled = gatewayId == EPaymentGateway.OpenEdgeExpress;
      }
    })
  }

  getWebRentalSetting() {
    const sub = this.marketInfoService.getWebRentalSetting(this.marketId).subscribe(async (res: any) => {
      if (res) {
        this.applyCCCharge = res.ApplyCcporcessingFeePercentage;
        this.CCFeeType = res.CCFeeType;
        this.CcfeeinPercentage = res.CcfeeinPercentage;
        this.AllowPartialPay = res.AllowPartialPay;
        this.bookingDetailsForm.get('paymentAmount').enable();
        this.allowCWRentalRenewal = res.AllowRenewalsCw;
        this.allowCMRentalRenewal = res.AllowRenewalsCm;
        this.applyRentalRenewalAvailability();
        this.allowOtherItemRenewal = res.AllowRenewingOtherItems;
        this.applyRenewalFee = res.ApplyBookingFee;
        this.bookingRenewalFeeId = res.ApplyBookingFeeId;
        this.preventVendorUncheckOtherItemRenewal = res.PreventVendorUncheckOtherItemRenewal ?? false;
        if (this.bookingRenewalFeeId) {
          const resFee = await this.rentalService.getBookingRenewalFeeById(this.marketId, this.bookingRenewalFeeId).toPromise();
          if (resFee) {
            this.renewalFeeAmount = (this.rentalType == 1 ? resFee.OtherItemCharge :
              this.rentalType == 4 ? resFee.OtherItemCombinedMonthlyCharge :
                this.rentalType == 5 ? resFee.OtherItemCombinedWeeklyCharge : 0) ?? 0;
          }
        }

        this.allowRenewalsFee = res.AllowRenewalsFee ?? false;
        this.allowRenewalsFeeId = res.AllowRenewalsFeeId;
        if (this.allowRenewalsFee && this.allowRenewalsFeeId) {
          const resOnlineFee = await this.rentalService.getBookingRenewalFeeById(this.marketId, this.allowRenewalsFeeId).toPromise();
          if (resOnlineFee) {
            this.onlineBookingFeeAmount = (this.rentalType == 1 ? resOnlineFee.OtherItemCharge :
              this.rentalType == 4 ? resOnlineFee.OtherItemCombinedMonthlyCharge :
                this.rentalType == 5 ? resOnlineFee.OtherItemCombinedWeeklyCharge : 0) ?? 0;
          }
        }
        if (!this.AllowPartialPay) {
          this.bookingDetailsForm.get('paymentAmount').disable();
          this.bookingDetailsForm.patchValue({
            paymentAmount: this.customCurrency.transform(this.actualTotalDue.toString()),
            totalPayment: this.customCurrency.transform(this.actualTotalDue.toString()),
          })
        } else {
          this.bookingDetailsForm.patchValue({
            paymentAmount: this.customCurrency.transform("0"),
            totalPayment: this.customCurrency.transform("0")
          })
          await this.calculateBalance();
        }
        
        this.paymentAmount = parseFloat(this.getActualAmountFromInp(this.bookingDetailsForm.get('totalPayment')?.value ?? 0).toFixed(2));
        const creditCardAmount = this.getActualAmountFromInp(this.bookingDetailsForm.get('paymentAmount').value);
        if (this.applyCCCharge && creditCardAmount > 0) {
          this.calculateConvenienceFee();
        }
      }
    }, err => {
    });
    this.subscriptions.push(sub);
  }

  // Reflect the market's "allow renewal" settings in the grid as soon as either
  // the settings or the booth data become available (whichever resolves last),
  // so a booth type with renewals disabled shows as non-extendable from the
  // initial load instead of only after the user interacts with it.
  private applyRentalRenewalAvailability() {
    if (this.allowCMRentalRenewal === false) {
      (this.selectedMonthlyBooths ?? [])
        .filter(record => record.BookingCanExtend !== false)
        .forEach(record => {
          record.BookingCanExtend = false;
          record.RenewalStartMonth = "This booking cannot be extended further!";
        });
    }
    if (this.allowCWRentalRenewal === false) {
      (this.selectedWeeklyBooths ?? [])
        .filter(record => record.BookingCanExtend !== false)
        .forEach(record => {
          record.BookingCanExtend = false;
          record.RenewalStartWeek = "This booking cannot be extended further!";
        });
    }
  }

  calculateConvenienceFee() {
    var convenienceFee = 0;
    var creditCardAmount = this.getActualAmountFromInp(this.bookingDetailsForm.get('paymentAmount').value);
    var totalrentalCharge = this.getActualAmountFromInp(this.bookingDetailsForm.get('rentalCharge').value);
    var otherRentalCharge = this.getActualAmountFromInp(this.bookingDetailsForm.get('otherCharge').value);
    var totalSalesTax = this.getActualAmountFromInp(this.bookingDetailsForm.get('totalSalesTax').value);
    var totalSecondLeveltax = this.getActualAmountFromInp(this.bookingDetailsForm.get('totalSecondLeveltax').value);
    var vendorLateFee = this.getActualAmountFromInp(this.bookingDetailsForm.get('paymentLateFee').value ?? 0);
    var renewalFee = this.getActualAmountFromInp(this.bookingDetailsForm.get('additionalCharge').value);
    var totalDue = this.actualTotalDue + totalrentalCharge + otherRentalCharge + totalSalesTax + totalSecondLeveltax + vendorLateFee;
    if(totalDue > 0){
      totalDue = totalDue + renewalFee;
    }
    else{
      renewalFee = 0;
    }
    if (creditCardAmount > 0) {
      var convenienceFee = creditCardAmount * ((this.CcfeeinPercentage) / 100);

      if (this.CCFeeType == 1) {
        convenienceFee = this.CcfeeinPercentage;
      }

      if (this.FirstMondayCustomChanges && creditCardAmount < 100) {
        convenienceFee = 3;
      }
      totalDue += convenienceFee;
      this.creditCardAmount = creditCardAmount + convenienceFee;
    }
    var totalAmount = 0;
    totalAmount = creditCardAmount + convenienceFee;
    const balanceAmount = totalDue - totalAmount;

    this.bookingDetailsForm.patchValue({
      convenienceFee: this.customCurrency.transform(convenienceFee.toString()),
      balanceDue: this.customCurrency.transform(balanceAmount.toString()),
      totalPayment: this.customCurrency.transform(totalAmount.toString()),
      totalCharge: this.customCurrency.transform(totalDue.toString())
    }, { emitEvent: false })
    this.paymentAmount = parseFloat(this.getActualAmountFromInp(this.bookingDetailsForm.get('totalPayment')?.value ?? 0).toFixed(2));
  }

  getRentalPaymentSettings() {
    this.loaderIcon = Promise.resolve(true);
    const sub = this.rentalService.getRentalSettings(this.marketId).subscribe((res: any) => {
      if (res) {
        this.ResaleNumberRequired = res.ResaleNumberRequired;
        this.DaysSellWithoutResaleNumber = res.DaysSellWithoutResaleNumber;
        this.BusinessLicenseNumberRequired = res.BusinessLicenseNumberRequired;
        this.DaysSellWithoutBusiLicNumber = res.DaysSellWithoutBusiLicNumber;
        this.combinedMonthlyBookingEndDate = res.CombinedMonthlyBookingEndDate;
        this.masterRentChargeforResOtherItems = res.MasterChargeForOtherChargeRenewal;
        this.displayCityTax = res.RentalSecondTaxable;
        this.displaySalesTax = res.RentalTaxable;
        this.displayOtherChargeSalesTax = res.OtherRentalTaxable;
        this.displayOtherChargeCityTax = res.OtherRentalSecondTaxable;
        this.secondTaxName = res.SecondTaxName ? res.SecondTaxName: "Sec Level Tax";
      }
    });
  }

  extendCWRental(extendRentalRecord) {
    if (extendRentalRecord) {
      var recordExist = this.selectedWeeklyBooths.findIndex(e => e.RentStartPeriod == extendRentalRecord.RentStartPeriod && e.RentEndPeriod == extendRentalRecord.RentEndPeriod
        && e.BoothNumber == extendRentalRecord.BoothNumber)
      if (recordExist != -1) {
        const rentalDates = [];
        const currentMonthRentalDates = [];
        var rentalstartDate;
        var marketDays = 0;
        this.selectedMarketDays.map((el, i) => {
          const startDate = this.selectedWeeklyBooths[recordExist].RentalStartDate;
          const endDate = new Date(extendRentalRecord.CWRenewalWeek.split("-")[1]);
          const selectedDayOfWeek = el - 1;
          const today: Date = new Date(new Date().toDateString())
          let currentDay = new Date(startDate);
          const currentMonthEnd =  new Date(this.selectedWeeklyBooths[recordExist].RentEndPeriod.split('-')[1]);
          while (currentDay <= endDate) {
            if (currentDay.getDay() === selectedDayOfWeek) {
              if (!rentalstartDate) {
                rentalstartDate = this.datePipe.transform(new Date(currentDay), 'MMM d, y');
              }
              marketDays += 1;
              rentalDates.push({ startDate: this.datePipe.transform(new Date(currentDay), 'MMM d, y') });
            }
            currentDay.setDate(currentDay.getDate() + 1);
          }

          currentDay = new Date(startDate);
          while (currentDay <= currentMonthEnd) {
            if (currentDay.getDay() === selectedDayOfWeek) {
              if (!rentalstartDate) {
                rentalstartDate = this.datePipe.transform(new Date(currentDay), 'MMM d, y');
              }
              currentMonthRentalDates.push({ startDate: this.datePipe.transform(new Date(currentDay), 'MMM d, y') });
            }
            currentDay.setDate(currentDay.getDate() + 1);
          }

          const compareDates = (a: DateString, b: DateString): number => {
            const dateA = new Date(a.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
            const dateB = new Date(b.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
            return dateA - dateB;
          };
          const sortedDates = rentalDates.sort(compareDates);

          const compareCurrentMonthDates = (a: DateString, b: DateString): number => {
            const dateA = new Date(a.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
            const dateB = new Date(b.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
            return dateA - dateB;
          };
          const currentMonthSortedDates = currentMonthRentalDates.sort(compareCurrentMonthDates);
        });

        var allRentalDates = rentalDates.map(el => new Date(el.startDate));
        var currentRentedEndDate = new Date(this.selectedWeeklyBooths[recordExist].RentalEndDate);
        const filteredRentalDates = allRentalDates.filter(rentalDate => rentalDate > currentRentedEndDate);
        var obj1 = {
          RentalDates: filteredRentalDates,
          BoothNumber: this.selectedWeeklyBooths[recordExist].BoothNumber
        }

        var RentAmount = this.selectedWeeklyBooths[recordExist].Rent;
        var SalesTax = this.selectedWeeklyBooths[recordExist].SalesTax;
        var CityTax = this.selectedWeeklyBooths[recordExist].CityTax;
        var JanRentAmount = this.selectedWeeklyBooths[recordExist].January ?? 0;
        var FebRentAmount = this.selectedWeeklyBooths[recordExist].February ?? 0;
        var MarRentAmount = this.selectedWeeklyBooths[recordExist].March ?? 0;
        var AprRentAmount = this.selectedWeeklyBooths[recordExist].April ?? 0;
        var MayRentAmount = this.selectedWeeklyBooths[recordExist].May ?? 0;
        var JunRentAmount = this.selectedWeeklyBooths[recordExist].June ?? 0;
        var JulRentAmount = this.selectedWeeklyBooths[recordExist].July ?? 0;
        var AugRentAmount = this.selectedWeeklyBooths[recordExist].August ?? 0;
        var SepRentAmount = this.selectedWeeklyBooths[recordExist].September ?? 0;
        var OctRentAmount = this.selectedWeeklyBooths[recordExist].October ?? 0;
        var NovRentAmount = this.selectedWeeklyBooths[recordExist].November ?? 0;
        var DecRentAmount = this.selectedWeeklyBooths[recordExist].December ?? 0;

        this.totalRentalCharge -= this.getActualAmountFromInp(RentAmount);
        this.totalSalesTax -= this.getActualAmountFromInp(SalesTax);
        this.totalSecondLeveltax -= this.getActualAmountFromInp(CityTax);
        this.totalCharge = this.priorBalance + this.totalRentalCharge + this.totalOtherRentalCharge + this.totalSalesTax + this.totalSecondLeveltax;

        this.bookingDetailsForm.patchValue({
          rentalCharge: this.customCurrency.transform(this.totalRentalCharge.toString()),
          totalSalesTax: this.customCurrency.transform(this.totalSalesTax.toString()),
          totalSecondLeveltax: this.customCurrency.transform(this.totalSecondLeveltax.toString()),
          totalCharge: this.customCurrency.transform(this.totalCharge.toString())
        });

        var extendRentalStartPeriod;
        if (!this.selectedWeeklyBooths[recordExist].NewBooth && this.selectedWeeklyBooths[recordExist].Status != "R") {
          extendRentalStartPeriod = new Date(this.selectedWeeklyBooths[recordExist].RentalSavedEndDate);
          extendRentalStartPeriod.setDate(extendRentalStartPeriod.getDate() + 1);
        }
        else {
          extendRentalStartPeriod = new Date(this.selectedWeeklyBooths[recordExist].RentStartPeriod.split("-")[0]);
        }

        var obj = {
          BoothTypeId: this.selectedWeeklyBooths[recordExist].BoothTypeId,
          VendorId: this.vendorId,
          RentalStartPeriod: new Date(extendRentalStartPeriod),
          RentalEndPeriod: new Date(extendRentalRecord.CWRenewalWeek.split("-")[1]),
          PerDiemApplicable: this.selectedWeeklyBooths[recordExist].PerDiem,
          JanRent: this.getActualAmountFromInp(JanRentAmount),
          FebRent: this.getActualAmountFromInp(FebRentAmount),
          MarRent: this.getActualAmountFromInp(MarRentAmount),
          AprRent: this.getActualAmountFromInp(AprRentAmount),
          MayRent: this.getActualAmountFromInp(MayRentAmount),
          JunRent: this.getActualAmountFromInp(JunRentAmount),
          JulRent: this.getActualAmountFromInp(JulRentAmount),
          AugRent: this.getActualAmountFromInp(AugRentAmount),
          SepRent: this.getActualAmountFromInp(SepRentAmount),
          OctRent: this.getActualAmountFromInp(OctRentAmount),
          NovRent: this.getActualAmountFromInp(NovRentAmount),
          DecRent: this.getActualAmountFromInp(DecRentAmount),
        }
        this.rentalService.getBoothRentalCombinedWeeklyCharges(this.marketId, obj).subscribe((res: any) => {
          this.selectedWeeklyBooths[recordExist].MktDays = marketDays;
          this.selectedWeeklyBooths[recordExist].RentalEndDate = rentalDates[rentalDates.length - 1].startDate;
          this.selectedWeeklyBooths[recordExist].RentEndPeriod = extendRentalRecord.CWRenewalWeek;
          this.selectedWeeklyBooths[recordExist].January = this.customCurrency.transform(res.JanRent);
          this.selectedWeeklyBooths[recordExist].February = this.customCurrency.transform(res.FebRent);
          this.selectedWeeklyBooths[recordExist].March = this.customCurrency.transform(res.MarRent);
          this.selectedWeeklyBooths[recordExist].April = this.customCurrency.transform(res.AprRent);
          this.selectedWeeklyBooths[recordExist].May = this.customCurrency.transform(res.MayRent);
          this.selectedWeeklyBooths[recordExist].June = this.customCurrency.transform(res.JunRent);
          this.selectedWeeklyBooths[recordExist].July = this.customCurrency.transform(res.JulRent);
          this.selectedWeeklyBooths[recordExist].August = this.customCurrency.transform(res.AugRent);
          this.selectedWeeklyBooths[recordExist].September = this.customCurrency.transform(res.SepRent);
          this.selectedWeeklyBooths[recordExist].October = this.customCurrency.transform(res.OctRent);
          this.selectedWeeklyBooths[recordExist].November = this.customCurrency.transform(res.NovRent);
          this.selectedWeeklyBooths[recordExist].December = this.customCurrency.transform(res.DecRent);
          this.selectedWeeklyBooths[recordExist].Rent = this.customCurrency.transform(res.Rent);
          this.selectedWeeklyBooths[recordExist].SalesTax = this.customCurrency.transform(res.SalesTax);
          this.selectedWeeklyBooths[recordExist].CityTax = this.customCurrency.transform(res.CityTax);
          this.selectedWeeklyBooths[recordExist].JanuaryMonthPresent = res.JanuaryMonthPresent;
          this.selectedWeeklyBooths[recordExist].FebruaryMonthPresent = res.FebruaryMonthPresent;
          this.selectedWeeklyBooths[recordExist].MarchMonthPresent = res.MarchMonthPresent;
          this.selectedWeeklyBooths[recordExist].AprilMonthPresent = res.AprilMonthPresent;
          this.selectedWeeklyBooths[recordExist].MayMonthPresent = res.MayMonthPresent;
          this.selectedWeeklyBooths[recordExist].JuneMonthPresent = res.JuneMonthPresent;
          this.selectedWeeklyBooths[recordExist].JulyMonthPresent = res.JulyMonthPresent;
          this.selectedWeeklyBooths[recordExist].AugustMonthPresent = res.AugustMonthPresent;
          this.selectedWeeklyBooths[recordExist].SeptemberMonthPresent = res.SeptemberMonthPresent;
          this.selectedWeeklyBooths[recordExist].OctoberMonthPresent = res.OctoberMonthPresent;
          this.selectedWeeklyBooths[recordExist].NovemberMonthPresent = res.NovemberMonthPresent;
          this.selectedWeeklyBooths[recordExist].DecemberMonthPresent = res.DecemberMonthPresent;
          this.selectedWeeklyBooths[recordExist].DisableJanMonth = res.JanRent || res.JanRent == 0 ? false : true;
          this.selectedWeeklyBooths[recordExist].DisableFebMonth = res.FebRent || res.FebRent == 0 ? false : true;
          this.selectedWeeklyBooths[recordExist].DisableMarMonth = res.MarRent || res.MarRent == 0 ? false : true;
          this.selectedWeeklyBooths[recordExist].DisableAprMonth = res.AprRent || res.AprRent == 0 ? false : true;
          this.selectedWeeklyBooths[recordExist].DisableMayMonth = res.MayRent || res.MayRent == 0 ? false : true;
          this.selectedWeeklyBooths[recordExist].DisableJunMonth = res.JunRent || res.JunRent == 0 ? false : true;
          this.selectedWeeklyBooths[recordExist].DisableJulMonth = res.JulRent || res.JulRent == 0 ? false : true;
          this.selectedWeeklyBooths[recordExist].DisableAugMonth = res.AugRent || res.AugRent == 0 ? false : true;
          this.selectedWeeklyBooths[recordExist].DisableSepMonth = res.SepRent || res.SepRent == 0 ? false : true;
          this.selectedWeeklyBooths[recordExist].DisableOctMonth = res.OctRent || res.OctRent == 0 ? false : true;
          this.selectedWeeklyBooths[recordExist].DisableNovMonth = res.NovRent || res.NovRent == 0 ? false : true;
          this.selectedWeeklyBooths[recordExist].DisableDecMonth = res.DecRent || res.DecRent == 0 ? false : true;
          this.selectedWeeklyBooths[recordExist].ExtendRental = true;

          this.totalRentalCharge += this.getActualAmountFromInp(res.Rent);
          this.totalSalesTax += this.getActualAmountFromInp(res.SalesTax);
          this.totalSecondLeveltax += this.getActualAmountFromInp(res.CityTax);
          this.totalCharge = this.priorBalance + this.totalRentalCharge + this.totalOtherRentalCharge + this.totalSalesTax + this.totalSecondLeveltax;
          this.bookingDetailsForm.patchValue({
            rentalCharge: this.customCurrency.transform(this.totalRentalCharge.toString()),
            totalSalesTax: this.customCurrency.transform(this.totalSalesTax.toString()),
            totalSecondLeveltax: this.customCurrency.transform(this.totalSecondLeveltax.toString()),
            totalCharge: this.customCurrency.transform(this.totalCharge.toString())
          });
        });
      }
    }
  }

  async extendCMRental(extendRentalRecord) {
    const extendedRentalEndDates = extendRentalRecord.CMRenewalMonth;
    if (extendedRentalEndDates != extendRentalRecord.CurrentRentStartPeriod) {
      const result = await Swal.fire({
        title: $localize`Confirm`,
        text: $localize`Are you sure you wish to extend the bookings till ` + extendedRentalEndDates + '? Please note that the extended period cannot be cancelled',
        icon: "question",
        showCancelButton: true,
        confirmButtonText: $localize`Yes`,
        cancelButtonText: $localize`No`,
      });
      if (!result.isConfirmed) {
        const recordExist = extendRentalRecord.MonthlyRentalId != 0
          ? this.selectedMonthlyBooths.findIndex(e =>
            e.RentStartPeriod == extendRentalRecord.RentStartPeriod &&
            e.RentEndPeriod == extendRentalRecord.RentEndPeriod &&
            e.BoothNumber == extendRentalRecord.BoothNumber &&
            e.MonthlyRentalId == extendRentalRecord.MonthlyRentalId)
          : this.selectedMonthlyBooths.findIndex(e =>
            e.RentStartPeriod == extendRentalRecord.RentStartPeriod &&
            e.RentEndPeriod == extendRentalRecord.RentEndPeriod &&
            e.BoothNumber == extendRentalRecord.BoothNumber);

        if (recordExist !== -1) {
          const record = this.selectedMonthlyBooths[recordExist];
          record.CMRenewalMonth = extendRentalRecord.RentEndPeriod;
          record.Reservation = false;
          this.updateRentalRecord(record);
          return;
        };
      }
    }

    this.loaderIcon = Promise.resolve(true);
    if ((this.ResaleNumberRequired && !this.exemptResale) || this.BusinessLicenseNumberRequired) {
      await this.handleResaleOrLicenseCheck(extendRentalRecord);
    } else {
      await this.proceedExtendingRental(extendRentalRecord);
    }
  }

  private async handleResaleOrLicenseCheck(extendRentalRecord: any) {
    const dateSet = new Set<string>();
    let vendorRentalDays: any[] = [];
    let marketDayCountForResale = 0;

    const selectedDays = this.selectedMarketDays.map(d => d - 1);

    const selectedBoothRecord = this.selectedMonthlyBooths.filter(e => e.NewBooth || e.ExtendRental);
    let rentalDates: string[] = [];

    for (const record of selectedBoothRecord) {
      rentalDates.push(...this.generateDates(new Date(record.RentalStartDate), new Date(record.RentalEndDate), selectedDays));
    }

    const recordExist = this.selectedMonthlyBooths.findIndex(e =>
      e.RentStartPeriod == extendRentalRecord.RentStartPeriod &&
      e.RentEndPeriod == extendRentalRecord.RentEndPeriod &&
      e.BoothNumber == extendRentalRecord.BoothNumber &&
      (extendRentalRecord.MonthlyRentalId == 0 || e.MonthlyRentalId == extendRentalRecord.MonthlyRentalId)
    );

    if (recordExist !== -1) {
      const record = this.selectedMonthlyBooths[recordExist];
      const startDate = new Date(record.RentalStartDate);
      const [endMonthDate, endMonthYear] = extendRentalRecord.CMRenewalMonth.split(' ');
      const endMonthIndex = this.getMonthIndex(endMonthDate);
      let endDate = new Date(endMonthYear, endMonthIndex + 1, 0);

      if (this.combinedMonthlyBookingEndDate) {
        const ym = `${endDate.getFullYear()}${(endDate.getMonth() + 1).toString().padStart(2, '0')}`;
        endDate = await this.getMonthEndingDateFromSetting(ym);
      }

      rentalDates.push(...this.generateDates(startDate, endDate, selectedDays));
    }

    for (const date of rentalDates) {
      if (!dateSet.has(date)) {
        dateSet.add(date);
        vendorRentalDays.push({ VendorRentalDate: date });
        marketDayCountForResale++;
        if (marketDayCountForResale > this.DaysSellWithoutResaleNumber) break;
      }
    }

    const vendorRentalDaysRes = await lastValueFrom(
      this.rentalService.getVendorRentalDays({ VendorID: this.vendorId, VendorRentalDate: new Date() })
    );

    if (vendorRentalDaysRes?.length) {
      for (const el of vendorRentalDaysRes) {
        const formatted = this.datePipe.transform(el.VendorRentalDate, 'MM/dd/yyyy');
        if (!dateSet.has(formatted)) {
          dateSet.add(formatted);
          vendorRentalDays.push({ VendorRentalDate: formatted });
          marketDayCountForResale++;
        }
      }
    }

    if (this.ResaleNumberRequired && !this.exemptResale && !this.resaleNo &&
      marketDayCountForResale > this.DaysSellWithoutResaleNumber && !this.resaleOptionSelected) {
      const modal = this.modalResaleNo.nativeElement;
      modal.classList.add('show');
      modal.style.display = 'block';
      this.loaderIcon = Promise.resolve(false);
    } else if (this.BusinessLicenseNumberRequired && marketDayCountForResale > this.DaysSellWithoutBusiLicNumber) {
      await this.handleBusinessLicenseFlow(extendRentalRecord);
    } else {
      await this.proceedExtendingRental(extendRentalRecord);
    }
  }

  private generateDates(start: Date, end: Date, selectedDays: number[]): string[] {
    const dates: string[] = [];
    let current = new Date(start);
    while (current <= end) {
      if (selectedDays.includes(current.getDay())) {
        dates.push(this.datePipe.transform(current, 'MM/dd/yyyy'));
      }
      current.setDate(current.getDate() + 1);
    }
    return dates;
  }

  async handleBusinessLicenseFlow(extendRentalRecord: any) {
    if (!this.businessLicenseNumber) {
      this.loaderIcon = Promise.resolve(false);
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Business License is required! Please contact the market`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
      this.revertMonthlyRentalExtension(extendRentalRecord);
      return;
    }

    if (!this.businessLicenseExpiryDate) {
      this.loaderIcon = Promise.resolve(false);
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Business License is expired! Please contact the market`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
      this.revertMonthlyRentalExtension(extendRentalRecord);
      return;
    }

    if (new Date(this.businessLicenseExpiryDate) < new Date()) {
      this.loaderIcon = Promise.resolve(false);
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Business License is expired! Please contact the market`,
        icon: "warning",
        confirmButtonText: $localize`Ok`,
      });
      this.revertMonthlyRentalExtension(extendRentalRecord);
      return;
    }

    await this.proceedExtendingRental(extendRentalRecord);
  }

  // Undo an in-progress CM (Monthly) extension attempt (dropdown selection +
  // Reservation flag) so the record does not appear extended when the
  // extension was blocked.
  private revertMonthlyRentalExtension(extendRentalRecord: any) {
    const recordExist = extendRentalRecord.MonthlyRentalId != 0
      ? this.selectedMonthlyBooths.findIndex(e =>
        e.RentStartPeriod == extendRentalRecord.RentStartPeriod &&
        e.RentEndPeriod == extendRentalRecord.RentEndPeriod &&
        e.BoothNumber == extendRentalRecord.BoothNumber &&
        e.MonthlyRentalId == extendRentalRecord.MonthlyRentalId)
      : this.selectedMonthlyBooths.findIndex(e =>
        e.RentStartPeriod == extendRentalRecord.RentStartPeriod &&
        e.RentEndPeriod == extendRentalRecord.RentEndPeriod &&
        e.BoothNumber == extendRentalRecord.BoothNumber);

    if (recordExist !== -1) {
      const record = this.selectedMonthlyBooths[recordExist];
      record.CMRenewalMonth = extendRentalRecord.RentEndPeriod;
      record.Reservation = false;
      this.updateRentalRecord(record);
    }
  }

  async proceedExtendingRental(extendRentalRecord) {
    this.loaderIcon = Promise.resolve(true);
    const {
      RentStartPeriod,
      RentEndPeriod,
      BoothNumber,
      MonthlyRentalId
    } = extendRentalRecord;

    const recordExist = this.selectedMonthlyBooths.findIndex(e =>
      e.RentStartPeriod === RentStartPeriod &&
      e.RentEndPeriod === RentEndPeriod &&
      e.BoothNumber === BoothNumber &&
      (MonthlyRentalId === 0 || e.MonthlyRentalId === MonthlyRentalId)
    );

    if (recordExist != -1) {
      if (!this.selectedMonthlyBooths[recordExist].Drop && this.selectedMonthlyBooths[recordExist].Reservation && this.allowCMRentalRenewal) {
        const rentalDates = [];
        var currentMonthRentalDates = [];
        var rentalstartDate;
        var marketDays = 0;

        for (const day of this.selectedMarketDays) {
          const selectedDayOfWeek = day - 1;
          let startDate = new Date(this.selectedMonthlyBooths[recordExist].RentalStartDate);
          let endDateYearMonth = '';
          let endDate: Date;

          // Parse end month
          const [endMonthName, endYear] = extendRentalRecord.CMRenewalMonth.split(' ');
          const endMonthIndex = this.getMonthIndex(endMonthName);
          endDate = new Date(+endYear, endMonthIndex + 1, 0);

          // Handle combined monthly booking end date
          if (this.combinedMonthlyBookingEndDate) {
            const rentalEndYM = `${endDate.getFullYear()}${String(endDate.getMonth() + 1).padStart(2, '0')}`;
            endDate = await this.getMonthEndingDateFromSetting(rentalEndYM);
            endDateYearMonth = rentalEndYM;

            const rentalStartDate = new Date(startDate);
            const prevMonthDate = new Date(rentalStartDate);
            prevMonthDate.setMonth(prevMonthDate.getMonth() - 1);

            const prevYM = `${prevMonthDate.getFullYear()}${String(prevMonthDate.getMonth() + 1).padStart(2, '0')}`;
            const prevMonthEnd = await this.getMonthEndingDateFromSetting(prevYM);

            const dateDiff = this.getDaysDifference(prevMonthEnd, startDate);
            if (dateDiff <= 7 && prevMonthEnd < startDate) {
              startDate = new Date(Math.max(Date.now(), prevMonthEnd.setDate(prevMonthEnd.getDate() + 1)));
            }
          }

          // Calculate currentMonthEnd
          let currentMonthEnd = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
          if (this.combinedMonthlyBookingEndDate) {
            const [startMonthName, startYear] = this.selectedMonthlyBooths[recordExist].RentStartPeriod.split(' ');
            const startMonthIndex = this.getMonthIndex(startMonthName);
            currentMonthEnd = new Date(+startYear, startMonthIndex + 1, 0);

            const rentalYM = `${currentMonthEnd.getFullYear()}${String(currentMonthEnd.getMonth() + 1).padStart(2, '0')}`;
            if (endDateYearMonth === rentalYM) {
              currentMonthEnd = await this.getMonthEndingDateFromSetting(rentalYM);
            }
          }

          // Fill rentalDates
          let currentDay = new Date(startDate);
          while (currentDay <= endDate) {
            if (currentDay.getDay() === selectedDayOfWeek) {
              const formatted = this.datePipe.transform(currentDay, 'MMM d, y')!;
              rentalstartDate ||= formatted;
              marketDays++;
              rentalDates.push({ startDate: formatted });
            }
            currentDay.setDate(currentDay.getDate() + 1);
          }

          // Fill currentMonthRentalDates
          if (this.combinedMonthlyBookingEndDate) {
            currentDay = new Date(startDate);
            while (currentDay <= currentMonthEnd) {
              if (currentDay.getDay() === selectedDayOfWeek) {
                const formatted = this.datePipe.transform(currentDay, 'MMM d, y')!;
                rentalstartDate ||= formatted;
                currentMonthRentalDates.push({ startDate: formatted });
              }
              currentDay.setDate(currentDay.getDate() + 1);
            }
          }
        }

        const compareDates = (a: DateString, b: DateString): number => {
          const dateA = new Date(a.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
          const dateB = new Date(b.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
          return dateA - dateB;
        };
        const sortedDates = rentalDates.sort(compareDates);

        if (this.combinedMonthlyBookingEndDate) {
          const compareCurrentMonthDates = (a: DateString, b: DateString): number => {
            const dateA = new Date(a.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
            const dateB = new Date(b.startDate.replace(/(\d+)(st|nd|rd|th)/, '$1')).getTime();
            return dateA - dateB;
          };
          const currentMonthSortedDates = currentMonthRentalDates.sort(compareCurrentMonthDates);
        }
        else {
          currentMonthRentalDates = rentalDates;
        }

        var allRentalDates = rentalDates.map(el => new Date(el.startDate));
        var currentRentedEndDate = new Date(this.selectedMonthlyBooths[recordExist].RentalEndDate);
        const filteredRentalDates = allRentalDates.filter(rentalDate => rentalDate > currentRentedEndDate);
        var obj1 = {
          RentalDates: filteredRentalDates,
          BoothNumber: this.selectedMonthlyBooths[recordExist].BoothNumber
        }

        this.subscriptions.push(this.rentalService.checkRentalExits(this.marketId, obj1).subscribe((res) => {
          if (!res.Success) {
            var RentAmount = this.selectedMonthlyBooths[recordExist].Rent;
            var SalesTax = this.selectedMonthlyBooths[recordExist].SalesTax;
            var CityTax = this.selectedMonthlyBooths[recordExist].CityTax;
            var JanRentAmount = this.selectedMonthlyBooths[recordExist].January ?? 0;
            var FebRentAmount = this.selectedMonthlyBooths[recordExist].February ?? 0;
            var MarRentAmount = this.selectedMonthlyBooths[recordExist].March ?? 0;
            var AprRentAmount = this.selectedMonthlyBooths[recordExist].April ?? 0;
            var MayRentAmount = this.selectedMonthlyBooths[recordExist].May ?? 0;
            var JunRentAmount = this.selectedMonthlyBooths[recordExist].June ?? 0;
            var JulRentAmount = this.selectedMonthlyBooths[recordExist].July ?? 0;
            var AugRentAmount = this.selectedMonthlyBooths[recordExist].August ?? 0;
            var SepRentAmount = this.selectedMonthlyBooths[recordExist].September ?? 0;
            var OctRentAmount = this.selectedMonthlyBooths[recordExist].October ?? 0;
            var NovRentAmount = this.selectedMonthlyBooths[recordExist].November ?? 0;
            var DecRentAmount = this.selectedMonthlyBooths[recordExist].December ?? 0;

            this.totalRentalCharge -= this.getActualAmountFromInp(RentAmount);
            this.totalSalesTax -= this.getActualAmountFromInp(SalesTax);
            this.totalSecondLeveltax -= this.getActualAmountFromInp(CityTax);
            this.totalCharge = this.priorBalance + this.totalRentalCharge + this.totalSalesTax + this.totalSecondLeveltax;
            this.setRentalCharges();

            var extendRentalStartPeriod;
            if (!this.selectedMonthlyBooths[recordExist].NewBooth && this.selectedMonthlyBooths[recordExist].Status != "R") {
              extendRentalStartPeriod = new Date(this.selectedMonthlyBooths[recordExist].RentalSavedEndDate);
              if (extendRentalStartPeriod.getDate() == 31) {
                extendRentalStartPeriod.setDate(extendRentalStartPeriod.getDate() + 1);
              }
              else {
                extendRentalStartPeriod.setMonth(extendRentalStartPeriod.getMonth() + 1);
              }
              extendRentalStartPeriod.setDate(1);
            }
            else {
              extendRentalStartPeriod = this.selectedMonthlyBooths[recordExist].RentalStartDate;
            }
            var obj = {
              BoothTypeId: this.selectedMonthlyBooths[recordExist].BoothTypeId,
              VendorId: this.vendorId,
              RentalStartPeriod: new Date(extendRentalStartPeriod),
              RentalEndPeriod: new Date(rentalDates[rentalDates.length - 1].startDate),
              PerDiemApplicable: this.selectedMonthlyBooths[recordExist].PerDiem,
              JanRent: this.getActualAmountFromInp(JanRentAmount),
              FebRent: this.getActualAmountFromInp(FebRentAmount),
              MarRent: this.getActualAmountFromInp(MarRentAmount),
              AprRent: this.getActualAmountFromInp(AprRentAmount),
              MayRent: this.getActualAmountFromInp(MayRentAmount),
              JunRent: this.getActualAmountFromInp(JunRentAmount),
              JulRent: this.getActualAmountFromInp(JulRentAmount),
              AugRent: this.getActualAmountFromInp(AugRentAmount),
              SepRent: this.getActualAmountFromInp(SepRentAmount),
              OctRent: this.getActualAmountFromInp(OctRentAmount),
              NovRent: this.getActualAmountFromInp(NovRentAmount),
              DecRent: this.getActualAmountFromInp(DecRentAmount),
            }

            this.subscriptions.push(this.rentalService.getBoothRentalCombinedMonthlyCharges(this.marketId, obj).subscribe((res: any) => {
              this.updateBoothRentalDetails(this.selectedMonthlyBooths[recordExist], extendRentalRecord.CMRenewalMonth, res, rentalDates, currentMonthRentalDates, marketDays);

              this.totalRentalCharge += this.getActualAmountFromInp(res.Rent);
              this.totalSalesTax += this.getActualAmountFromInp(res.SalesTax);
              this.totalSecondLeveltax += this.getActualAmountFromInp(res.CityTax);
              this.totalCharge = this.priorBalance + this.totalRentalCharge + this.totalOtherRentalCharge + this.totalSalesTax + this.totalSecondLeveltax;
              this.setRentalCharges();
              this.loaderIcon = Promise.resolve(false);
              // this.getDiscounts();
            }, err => {
              this.loaderIcon = Promise.resolve(false);
            }));
          }
          else {
            Swal.fire({
              title: $localize`Warning`,
              text: $localize`Rental End Period cannot be extended further`,
              icon: "warning",
              confirmButtonText: $localize`Ok`,
            });
            this.loaderIcon = Promise.resolve(false);
          }
        }));
      }
      else {
        this.selectedMonthlyBooths[recordExist].CMRenewalMonth =  this.selectedMonthlyBooths[recordExist].RentEndPeriod;
        this.selectedMonthlyBooths[recordExist].RenewalStartMonth = "This booking cannot be extended further!"
        this.selectedMonthlyBooths[recordExist].BookingCanExtend = false;
        this.loaderIcon = Promise.resolve(false);
      }
    }
    else{
      this.loaderIcon = Promise.resolve(false);
    }
  }

  updateBoothRentalDetails(record: any, renewalPeriod: any, res: any, rentalDates: any[], currentMonthRentalDates: any[], marketDays: number) {
    record.RentEndPeriod = renewalPeriod;
    record.RentalEndDate = this.datePipe.transform(new Date(rentalDates[rentalDates.length - 1].startDate), 'MMM d, y');
    record.MktDays = marketDays;

    record.Rent = this.customCurrency.transform(res.Rent);
    record.SalesTax = this.customCurrency.transform(res.SalesTax);
    record.CityTax = this.customCurrency.transform(res.CityTax);

    const months = [
      'January', 'February', 'March', 'April', 'May', 'June',
      'July', 'August', 'September', 'October', 'November', 'December'
    ];

    months.forEach(month => {
      const monthShort = month.substring(0, 3);
      record[month] = this.customCurrency.transform(res[`${monthShort}Rent`]);
      record[`${month}MonthPresent`] = res[`${month}MonthPresent`];
      record[`Disable${month.substring(0, 3)}Month`] = (res[`${monthShort}Rent`] || res[`${monthShort}Rent`] === 0) ? false : true;
    });

    record.StartDateList = currentMonthRentalDates;
    record.ExtendRental = true;
    record.AllRentalDates = rentalDates.map(el => new Date(el.startDate));
  }

  setRentalCharges() {
    this.totalCharge = this.priorBalance + this.totalRentalCharge + this.totalOtherRentalCharge + this.totalSalesTax + this.totalSecondLeveltax;
    this.bookingDetailsForm.patchValue({
      rentalCharge: this.customCurrency.transform(this.totalRentalCharge.toString()),
      otherCharge: this.customCurrency.transform(this.totalOtherRentalCharge.toString()),
      totalSalesTax: this.customCurrency.transform(this.totalSalesTax.toString()),
      totalSecondLeveltax: this.customCurrency.transform(this.totalSecondLeveltax.toString()),
      totalCharge: this.customCurrency.transform(this.totalCharge.toString())
    });
  }

  async handleCWEndDateChange() {

    this.renewAllBoothsFromGrid = true;
    this.vendorRentalDays = [];
    this.marketDayCountForResale = 0;

    let rentalDates = this.calculateRentalDates();
    await this.processVendorRentalDays(rentalDates);
  }

  calculateRentalDates() {
    let rentalDates = [];
    const selectedBooths = this.selectedWeeklyBooths.filter(e => e.NewBooth || e.ExtendRental);

    selectedBooths.forEach(record => {
      const selectedDayOfWeek = this.getSelectedDayOfWeek(record);
      let currentDay = new Date(record.RentalStartDate);
      const endDate = new Date(record.RentalEndDate);

      while (currentDay <= endDate) {
        if (currentDay.getDay() === selectedDayOfWeek) {
          rentalDates.push({ startDate: this.datePipe.transform(currentDay, 'MMM d, y') });
        }
        currentDay.setDate(currentDay.getDate() + 1);
      }
    });

    return rentalDates;
  }

  getSelectedDayOfWeek(record) {
    return record.Sunday ? 0 :
      record.Monday ? 1 :
        record.Tuesday ? 2 :
          record.Wednesday ? 3 :
            record.Thursday ? 4 :
              record.Friday ? 5 :
                record.Saturday ? 6 : null;
  }

  async processVendorRentalDays(rentalDates) {
    rentalDates.forEach(date => {
      const targetDateString = this.datePipe.transform(date.startDate, "MM/dd/yyyy");
      if (!this.vendorRentalDays.some(el => this.datePipe.transform(el.VendorRentalDate, "MM/dd/yyyy") === targetDateString)) {
        this.vendorRentalDays.push({ VendorRentalDate: targetDateString });
        this.marketDayCountForResale += 1;
        if (this.marketDayCountForResale > this.DaysSellWithoutResaleNumber && this.marketDayCountForResale > this.DaysSellWithoutBusiLicNumber) {
          return;
        }
      }
    });

    const obj = { VendorID: this.vendorId, VendorRentalDate: new Date() };
    const res = await this.rentalService.getVendorRentalDays(obj).toPromise();

    if (res && res.length > 0) {
      res.forEach(el => {
        const targetDateString = this.datePipe.transform(el.VendorRentalDate, "MM/dd/yyyy");
        if (!this.vendorRentalDays.some(data => this.datePipe.transform(data.VendorRentalDate, "MM/dd/yyyy") === targetDateString)) {
          this.vendorRentalDays.push({ VendorRentalDate: targetDateString });
          this.marketDayCountForResale += 1;
        }
      });
    }

    await this.checkResaleAndBusinessLicense();
  }

  async checkResaleAndBusinessLicense() {
    if (this.ResaleNumberRequired && !this.exemptResale && !this.resaleNo && this.marketDayCountForResale > this.DaysSellWithoutResaleNumber && !this.resaleOptionSelected) {
      this.showModal(this.modalResaleNo.nativeElement);
    } else if (this.BusinessLicenseNumberRequired && this.marketDayCountForResale > this.DaysSellWithoutBusiLicNumber) {
      if (!this.businessLicenseNumber) {
        await this.promptBusinessLicense();
      } else if (!this.businessLicenseExpiryDate || new Date(this.businessLicenseExpiryDate) < new Date()) {
        await this.promptExpiredBusinessLicense();
      } else {
        this.renewCWAllBooths();
      }
    } else {
      this.renewCWAllBooths();
    }
  }

  showModal(modal) {
    modal.classList.add('show');
    modal.style.display = 'block';
  }

  async promptBusinessLicense() {
    this.loaderIcon = Promise.resolve(false);
    Swal.fire({
      title: $localize`Warning`,
      text: $localize`Business License is required! Please contact the market`,
      icon: "warning",
      confirmButtonText: $localize`Ok`,
    });
    this.revertPendingWeeklyExtensions();
    return;
  }

  async promptExpiredBusinessLicense() {
    this.loaderIcon = Promise.resolve(false);
    Swal.fire({
      title: $localize`Warning`,
      text: $localize`Business License is expired! Please contact the market`,
      icon: "warning",
      confirmButtonText: $localize`Ok`,
    });
    this.revertPendingWeeklyExtensions();
    return;
  }

  // Undo pending renewals for every CW (Weekly) booth marked for renewal,
  // used when the "renew all" bulk flow is blocked before a specific record
  // is selected (no single extendRentalRecord to target).
  private revertPendingWeeklyExtensions() {
    this.selectedWeeklyBooths
      .filter(record => record.Reservation)
      .forEach(record => {
        record.Reservation = false;
        this.updateCWRentalRecord(record);
      });
  }

  async renewCWAllBooths(){
    var nonAvailableBooths = [];
    for (const item of this.selectedWeeklyBooths) {
      // this.selectedWeeklyBooths.forEach((item, i) => {
      if (new Date(item.RentEndPeriod.split('-')[0]) <= new Date(item.CWRenewalWeek.split('-')[0])
        && !item.Drop && item.Reservation && this.allowCWRentalRenewal) {
        if (item.WeeklyRentalId != 0)
          var recordExist = this.selectedWeeklyBooths.findIndex(e => e.RentStartPeriod == item.RentStartPeriod && e.RentEndPeriod == item.RentEndPeriod
            && e.BoothNumber == item.BoothNumber && e.WeeklyRentalId == item.WeeklyRentalId);
        else
          var recordExist = this.selectedWeeklyBooths.findIndex(e => e.RentStartPeriod == item.RentStartPeriod && e.RentEndPeriod == item.RentEndPeriod
            && e.BoothNumber == item.BoothNumber && e.RentalMarketDay == item.RentalMarketDay);

        if (recordExist != -1 && item.Status != "R") {
          var rentalstartDate = "";
          var marketDays = 0;
          var currentMonthRentalDates = [];
          const startDate = new Date(this.selectedWeeklyBooths[recordExist].RentalStartDate);
          const endDate = new Date(item.CWRenewalWeek.split('-')[1]);
          const currentMonthEnd =  new Date(this.selectedWeeklyBooths[recordExist].RentEndPeriod.split('-')[1])
          var rentalDates = [];
          this.selectedMarketDays =[];
          this.selectedWeeklyBooths[recordExist].Sunday == true ? this.selectedMarketDays.push(1) : 0;
          this.selectedWeeklyBooths[recordExist].Monday ? this.selectedMarketDays.push(2) : 0;
          this.selectedWeeklyBooths[recordExist].Tuesday == true ? this.selectedMarketDays.push(3) : 0;
          this.selectedWeeklyBooths[recordExist].Wednesday == true ? this.selectedMarketDays.push(4) : 0;
          this.selectedWeeklyBooths[recordExist].Thursday == true ? this.selectedMarketDays.push(5) : 0;
          this.selectedWeeklyBooths[recordExist].Friday == true ? this.selectedMarketDays.push(6) : 0;
          this.selectedWeeklyBooths[recordExist].Saturday == true ? this.selectedMarketDays.push(7) : 0;

          let currentDay = new Date(startDate);
          rentalDates = await this.CWRentalDateList(startDate,endDate);
          currentMonthRentalDates =  await this.CWRentalDateList(startDate,currentMonthEnd);

          var allRentalDates = rentalDates.map(el => new Date(el.startDate));
          var currentRentedEndDate = new Date(this.selectedWeeklyBooths[recordExist].RentalEndDate);
          const filteredRentalDates = allRentalDates.filter(rentalDate => rentalDate > currentRentedEndDate);
          var obj1 = {
            RentalDates: filteredRentalDates,
            BoothNumber: this.selectedWeeklyBooths[recordExist].BoothNumber
          }

          const rentalExist = await this.rentalService.checkRentalExits(this.marketId,obj1).toPromise();
          if (!rentalExist.Success) {
            var RentAmount = this.selectedWeeklyBooths[recordExist].Rent;
            var SalesTax = this.selectedWeeklyBooths[recordExist].SalesTax;
            var CityTax = this.selectedWeeklyBooths[recordExist].CityTax;
            var JanRentAmount = this.selectedWeeklyBooths[recordExist].January ?? 0;
            var FebRentAmount = this.selectedWeeklyBooths[recordExist].February ?? 0;
            var MarRentAmount = this.selectedWeeklyBooths[recordExist].March ?? 0;
            var AprRentAmount = this.selectedWeeklyBooths[recordExist].April ?? 0;
            var MayRentAmount = this.selectedWeeklyBooths[recordExist].May ?? 0;
            var JunRentAmount = this.selectedWeeklyBooths[recordExist].June ?? 0;
            var JulRentAmount = this.selectedWeeklyBooths[recordExist].July ?? 0;
            var AugRentAmount = this.selectedWeeklyBooths[recordExist].August ?? 0;
            var SepRentAmount = this.selectedWeeklyBooths[recordExist].September ?? 0;
            var OctRentAmount = this.selectedWeeklyBooths[recordExist].October ?? 0;
            var NovRentAmount = this.selectedWeeklyBooths[recordExist].November ?? 0;
            var DecRentAmount = this.selectedWeeklyBooths[recordExist].December ?? 0;

            var extendRentalStartPeriod;
            if (!this.selectedWeeklyBooths[recordExist].NewBooth && this.selectedWeeklyBooths[recordExist].Status != "R") {
              extendRentalStartPeriod = new Date(this.selectedWeeklyBooths[recordExist].RentalSavedEndDate);
              extendRentalStartPeriod.setDate(extendRentalStartPeriod.getDate() + 1);
            }
            else {
              extendRentalStartPeriod = new Date(this.selectedWeeklyBooths[recordExist].RentStartPeriod.split("-")[0]);
            }

            var obj = {
              BoothTypeId: this.selectedWeeklyBooths[recordExist].BoothTypeId,
              VendorId: this.vendorId,
              RentalStartPeriod: new Date(extendRentalStartPeriod),
              RentalEndPeriod: new Date(item.CWRenewalWeek.split("-")[1]),
              PerDiemApplicable: this.selectedWeeklyBooths[recordExist].PerDiem,
              JanRent: this.getActualAmountFromInp(JanRentAmount),
              FebRent: this.getActualAmountFromInp(FebRentAmount),
              MarRent: this.getActualAmountFromInp(MarRentAmount),
              AprRent: this.getActualAmountFromInp(AprRentAmount),
              MayRent: this.getActualAmountFromInp(MayRentAmount),
              JunRent: this.getActualAmountFromInp(JunRentAmount),
              JulRent: this.getActualAmountFromInp(JulRentAmount),
              AugRent: this.getActualAmountFromInp(AugRentAmount),
              SepRent: this.getActualAmountFromInp(SepRentAmount),
              OctRent: this.getActualAmountFromInp(OctRentAmount),
              NovRent: this.getActualAmountFromInp(NovRentAmount),
              DecRent: this.getActualAmountFromInp(DecRentAmount),
            }

            const res = await this.rentalService.getBoothRentalCombinedWeeklyCharges(this.marketId,obj).toPromise();
            if (res) {
              this.selectedWeeklyBooths[recordExist].MktDays = marketDays;
              this.selectedWeeklyBooths[recordExist].RentalEndDate = rentalDates[rentalDates.length - 1].startDate;
              this.selectedWeeklyBooths[recordExist].RentEndPeriod = item.RentEndPeriod;
              this.selectedWeeklyBooths[recordExist].January = this.customCurrency.transform(res.JanRent);
              this.selectedWeeklyBooths[recordExist].February = this.customCurrency.transform(res.FebRent);
              this.selectedWeeklyBooths[recordExist].March = this.customCurrency.transform(res.MarRent);
              this.selectedWeeklyBooths[recordExist].April = this.customCurrency.transform(res.AprRent);
              this.selectedWeeklyBooths[recordExist].May = this.customCurrency.transform(res.MayRent);
              this.selectedWeeklyBooths[recordExist].June = this.customCurrency.transform(res.JunRent);
              this.selectedWeeklyBooths[recordExist].July = this.customCurrency.transform(res.JulRent);
              this.selectedWeeklyBooths[recordExist].August = this.customCurrency.transform(res.AugRent);
              this.selectedWeeklyBooths[recordExist].September = this.customCurrency.transform(res.SepRent);
              this.selectedWeeklyBooths[recordExist].October = this.customCurrency.transform(res.OctRent);
              this.selectedWeeklyBooths[recordExist].November = this.customCurrency.transform(res.NovRent);
              this.selectedWeeklyBooths[recordExist].December = this.customCurrency.transform(res.DecRent);
              this.selectedWeeklyBooths[recordExist].Rent = this.customCurrency.transform(res.Rent);
              this.selectedWeeklyBooths[recordExist].SalesTax = this.customCurrency.transform(res.SalesTax);
              this.selectedWeeklyBooths[recordExist].CityTax = this.customCurrency.transform(res.CityTax);
              this.selectedWeeklyBooths[recordExist].JanuaryMonthPresent = res.JanuaryMonthPresent;
              this.selectedWeeklyBooths[recordExist].FebruaryMonthPresent = res.FebruaryMonthPresent;
              this.selectedWeeklyBooths[recordExist].MarchMonthPresent = res.MarchMonthPresent;
              this.selectedWeeklyBooths[recordExist].AprilMonthPresent = res.AprilMonthPresent;
              this.selectedWeeklyBooths[recordExist].MayMonthPresent = res.MayMonthPresent;
              this.selectedWeeklyBooths[recordExist].JuneMonthPresent = res.JuneMonthPresent;
              this.selectedWeeklyBooths[recordExist].JulyMonthPresent = res.JulyMonthPresent;
              this.selectedWeeklyBooths[recordExist].AugustMonthPresent = res.AugustMonthPresent;
              this.selectedWeeklyBooths[recordExist].SeptemberMonthPresent = res.SeptemberMonthPresent;
              this.selectedWeeklyBooths[recordExist].OctoberMonthPresent = res.OctoberMonthPresent;
              this.selectedWeeklyBooths[recordExist].NovemberMonthPresent = res.NovemberMonthPresent;
              this.selectedWeeklyBooths[recordExist].DecemberMonthPresent = res.DecemberMonthPresent;
              this.selectedWeeklyBooths[recordExist].DisableJanMonth = res.JanRent || res.JanRent == 0 ? false : true;
              this.selectedWeeklyBooths[recordExist].DisableFebMonth = res.FebRent || res.FebRent == 0 ? false : true;
              this.selectedWeeklyBooths[recordExist].DisableMarMonth = res.MarRent || res.MarRent == 0 ? false : true;
              this.selectedWeeklyBooths[recordExist].DisableAprMonth = res.AprRent || res.AprRent == 0 ? false : true;
              this.selectedWeeklyBooths[recordExist].DisableMayMonth = res.MayRent || res.MayRent == 0 ? false : true;
              this.selectedWeeklyBooths[recordExist].DisableJunMonth = res.JunRent || res.JunRent == 0 ? false : true;
              this.selectedWeeklyBooths[recordExist].DisableJulMonth = res.JulRent || res.JulRent == 0 ? false : true;
              this.selectedWeeklyBooths[recordExist].DisableAugMonth = res.AugRent || res.AugRent == 0 ? false : true;
              this.selectedWeeklyBooths[recordExist].DisableSepMonth = res.SepRent || res.SepRent == 0 ? false : true;
              this.selectedWeeklyBooths[recordExist].DisableOctMonth = res.OctRent || res.OctRent == 0 ? false : true;
              this.selectedWeeklyBooths[recordExist].DisableNovMonth = res.NovRent || res.NovRent == 0 ? false : true;
              this.selectedWeeklyBooths[recordExist].DisableDecMonth = res.DecRent || res.DecRent == 0 ? false : true;
              this.selectedWeeklyBooths[recordExist].StartDateList = currentMonthRentalDates;
              this.selectedWeeklyBooths[recordExist].ExtendRental = true;

              this.updateTotalCharges(res.Rent, res.SalesTax, res.CityTax);
              //        this.getDiscounts();
            }
          }
          else {
            nonAvailableBooths.push(this.selectedWeeklyBooths[recordExist].BoothNumber);
            this.selectedWeeklyBooths[recordExist].CWRenewalWeek = item.RentEndPeriod;
            this.selectedWeeklyBooths[recordExist].RenewalStartWeek = "This booking cannot be extended further!"
            this.selectedWeeklyBooths[recordExist].BookingCanExtend = false;
            this.selectedWeeklyBooths[recordExist].Rent = this.customCurrency.transform("0");
            this.selectedWeeklyBooths[recordExist].BlockRenewal = true;
          }
        }
      }
      else{
        var recordExist = this.selectedWeeklyBooths.findIndex(e => e.RentStartPeriod == item.RentStartPeriod && e.RentEndPeriod == item.RentEndPeriod
          && e.BoothNumber == item.BoothNumber && e.WeeklyRentalId == item.WeeklyRentalId);
        item.CWRenewalWeek = item.RentEndPeriod;
        item.RenewalStartWeek = "This booking cannot be extended further!"
        item.BookingCanExtend = false;
        this.selectedWeeklyBooths[recordExist].BlockRenewal = true;
        //if (!this.allowCWRentalRenewal) {
        if (recordExist != -1) {
          this.selectedWeeklyBooths[recordExist].Rent = this.customCurrency.transform("0")
        }
        // }
      }
    }

    if (nonAvailableBooths.length > 0) {
      const nonAvailableBoothsString = nonAvailableBooths.join(', ');
      Swal.fire({
        title: $localize`Warning`,
        text: $localize`Cannot be renewed further as the booth number ` + nonAvailableBoothsString + ` is not available`,
        icon: "info",
        confirmButtonText: $localize`Ok`,
      });
    }
  }

  updateCMOtherItemRecord(record, CMRenewalMonth = ""){
    if (record.Recurring) {
      var rentEndPeriodIndex = 0;
      if (record.Status != "R") {
        rentEndPeriodIndex = this.monthlyMarketDays.findIndex(e => e.RentalMonths == record.RentalMonth);
      }
      var renewalStartMonth = this.monthlyMarketDays[rentEndPeriodIndex + 1].RentalMonths;
      record.BookingCanExtend = true;
      record.Quantity = 1;
      record.RentalMonth = record.CurrentRentalMonth;
      if (record.Status == "R") {
        renewalStartMonth = this.monthlyMarketDays[rentEndPeriodIndex].RentalMonths;
        record.RentalMonth = this.monthlyMarketDays[rentEndPeriodIndex].RentalMonths;
      }
      record.RenewalStartMonth = renewalStartMonth;
      record.CMRenewalMonth = renewalStartMonth;
      record.RentEndPeriodIndex = rentEndPeriodIndex
      if (CMRenewalMonth != "") {
        record.CMRenewalMonth = CMRenewalMonth;
      }
      this.extendCMOtherRental(record);
    }
    else {
      if (this.preventVendorUncheckOtherItemRenewal) {
        record.Recurring = true;
        return;
      }
      record.BookingCanExtend = false;
      record.RenewalStartWeek = "This booking cannot be extended further!";
      record.CMRenewalMonth = record.RentalMonth;
      this.totalOtherRentalCharge -= this.getActualAmountFromInp(record.OtherItemtotal);
      this.totalSalesTax -= this.getActualAmountFromInp(record.SalesTax);
      this.totalSecondLeveltax -= this.getActualAmountFromInp(record.CityTax);
      this.setRentalCharges();
      record.OtherItemtotal = this.customCurrency.transform("0");
      record.Quantity = 0;
      record.OtherItemCharge = this.customCurrency.transform("0");
    }
  }


  updateCWOtherItemRecord(record){
    if (record.Recurring) {
      var rentEndPeriodIndex = 0;
      if (record.Status != "R") {
        rentEndPeriodIndex = this.weeklyMarketDays.findIndex(e => e.RentalEndDays == record.CurrentRentalWeek);
      }
      var renewalStartWeek = this.weeklyMarketDays[rentEndPeriodIndex + 1].RentalEndDays;
      record.RentalWeek =  record.CurrentRentalWeek;
      if (record.Status == "R") {
        record.RentalWeek = this.weeklyMarketDays[rentEndPeriodIndex].RentalEndDays;
        renewalStartWeek = this.weeklyMarketDays[rentEndPeriodIndex].RentalEndDays;
      }
      record.BookingCanExtend = true;
      record.Quantity = 1;
      record.RenewalStartWeek = renewalStartWeek
      record.CWRenewalWeek = renewalStartWeek;
      record.RentEndPeriodIndex = rentEndPeriodIndex
      this.extendCWOtherRental(record);
    }
    else {
      if (this.preventVendorUncheckOtherItemRenewal) {
        record.Recurring = true;
        return;
      }
      record.BookingCanExtend = false;
      record.RenewalStartWeek = "This booking cannot be extended further!";
      record.CWRenewalWeek = record.CurrentRentalWeek;
      this.totalOtherRentalCharge -= this.getActualAmountFromInp(record.OtherItemtotal);
      this.totalSalesTax -= this.getActualAmountFromInp(record.SalesTax);
      this.totalSecondLeveltax -= this.getActualAmountFromInp(record.CityTax);
      this.totalCharge = this.priorBalance + this.totalRentalCharge + this.totalOtherRentalCharge + this.totalSalesTax + this.totalSecondLeveltax;
      this.bookingDetailsForm.patchValue({
        otherCharge: this.customCurrency.transform(this.totalOtherRentalCharge.toString()),
        totalSalesTax: this.customCurrency.transform(this.totalSalesTax.toString()),
        totalSecondLeveltax: this.customCurrency.transform(this.totalSecondLeveltax.toString()),
        totalCharge: this.customCurrency.transform(this.totalCharge.toString())
      });
      record.OtherItemtotal = this.customCurrency.transform("0");
      record.Quantity = 0;
      record.OtherItemCharge = this.customCurrency.transform("0");
    }
  }

  updateCWRentalRecord(record) {
    if (record.Reservation && this.allowCWRentalRenewal && !record.BlockRenewal) {
      const rentEndPeriodIndex = this.weeklyMarketDays.findIndex(e => e.RentalEndDays == record.CurrentRentEndPeriod);
      const renewalStartWeek = this.weeklyMarketDays[rentEndPeriodIndex + 1].RentalEndDays;
      record.BookingCanExtend = true;
      record.RenewalStartWeek = renewalStartWeek
      record.CWRenewalWeek = renewalStartWeek;
      record.RentEndPeriodIndex = rentEndPeriodIndex
      this.extendCWRental(record);
    }
    else {
      record.BookingCanExtend = false;
      record.RenewalStartWeek = "This booking cannot be extended further!";
      record.CWRenewalWeek = record.CurrentRentEndPeriod;
      this.totalRentalCharge -= this.getActualAmountFromInp(record.Rent);
      this.totalSalesTax -= this.getActualAmountFromInp(record.SalesTax);
      this.totalSecondLeveltax -= this.getActualAmountFromInp(record.CityTax);
      this.totalCharge = this.priorBalance + this.totalRentalCharge + this.totalOtherRentalCharge + this.totalSalesTax + this.totalSecondLeveltax;
      this.bookingDetailsForm.patchValue({
        rentalCharge: this.customCurrency.transform(this.totalRentalCharge.toString()),
        totalSalesTax: this.customCurrency.transform(this.totalSalesTax.toString()),
        totalSecondLeveltax: this.customCurrency.transform(this.totalSecondLeveltax.toString()),
        totalCharge: this.customCurrency.transform(this.totalCharge.toString())
      });
      record.Rent = this.customCurrency.transform("0");
    }
  }

  renewCWOtherCharges() {
    if (this.selectedOtherItems.length > 0) {
      this.proceedRenewingCWOtherCharges();
    }
  }

  getActualAmountFromInp(value: any): number {
    if (value == null) return 0;

    try {
      const valStr = value.toString();
      if (valStr.includes('(') && valStr.includes(')')) {
        return -1 * parseFloat(valStr.replace(/[^0-9.-]/g, ''));
      } else {
        return parseFloat(valStr.replace(/[^0-9.-]/g, ''));
      }
    } catch (err) {
      console.warn('Error in getActualAmountFromInp:', value, err);
      return 0;
    }
  }

  disableSavePayment() {
    var proceedPayment = false;
    this.paymentAdjustedWithPriorBal = false;
    const rentalCharge = this.getActualAmountFromInp(this.bookingDetailsForm.get('rentalCharge').value)
    const otherCharge = this.getActualAmountFromInp(this.bookingDetailsForm.get('otherCharge').value)
    const salesTax = this.getActualAmountFromInp(this.bookingDetailsForm.get('totalSalesTax').value)
    const secondTax = this.getActualAmountFromInp(this.bookingDetailsForm.get('totalSecondLeveltax').value)
    const additionalCharge = this.getActualAmountFromInp(this.bookingDetailsForm.get('additionalCharge').value)
    const priorBalance = this.getActualAmountFromInp(this.bookingDetailsForm.get('priorBalance').value)
    var totalCharges = rentalCharge + otherCharge + salesTax + secondTax + additionalCharge;
    if(priorBalance < 0 && totalCharges > 0 && (totalCharges + priorBalance <= 0)){
      proceedPayment = true;
      this.paymentAdjustedWithPriorBal = true;
    }

    const paymentAmount = this.getActualAmountFromInp(this.bookingDetailsForm.get('totalPayment').value);
    if (paymentAmount > 0 || proceedPayment) {
      return false
    }
    else
      return true
  }

  addDays(date: Date, days: number): Date {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  proceedRenewingCWOtherCharges(){
    for(const item of this.selectedOtherItems){
      if (new Date(item.RentalWeek.split('-')[0]) <= new Date(item.CWRenewalWeek.split('-')[0])
        && item.Recurring && this.allowOtherItemRenewal) {
        var nextDate = this.addDays(new Date(item.RentalWeek.split('-')[0]), 7);
        var rentalWeekDate = this.weeklyMarketDays.filter(date => new Date(date.RentalEndDays.split('-')[0]) <= new Date(nextDate)
          && new Date(date.RentalEndDays.split('-')[1]) >= new Date(nextDate))
        if (rentalWeekDate.length > 0)
          var rentalStartWeek = rentalWeekDate[0].RentalStartDays;

        var recordExist = this.selectedOtherItems.findIndex(e => e.RentalWeek == item.RentalWeek && e.Id == item.Id && e.Reference == item.Reference && e.BoothNo == item.BoothNo)
        var otherItemCharge;
        if (this.otherItemList.length > 0) {
          otherItemCharge = this.otherItemList.filter(e => e.Id == item.Id)[0].OtherItemCharge;
          if (!this.masterRentChargeforResOtherItems && this.allrentedOtherItems.length > 0) {
            otherItemCharge = this.customCurrency.transform(this.allrentedOtherItems.filter(e => e.OtherItemId == item.Id)[0].OtherCharge);
          }
        } else {
          otherItemCharge = this.customCurrency.transform(this.allrentedOtherItems.filter(e => e.OtherItemId == item.Id)[0].OtherCharge);
        }
        if (item.Status != "R") {
          var obj = {
            MarketId: this.marketId,
            OtherItemId: item.Id,
            VendorId: this.vendorId,
            Quantity: item.Quantity,
            OtherItemCharge: this.getActualAmountFromInp(otherItemCharge)
          }
          this.rentalService.getOtherItemsRentalCharges(obj).subscribe((res: any) => {
            if (recordExist != -1) {
              const isNegative = otherItemCharge.includes('(') && otherItemCharge.includes(')');
              const totalValue = parseFloat(otherItemCharge.replace(/[^0-9.-]/g, ''));
              const finalCharge = isNegative ? -totalValue : totalValue;
              item.OtherItemtotal = this.customCurrency.transform((finalCharge * item.Quantity).toString());

              this.selectedOtherItems[recordExist].OtherItemCharge = otherItemCharge;
              this.selectedOtherItems[recordExist].Quantity = item.Quantity;
              this.selectedOtherItems[recordExist].OtherItemtotal = item.OtherItemtotal;
              this.selectedOtherItems[recordExist].RentalWeek = rentalStartWeek;
              this.selectedOtherItems[recordExist].SalesTax = this.customCurrency.transform(res.SalesTax.toString());
              this.selectedOtherItems[recordExist].CityTax = this.customCurrency.transform(res.CityTax.toString());
              this.selectedOtherItems[recordExist].BoothNo = item.othChgBooths ?? "none";
              this.selectedOtherItems[recordExist].Recurring = item.Recurring;
              this.selectedOtherItems[recordExist].WeeklyOtherRentalIds = "";
            }
            this.totalOtherRentalCharge += this.getActualAmountFromInp(item.OtherItemtotal);
            this.totalSalesTax += this.getActualAmountFromInp(res.SalesTax);
            this.totalSecondLeveltax += this.getActualAmountFromInp(res.CityTax);
            this.totalCharge = this.priorBalance + this.totalRentalCharge + this.totalOtherRentalCharge + this.totalSalesTax + this.totalSecondLeveltax;
            this.bookingDetailsForm.patchValue({
              otherCharge: this.customCurrency.transform(this.totalOtherRentalCharge.toString()),
              totalSalesTax: this.customCurrency.transform(this.totalSalesTax.toString()),
              totalSecondLeveltax: this.customCurrency.transform(this.totalSecondLeveltax.toString()),
              totalCharge: this.customCurrency.transform(this.totalCharge.toString())
            });
          });
        }
      }
      else{
        var recordExist = this.selectedOtherItems.findIndex(e => e.MonthOtherRentalId == item.MonthOtherRentalId)
        item.BookingCanExtend = false;
        item.RenewalStartWeek = "This booking cannot be extended further!";
        item.CWRenewalWeek =""
        if (!this.allowOtherItemRenewal) {
          if (recordExist != -1) {
            this.selectedOtherItems[recordExist].OtherItemCharge = this.customCurrency.transform("0")
            this.selectedOtherItems[recordExist].OtherItemtotal = this.customCurrency.transform("0")
          }
        }
      }
    }
  }

  closeResaleModal(){
    // this.refreshAddBooth();
    const modal = this.modalResaleNo.nativeElement;
    if (modal.classList.contains('show')) {
      modal.style.display = 'none';
      modal.classList.remove('show');
    }
  }

  resaleOptionValidation() {
    this.exemptResaleReason = "";
    this.resaleNo = "";
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((subscription) => {
      if (subscription) {
        subscription.unsubscribe();
      }
    });
  }
}
